/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState, useCallback, useRef, useEffect, useMemo } from "react";
import {
	Button,
	TextField,
	IconButton,
	Paper,
	Box,
	Tooltip,
	Menu,
	ListItemIcon,
	ListItemText,
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
} from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import DeleteIcon from "@material-ui/icons/Delete";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import RadioButtonUncheckedIcon from "@material-ui/icons/RadioButtonUnchecked";
import TitleIcon from "@material-ui/icons/Title";
import ImageIcon from "@material-ui/icons/Image";
import VideoLibraryIcon from "@material-ui/icons/VideoLibrary";
import LiveHelpIcon from "@material-ui/icons/LiveHelp";
import LayersIcon from "@material-ui/icons/Layers";
import CropSquareIcon from "@material-ui/icons/CropSquare";
import PanoramaFishEyeIcon from "@material-ui/icons/PanoramaFishEye";
import ChangeHistoryIcon from "@material-ui/icons/ChangeHistory";
import RemoveIcon from "@material-ui/icons/Remove";
import FormatBoldIcon from "@material-ui/icons/FormatBold";
import FormatItalicIcon from "@material-ui/icons/FormatItalic";
import FormatListBulletedIcon from "@material-ui/icons/FormatListBulleted";
import FormatUnderlinedIcon from "@material-ui/icons/FormatUnderlined";
import FormatAlignLeftIcon from "@material-ui/icons/FormatAlignLeft";
import FormatAlignCenterIcon from "@material-ui/icons/FormatAlignCenter";
import FormatAlignRightIcon from "@material-ui/icons/FormatAlignRight";
import FormatAlignJustifyIcon from "@material-ui/icons/FormatAlignJustify";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import AssignmentIcon from "@material-ui/icons/Assignment";
import FormatPaintIcon from "@material-ui/icons/FormatPaint";
import FlipToFrontIcon from "@material-ui/icons/FlipToFront";
import FlipToBackIcon from "@material-ui/icons/FlipToBack";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import UndoIcon from "@material-ui/icons/Undo";
import RedoIcon from "@material-ui/icons/Redo";
import ControlPointDuplicateIcon from "@material-ui/icons/ControlPointDuplicate";
import ViewModuleIcon from "@material-ui/icons/ViewModule";
import CategoryIcon from "@material-ui/icons/Category";
import TouchAppIcon from "@material-ui/icons/TouchApp";
import FlashOnIcon from "@material-ui/icons/FlashOn";
import ElementEntryAnimationPanel from "./ElementEntryAnimationPanel";
import PermMediaIcon from "@material-ui/icons/PermMedia";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import EditIcon from "@material-ui/icons/Edit";
import PaletteIcon from "@material-ui/icons/Palette";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import PlayArrowIcon from "@material-ui/icons/PlayArrow";
import PauseIcon from "@material-ui/icons/Pause";
import CloseIcon from "@material-ui/icons/Close";
import LocationOnIcon from "@material-ui/icons/LocationOn";
import AspectRatioIcon from "@material-ui/icons/AspectRatio";
import SettingsIcon from "@material-ui/icons/Settings";
import TextFieldsIcon from "@material-ui/icons/TextFields";
import SwapHorizIcon from "@material-ui/icons/SwapHoriz";
import SwapVertIcon from "@material-ui/icons/SwapVert";
import RotateRightIcon from "@material-ui/icons/RotateRight";
import DragIndicatorIcon from "@material-ui/icons/DragIndicator";
import CheckIcon from "@material-ui/icons/Check";
import ClearIcon from "@material-ui/icons/Clear";
import EmojiObjectsIcon from "@material-ui/icons/EmojiObjects";
import CameraAltOutlinedIcon from "@material-ui/icons/CameraAltOutlined";
import StarBorderIcon from "@material-ui/icons/StarBorder";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import LockOpenOutlinedIcon from "@material-ui/icons/LockOpenOutlined";
import SearchIcon from "@material-ui/icons/Search";
import HomeOutlinedIcon from "@material-ui/icons/HomeOutlined";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import SendIcon from "@material-ui/icons/Send";
import RefreshIcon from "@material-ui/icons/Refresh";
import FavoriteBorderIcon from "@material-ui/icons/FavoriteBorder";
import BookmarkBorderIcon from "@material-ui/icons/BookmarkBorder";
import ShareIcon from "@material-ui/icons/Share";
import LinkIcon from "@material-ui/icons/Link";
import OpenInNewIcon from "@material-ui/icons/OpenInNew";
import VisibilityOutlinedIcon from "@material-ui/icons/VisibilityOutlined";
import DoneAllIcon from "@material-ui/icons/DoneAll";
import Filter1OutlinedIcon from "@material-ui/icons/Filter1Outlined";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import SettingsOutlinedIcon from "@material-ui/icons/SettingsOutlined";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import GetAppIcon from "@material-ui/icons/GetApp";
import MailOutlineIcon from "@material-ui/icons/MailOutline";
import PhoneIcon from "@material-ui/icons/Phone";
import ThumbUpOutlinedIcon from "@material-ui/icons/ThumbUpOutlined";
import FlagIcon from "@material-ui/icons/Flag";
import EmojiEventsIcon from "@material-ui/icons/EmojiEvents";
import NotificationsNoneIcon from "@material-ui/icons/NotificationsNone";
import ScheduleIcon from "@material-ui/icons/Schedule";
import PeopleOutlineIcon from "@material-ui/icons/PeopleOutline";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import InputIcon from "@material-ui/icons/Input";
import MenuIcon from "@material-ui/icons/Menu";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import WarningIcon from "@material-ui/icons/Warning";
import OpacityIcon from "@material-ui/icons/Opacity";
import LoopIcon from "@material-ui/icons/Loop";
import FavoriteIcon from "@material-ui/icons/Favorite";
import LockIcon from "@material-ui/icons/Lock";
import VerticalAlignCenterIcon from "@material-ui/icons/VerticalAlignCenter";
import { Select, MenuItem, FormControl, InputLabel, Slider, FormControlLabel, Switch } from "@material-ui/core";
import { ToggleButton, ToggleButtonGroup } from "@material-ui/lab";
import { SERVER_URL } from "../../../../utils";
import { alertError } from "../../../../utils/logger";
import { getPlantillas } from "../../../../api/plantilla";
import { getEscapeRoomById } from "../../../../api/escape-room";
import { getQuizzes, getQuizById, createQuiz, updateQuiz } from "../../../../api/quiz";
import { getUserMedia, uploadUserMedia } from "../../../../api/files";
import InlineQuizEditor from "./InlineQuizEditor";
import RgbaColorPickerPopover from "./RgbaColorPickerPopover";
import { BUTTON_ICON_LIBRARY, BUTTON_ICON_MAP } from "./buttonIconLibrary";
import HexColorPickerPopover from "./HexColorPickerPopover";
import ShapeColorPicker from "./ShapeColorPicker";
import PageTransitionPicker from "./PageTransitionPicker";
import {
	CANVAS_WIDTH,
	CANVAS_HEIGHT,
	TRANSITION_SPEEDS,
	DEFAULT_GAME_TIME_SECONDS,
	VIEWPORTS,
	MODAL_SIZES,
	DESKTOP,
	REGISTRATION_PAGE_ID,
	REGISTRATION_SCENARIO_ID,
	isRegistrationScenario,
	PRIMARY_RED,
	normalizePageTransitionId,
} from "./escapeRoomEditorConstants";
import { insertIndexForScenarioBlock, getElementsForViewport } from "./escapeRoomEditorViewportUtils";
import {
	ensureRegistrationScenario,
	getDefaultPlayableScenarioId,
	getPlayableScenarios,
	getScenarioBlockKey,
	isPageInScenario,
	isRegistrationPage as isErRegistrationPage,
} from "./escapeRoomScenarioUtils";
import { genId, genMatchId, defaultElement } from "./escapeRoomElementFactory";
import { pickElementDesktopRootPatch, normalizePagesForPersist } from "./escapeRoomElementPersist";
import { getDefaultRegistrationPage } from "./defaultRegistrationPage";

import { playSuppressBranchAlternates } from "./escapeRoomPlayGraph";
import { ELEMENT_LAYER_TYPE_LABELS, getElementLayerSubtitle } from "./escapeRoomEditorLayerUtils";
import { SCORE_TEXT_TOKEN, SCORE_TEXT_ROLE } from "./escapeRoomScoreText";
import { buildQuizDuplicatePayload } from "./escapeRoomEditorDuplicateQuiz";
import {
	parseRgba,
	toRgba,
	getQuizBlockBackground,
	normalizeColorToRgba,
	getQuizBlockBorderCss,
	getQuizBlockBorderColorForPicker,
	getQuizBlockBorderWidth,
	getQuizBlockShadowBlur,
	getQuizBlockBoxShadow,
	QUIZ_OPTION_DESIGNS,
	getQuizTrueFalseColorsEditor,
	getQuizOptionStyles,
	parseColorToRgb,
	getDefaultHoverColor,
} from "./escapeRoomEditorQuizVisual";
import {
	SHAPE_TYPES,
	BUTTON_TEMPLATES,
	PLANTILLA_TEMAS,
	ADD_PAGE_BLANCO_THEME_ID,
	ADD_PAGE_DIALOG_TEMAS,
	BLANK_PAGE_ADD_TEMPLATE,
	buildPageWithBackgroundAddTemplate,
	getPlantillaThemeSwatchStyle,
	getPlantillaThemeRingColor,
	AZUL_ESCAPE_ROOM_ID,
	CASO_MEDICO_ESCAPE_ROOM_ID,
	HINT_TEMPLATES,
	FONT_OPTIONS,
	ADD_FONT_OPTION,
} from "./escapeRoomEditorUiConstants";
import {
	HANDLE_SIZE,
	MIN_SIZE,
	RESIZE_EDGE_STRIP_PX,
	parseGoogleFontsFamilies,
	importGoogleFontFamily,
	buildFontFamilyStack,
	importGoogleFontInput,
	mergeCustomFontEntries,
	getFontPickerOptions,
	collectFontStylesheetUrls,
	injectEscapeRoomFontLinks,
	isFontStylesheetUrl,
	resizeHandleStyle,
	hitTestResizeEdge,
	applyLockedAspectResize,
	resolveQuizImageUrl,
	REUSABLE_QUIZ_ID,
	shuffleArray,
} from "./escapeRoomEditorCanvasInteraction";
import {
	isImageCornerResizeHandle,
	resolveImageElementPlacementSize,
	resolveImageElementSizeKeepingWidth,
} from "./escapeRoomImagePlacement";
import { ElementRenderer } from "./escapeRoomElementRenderer";
import { quizTextAnswersMatch, resolveCustomQuizDone, accumulateCustomQuizPoints } from "./escapeRoomMatchFillEditorQuiz";
import { QuizPreviewThumbnail, DraftIntTextField, TextFloatingToolbar, QuizOptionsFloatingToolbar } from "./escapeRoomEditorFloatingWidgets";
import { PagePreviewThumbnail, THUMB_WIDTH, THUMB_HEIGHT } from "./escapeRoomPagePreviewThumbnail";
import { pageHasQuizOrPoints, normalizePages, resolvePlayQuizId, collectUniqueQuizIdsFromElements, collectUniqueQuizIdsFromPages } from "./escapeRoomPageNormalize";
import { ensureTextEffectStylesInjected, pickEffectBundle, mergeEffectBundlePatch } from "./textEffectStyles";
import TextEffectPicker from "./TextEffectPicker";
import ButtonElementStylePanel from "./ButtonElementStylePanel";
import TextElementStylePanel from "./TextElementStylePanel";
import { ShapeElementContentPanel, ShapeElementStylePanel } from "./ShapeElementPanels";
import ErEditAccordion from "./ErEditAccordion";
import { erElIdEq, erSelectedIdsInclude } from "./escapeRoomEditorElementIds";
import { PlayModeView } from "./escapeRoomPlayModeView";
import GoogleFontsSearchPicker from "./GoogleFontsSearchPicker";
import { resolveEscapeRoomMediaUrl, normalizeEscapeRoomMediaPath } from "./escapeRoomMediaUrl";
import { EscapeRoomPlayHudZoneOverlay } from "./escapeRoomPlayHudZone";

export default function EscapeRoomEditor({
	escapeRoom,
	onSave,
	onDelete,
	saving,
}) {
	const [pagesRaw, setPagesRaw] = useState(() => normalizePages(escapeRoom.pages));
	const [nameRaw, setNameRaw] = useState(escapeRoom.name || "");
	const [customFontsRaw, setCustomFontsRaw] = useState(() =>
		Array.isArray(escapeRoom.customFonts)
			? escapeRoom.customFonts.map((f) => String(f || "").trim()).filter(Boolean)
			: []
	);
	const [fontManagerOpen, setFontManagerOpen] = useState(false);
	const [fontManagerTarget, setFontManagerTarget] = useState(null); // text | quizOptions | button
	const [fontImportInputRaw, setFontImportInputRaw] = useState("");
	const [fontImportError, setFontImportError] = useState("");
	const [fontLinkImportOpen, setFontLinkImportOpen] = useState(false);
	const [gameTimeSecondsRaw, setGameTimeSecondsRaw] = useState(() => {
		const n = Number(escapeRoom?.gameTimeSeconds);
		return Number.isFinite(n) ? Math.max(1, Math.round(n)) : DEFAULT_GAME_TIME_SECONDS;
	});
	const [sessionMaxConcurrentPlayersRaw, setSessionMaxConcurrentPlayersRaw] = useState(() => {
		const n = Number(escapeRoom?.sessionMaxConcurrentPlayers);
		return Number.isFinite(n) && n >= 0 ? Math.round(n) : 0;
	});
	const [sessionMaxTablesRaw, setSessionMaxTablesRaw] = useState(() => {
		const n = Number(escapeRoom?.sessionMaxTables);
		return Number.isFinite(n) && n >= 0 ? Math.round(n) : 0;
	});
	const [scenariosRaw, setScenariosRaw] = useState(() => {
		const initialPages = normalizePages(escapeRoom.pages);
		const initialScenarios =
			Array.isArray(escapeRoom.scenarios) && escapeRoom.scenarios.length > 0
				? escapeRoom.scenarios.map((s, i) => ({ id: s.id || `scenario-${i}`, name: s.name || `Escenario ${i + 1}`, icon: s.icon || "flag", order: s.order ?? i }))
				: [{ id: genId(), name: "Escenario 1", icon: "flag", order: 0 }];
		return ensureRegistrationScenario(initialScenarios, initialPages);
	});
	const [currentPageIndex, setCurrentPageIndex] = useState(0);
	// Asegurar que todas las páginas no-registro tengan un scenarioId (escenario por defecto)
	useEffect(() => {
		if (scenariosRaw.length === 0) return;
		const defaultScId = getDefaultPlayableScenarioId(scenariosRaw);
		if (!defaultScId) return;
		const needsFix = pages.some((p) => !isErRegistrationPage(p) && !(p.scenarioId || "").trim());
		if (!needsFix) return;
		setPages((prev) => prev.map((p) => (isErRegistrationPage(p) ? p : { ...p, scenarioId: (p.scenarioId || "").trim() || defaultScId })));
	}, [scenariosRaw.length, scenariosRaw, pages]);
	const [scenarioMenuAnchor, setScenarioMenuAnchor] = useState(null);
	const [scenarioMenuIdx, setScenarioMenuIdx] = useState(null);
	const [editingScenarioId, setEditingScenarioId] = useState(null);
	const scenarioNameInputRef = useRef(null);
	const scenarioNameBlurTimerRef = useRef(null);
	const [selectedElement, setSelectedElement] = useState(null);
	const [selectedElementIds, setSelectedElementIds] = useState([]);
	const skipOpenEditarOnSelectRef = useRef(false);
	const undoStackRef = useRef([]);
	const redoStackRef = useRef([]);
	const isUndoRedoRef = useRef(false);
	const pages = pagesRaw;
	const name = nameRaw;
	const customFonts = customFontsRaw;
	const gameTimeSeconds = gameTimeSecondsRaw;
	const allFontOptions = useMemo(
		() => Array.from(new Set([...FONT_OPTIONS, ...getFontPickerOptions(customFonts)])),
		[customFonts]
	);
	const importedFontOptions = useMemo(
		() => getFontPickerOptions(customFonts).filter((f) => !FONT_OPTIONS.includes(f)),
		[customFonts]
	);
	const fontLabel = (f) => f.split(",")[0].replace(/['"]/g, "");
	const applyFontToTarget = (fontFamily) => {
		if (!selectedElement || !fontFamily) return;
		if (fontManagerTarget === "quizOptions") {
			effectiveUpdateElement({
				...selectedElement,
				content: {
					...selectedElement.content,
					quizOptionsStyle: { ...selectedElement.content?.quizOptionsStyle, fontFamily },
				},
			});
			return;
		}
		effectiveUpdateElement({
			...selectedElement,
			style: { ...selectedElement.style, fontFamily },
		});
	};

	useEffect(() => {
		const urls = collectFontStylesheetUrls(customFonts);
		return injectEscapeRoomFontLinks(urls);
	}, [customFonts]);

	useEffect(() => {
		ensureTextEffectStylesInjected();
	}, []);

	const handleImportGoogleFont = useCallback(() => {
		const result = importGoogleFontInput(fontImportInputRaw);
		if (result.families.length === 0 && result.stylesheetUrls.length === 0) {
			setFontImportError("Pega un enlace válido de Google Fonts (https://fonts.googleapis.com/...).");
			return;
		}
		setFontImportError("");
		setCustomFontsRaw((prev) => mergeCustomFontEntries(prev, result));
		setFontImportInputRaw("");
	}, [fontImportInputRaw]);

	const isGoogleFontAlreadyAdded = useCallback(
		(familyName, category) => {
			const stack = buildFontFamilyStack(familyName, category);
			return stack ? allFontOptions.includes(stack) : false;
		},
		[allFontOptions]
	);

	const handleUseGoogleFontFromSearch = useCallback(
		(familyName, category) => {
			const result = importGoogleFontFamily(familyName, category);
			if (!result.families?.length) return;
			setCustomFontsRaw((prev) => mergeCustomFontEntries(prev, result));
			applyFontToTarget(result.families[0]);
		},
		// applyFontToTarget depende del elemento seleccionado
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[selectedElement, fontManagerTarget]
	);
	const pushHistory = useCallback(() => {
		if (isUndoRedoRef.current) return;
		undoStackRef.current.push({ name: nameRaw, pages: JSON.parse(JSON.stringify(pagesRaw)) });
		if (undoStackRef.current.length > 50) undoStackRef.current.shift();
		redoStackRef.current = [];
	}, [nameRaw, pagesRaw]);
	const setPages = useCallback((updater) => {
		pushHistory();
		setPagesRaw(updater);
	}, [pushHistory]);
	const setName = useCallback((value) => {
		pushHistory();
		setNameRaw(typeof value === "function" ? value(nameRaw) : value);
	}, [pushHistory, nameRaw]);
	const performUndo = useCallback(() => {
		if (undoStackRef.current.length === 0) return;
		const prev = undoStackRef.current.pop();
		redoStackRef.current.push({ name: nameRaw, pages: JSON.parse(JSON.stringify(pagesRaw)) });
		isUndoRedoRef.current = true;
		setNameRaw(prev.name);
		setPagesRaw(prev.pages);
		setCurrentPageIndex((i) => Math.min(i, Math.max(0, prev.pages.length - 1)));
		setSelectedElement(null);
		requestAnimationFrame(() => { isUndoRedoRef.current = false; });
	}, [nameRaw, pagesRaw]);
	const performRedo = useCallback(() => {
		if (redoStackRef.current.length === 0) return;
		const next = redoStackRef.current.pop();
		undoStackRef.current.push({ name: nameRaw, pages: JSON.parse(JSON.stringify(pagesRaw)) });
		isUndoRedoRef.current = true;
		setNameRaw(next.name);
		setPagesRaw(next.pages);
		setCurrentPageIndex((i) => Math.min(i, Math.max(0, next.pages.length - 1)));
		setSelectedElement(null);
		requestAnimationFrame(() => { isUndoRedoRef.current = false; });
	}, [nameRaw, pagesRaw]);
	const canUndo = undoStackRef.current.length > 0;
	const canRedo = redoStackRef.current.length > 0;
	const [addPanelCategory, setAddPanelCategory] = useState("elementos");
	const [editarSubSection, setEditarSubSection] = useState("posicion");
	const [elementosSubSection, setElementosSubSection] = useState(null);
	const [contextMenu, setContextMenu] = useState(null);
	const [activeViewport, setActiveViewport] = useState("desktop");
	const [pageMenuAnchor, setPageMenuAnchor] = useState(null);
	const [pageMenuPosition, setPageMenuPosition] = useState(null);
	const [pageMenuIdx, setPageMenuIdx] = useState(null);
	const [draggingPageIdx, setDraggingPageIdx] = useState(null);
	const [hoverPanelElementId, setHoverPanelElementId] = useState(null);
	const [canvasZoom, setCanvasZoom] = useState(1);
	const [canvasPan, setCanvasPan] = useState({ x: 0, y: 0 });
	const [middleMousePanning, setMiddleMousePanning] = useState(null);
	const [plantillas, setPlantillas] = useState([]);
	const [plantillasLoading, setPlantillasLoading] = useState(false);
	const [azulPlantillas, setAzulPlantillas] = useState([]);
	const [azulPlantillasLoading, setAzulPlantillasLoading] = useState(false);
	const [casoMedicoPlantillas, setCasoMedicoPlantillas] = useState([]);
	const [casoMedicoPlantillasLoading, setCasoMedicoPlantillasLoading] = useState(false);
	const [quizzes, setQuizzes] = useState([]);
	const [quizzesLoading, setQuizzesLoading] = useState(false);
	const [userMedia, setUserMedia] = useState([]);
	const [userMediaLoading, setUserMediaLoading] = useState(false);
	const [backgroundPickerOpen, setBackgroundPickerOpen] = useState(false);
	const [registrationBackgroundPickerOpen, setRegistrationBackgroundPickerOpen] = useState(false);
	const [iconPickerOpen, setIconPickerOpen] = useState(false);
	const [iconPickerSearch, setIconPickerSearch] = useState("");
	useEffect(() => {
		if (iconPickerOpen && (!selectedElement || selectedElement?.type !== "button")) setIconPickerOpen(false);
	}, [iconPickerOpen, selectedElement]);
	const [logoPickerOpen, setLogoPickerOpen] = useState(false);
	const [scenarioIconPickerIdx, setScenarioIconPickerIdx] = useState(null); // index in scenariosRaw when picking icon for a scenario
	const [scenarioIconPickerSearch, setScenarioIconPickerSearch] = useState("");
	const [mediaPickerOpen, setMediaPickerOpen] = useState(false);
	const [mediaPickerMode, setMediaPickerMode] = useState(null);
	const [playMode, setPlayMode] = useState(false);
	const [playHintModal, setPlayHintModal] = useState(null);
	const [playQuizAnswers, setPlayQuizAnswers] = useState({});
	/** Por página: ids de botones ya pulsados en vista previa (onlyOnce / allButtonsActivated) */
	const [playActivatedByPage, setPlayActivatedByPage] = useState({});
	const [playPageIndex, setPlayPageIndex] = useState(0);
	const [playTotalPoints, setPlayTotalPoints] = useState(0);
	const [playFooterOpen, setPlayFooterOpen] = useState(false);
	const [playSuppressedScenarioIds, setPlaySuppressedScenarioIds] = useState(() => new Set());
	const playLandingAwardedRef = useRef(new Set());
	const [playTransitionKey, setPlayTransitionKey] = useState(0);
	const [playTransitionType, setPlayTransitionType] = useState("none");
	const [playTransitionDuration, setPlayTransitionDuration] = useState(350);
	const [playViewport, setPlayViewport] = useState("desktop");
	const [playScale, setPlayScale] = useState(1);
	const [playModalContent, setPlayModalContent] = useState(null);
	const [playQuizFeedbackModal, setPlayQuizFeedbackModal] = useState(null);
	const [playShowResults, setPlayShowResults] = useState(false);
	const [editingModalButton, setEditingModalButton] = useState(null);
	const [editingHintModal, setEditingHintModal] = useState(null); // { elementId, modalType: "confirm"|"hint" }
	const [editingTextElementId, setEditingTextElementId] = useState(null);
	const [editingButtonLabelElementId, setEditingButtonLabelElementId] = useState(null);
	const [pointsOnLandDraft, setPointsOnLandDraft] = useState(null);
	const [addPageTemplateDialogOpen, setAddPageTemplateDialogOpen] = useState(false);
	const [addPageDialogTheme, setAddPageDialogTheme] = useState(ADD_PAGE_BLANCO_THEME_ID);
	const [plantillaTheme, setPlantillaTheme] = useState("blanco-rojo");
	useEffect(() => {
		if (selectedElement?.elementId !== editingTextElementId) setEditingTextElementId(null);
	}, [selectedElement?.elementId]);
	useEffect(() => {
		if (selectedElement?.elementId !== editingButtonLabelElementId) setEditingButtonLabelElementId(null);
	}, [selectedElement?.elementId]);
	useEffect(() => { setPointsOnLandDraft(null); }, [currentPageIndex]);
	const [modalCanvasZoom, setModalCanvasZoom] = useState(1);
	const [modalCanvasPan, setModalCanvasPan] = useState({ x: 0, y: 0 });
	const playModeContainerRef = useRef(null);
	const fileInputRef = useRef(null);
	const backgroundFileInputRef = useRef(null);
	const registrationBackgroundFileInputRef = useRef(null);
	const logoFileInputRef = useRef(null);
	const mediaElementFileInputRef = useRef(null);
	const imageElementPickerFileInputRef = useRef(null);
	const videoElementPickerFileInputRef = useRef(null);
	const [imageElementPickerOpen, setImageElementPickerOpen] = useState(false);
	const [buttonImagePickerTarget, setButtonImagePickerTarget] = useState(null);
	const [videoElementPickerOpen, setVideoElementPickerOpen] = useState(false);
	const canvasViewportRef = useRef(null);
	const canvasDropRef = useRef(null);
	/** Tras un marquee: ignorar selección/deselección hasta el siguiente `click` (documento), para no pisar la multiselección con mousedown+click del mismo gesto. */
	const suppressMarqueeFollowupRef = useRef(false);
	/** Copia síncrona de `selectedElementIds` para arrastre grupal justo después del marquee (antes del re-render). */
	const selectedElementIdsRef = useRef([]);
	/** Lista actual de elementos del lienzo (evita cierre obsoleto en mouseup del marquee). */
	const effectiveElementsRef = useRef([]);
	const isFirstRender = useRef(true);
	const autoSaveTimeoutRef = useRef(null);
	const onSaveRef = useRef(onSave);
	onSaveRef.current = onSave;

	useEffect(() => {
		if (isFirstRender.current) {
			isFirstRender.current = false;
			return;
		}
		if (autoSaveTimeoutRef.current) clearTimeout(autoSaveTimeoutRef.current);
		autoSaveTimeoutRef.current = setTimeout(() => {
			autoSaveTimeoutRef.current = null;
			onSaveRef.current(
				{
					name: name.trim(),
					pages: normalizePagesForPersist(pages),
					scenarios: scenariosRaw,
					customFonts,
					gameTimeSeconds,
					sessionMaxConcurrentPlayers: sessionMaxConcurrentPlayersRaw,
					sessionMaxTables: sessionMaxTablesRaw,
				},
				{ silent: true }
			);
		}, 1500);
		return () => {
			if (autoSaveTimeoutRef.current) clearTimeout(autoSaveTimeoutRef.current);
		};
	}, [name, pages, scenariosRaw, customFonts, gameTimeSeconds, sessionMaxConcurrentPlayersRaw, sessionMaxTablesRaw]);

	useEffect(() => {
		if ((addPanelCategory === "plantillas" || addPageTemplateDialogOpen) && plantillas.length === 0) {
			setPlantillasLoading(true);
			getPlantillas()
				.then((res) => setPlantillas(res.data || []))
				.catch(() => setPlantillas([]))
				.finally(() => setPlantillasLoading(false));
		}
	}, [addPanelCategory, addPageTemplateDialogOpen, plantillas.length]);
	useEffect(() => {
		if (addPanelCategory === "plantillas" && (plantillas.length > 0 || plantillaTheme === "azul") && quizzes.length === 0) loadQuizzes();
	}, [addPanelCategory, plantillas.length, plantillaTheme, quizzes.length, loadQuizzes]);

	/** En modo juego: sumar (o restar si son negativos) puntos por aterrizar en la página actual (una sola vez por página). */
	useEffect(() => {
		if (!playMode || !pages.length || playPageIndex < 0 || playPageIndex >= pages.length) return;
		if (playLandingAwardedRef.current.has(playPageIndex)) return;
		const pts = Number(pages[playPageIndex]?.pointsOnLand ?? 0);
		if (!Number.isFinite(pts) || pts === 0) return;
		playLandingAwardedRef.current.add(playPageIndex);
		setPlayTotalPoints((prev) => (prev || 0) + pts);
	}, [playMode, playPageIndex, pages]);

	useEffect(() => {
		if (addPageTemplateDialogOpen) setAddPageDialogTheme(ADD_PAGE_BLANCO_THEME_ID);
	}, [addPageTemplateDialogOpen]);

	const effectivePlantillaTheme = addPageTemplateDialogOpen ? addPageDialogTheme : plantillaTheme;

	const addPageDialogErPages = useMemo(() => {
		const pid = (p) => (p.pageId || p._id);
		return pages
			.filter((p) => pid(p) !== REGISTRATION_PAGE_ID)
			.map((p, i) => ({
				key: pid(p) || `page-${i}`,
				name: p.name || `Página ${i + 1}`,
				page: p,
			}));
	}, [pages]);

	/** Cargar plantillas tema azul: escape room AZUL, páginas con order 1–4 (referencian quiz e imágenes). */
	useEffect(() => {
		if (effectivePlantillaTheme !== "azul") return;
		if (addPanelCategory !== "plantillas" && !addPageTemplateDialogOpen) return;
		setAzulPlantillasLoading(true);
		getEscapeRoomById(AZUL_ESCAPE_ROOM_ID)
			.then((res) => {
				const pages = res.data?.pages || [];
				const pages1to4 = pages.filter((p) => (p.order ?? 0) >= 1 && (p.order ?? 0) <= 4).sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
				const plantillasFromAzul = pages1to4.map((p) => ({
					name: (p.name || "") + " (azul)",
					design: {
						backgroundColor: p.backgroundColor ?? "#001927",
						backgroundImageUrl: p.backgroundImageUrl ?? "",
						backgroundImageOpacity: p.backgroundImageOpacity ?? 40,
						elements: p.elements || [],
					},
				}));
				setAzulPlantillas(plantillasFromAzul);
			})
			.catch(() => setAzulPlantillas([]))
			.finally(() => setAzulPlantillasLoading(false));
	}, [effectivePlantillaTheme, addPanelCategory, addPageTemplateDialogOpen, plantillas]);
	/** Cargar plantillas tema Caso Médico desde ID fijo (todas las páginas salvo registro). */
	useEffect(() => {
		if (effectivePlantillaTheme !== "caso-medico") return;
		if (addPanelCategory !== "plantillas" && !addPageTemplateDialogOpen) return;
		setCasoMedicoPlantillasLoading(true);
		getEscapeRoomById(CASO_MEDICO_ESCAPE_ROOM_ID)
			.then((res) => {
				const pages = (res.data?.pages || [])
					.filter((p) => (p.pageId || p._id) !== REGISTRATION_PAGE_ID)
					.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
				const mapped = pages.map((p) => ({
					name: (p.name || "") + " (caso médico)",
					design: {
						backgroundColor: p.backgroundColor ?? "#0f4c5c",
						backgroundImageUrl: p.backgroundImageUrl ?? "",
						backgroundImageOpacity: p.backgroundImageOpacity ?? 40,
						elements: p.elements || [],
					},
				}));
				setCasoMedicoPlantillas(mapped);
			})
			.catch(() => setCasoMedicoPlantillas([]))
			.finally(() => setCasoMedicoPlantillasLoading(false));
	}, [effectivePlantillaTheme, addPanelCategory, addPageTemplateDialogOpen, plantillas]);

	const loadQuizzes = useCallback(() => {
		setQuizzesLoading(true);
		getQuizzes()
			.then((res) => setQuizzes(Array.isArray(res.data) ? res.data : []))
			.catch(() => {
				// No vaciar: un fallo de red dejaría los quizzes del modal como "sin asignar"
			})
			.finally(() => setQuizzesLoading(false));
	}, []);
	const quizFetchAttemptedRef = useRef(new Set());
	useEffect(() => {
		if (addPanelCategory === "quizzes" || addPanelCategory === "paginas") loadQuizzes();
	}, [addPanelCategory, loadQuizzes]);
	useEffect(() => {
		if (selectedElement?.type === "quiz" && quizzes.length === 0) loadQuizzes();
	}, [selectedElement?.type, quizzes.length, loadQuizzes]);
	useEffect(() => {
		const neededIds = collectUniqueQuizIdsFromPages(pages);
		if (!neededIds.length) return undefined;
		const have = new Set((quizzes || []).map((q) => String(q?._id || "")));
		const missing = neededIds.filter((id) => {
			const sid = String(id);
			if (have.has(sid)) return false;
			if (quizFetchAttemptedRef.current.has(sid)) return false;
			return true;
		});
		if (!missing.length) return undefined;
		if (quizzes.length === 0) loadQuizzes();
		missing.forEach((id) => quizFetchAttemptedRef.current.add(String(id)));
		let cancelled = false;
		Promise.all(
			missing.map((id) =>
				getQuizById(id)
					.then((res) => res?.data)
					.catch(() => null)
			)
		).then((fetched) => {
			if (cancelled) return;
			const add = fetched.filter(Boolean);
			if (!add.length) return;
			setQuizzes((prev) => {
				const seen = new Set((prev || []).map((q) => String(q?._id || "")));
				const next = [...(prev || [])];
				for (const q of add) {
					const id = String(q?._id || "");
					if (!id || seen.has(id)) continue;
					seen.add(id);
					next.push(q);
				}
				return next;
			});
		});
		return () => {
			cancelled = true;
		};
	}, [pages, quizzes, loadQuizzes]);

	const loadUserMedia = useCallback(() => {
		setUserMediaLoading(true);
		getUserMedia(escapeRoom?._id)
			.then((res) => setUserMedia(res.data?.items || []))
			.catch(() => setUserMedia([]))
			.finally(() => setUserMediaLoading(false));
	}, [escapeRoom?._id]);

	useEffect(() => {
		if (addPanelCategory === "elementos" || addPanelCategory === "multimedia" || backgroundPickerOpen || registrationBackgroundPickerOpen || logoPickerOpen || mediaPickerOpen || imageElementPickerOpen || videoElementPickerOpen || selectedElement?.type === "quiz" || selectedElement?.type === "video") {
			loadUserMedia();
		}
	}, [addPanelCategory, backgroundPickerOpen, registrationBackgroundPickerOpen, logoPickerOpen, mediaPickerOpen, imageElementPickerOpen, videoElementPickerOpen, selectedElement?.type, loadUserMedia]);

	// Deselección solo dentro del área del canvas (fondo vacío o margen gris alrededor del lienzo),
	// no en toda la pantalla: el panel derecho y demás UI deben poder usarse sin perder la selección.

	const handleUploadUserMedia = useCallback((e) => {
		const file = e?.target?.files?.[0];
		if (!file) return;
		const isImg = /\.(jpe?g|png|gif|webp|svg)$/i.test(file.name);
		const isVid = /\.(mp4|webm|ogg|mov)$/i.test(file.name);
		if (!isImg && !isVid) {
			alertError({ customMessage: "Solo se permiten imágenes (jpg, png, gif, webp, svg) o videos (mp4, webm, ogg, mov)." });
			return;
		}
		uploadUserMedia(file, escapeRoom?._id)
			.then((res) => {
				if (res?.data?.fileURL) {
					setUserMedia((prev) => [{ path: res.data.fileURL, name: file.name, isVideo: isVid }, ...prev]);
					return res.data.fileURL;
				}
			})
			.catch((err) => {
				alertError({ error: err, customMessage: "Error al subir el archivo." });
			});
	}, []);

	const ADD_CATEGORIES = [
		{ id: "editar", label: "Editar", shortLabel: "Editar", Icon: EditIcon },
		{ id: "elementos", label: "Elementos", shortLabel: "Elementos", Icon: CategoryIcon },
		{ id: "multimedia", label: "Multimedia", shortLabel: "Media", Icon: PermMediaIcon },
		{ id: "texto", label: "Texto", shortLabel: "Texto", Icon: TitleIcon },
		{ id: "quizzes", label: "Preguntas", shortLabel: "Preg.", Icon: LiveHelpIcon },
		{ id: "paginas", label: "Páginas", shortLabel: "Pág.", Icon: LayersIcon },
		{ id: "ajustes", label: "Ajustes", shortLabel: "Ajustes", Icon: SettingsIcon },
	];
	/** Subsecciones del panel Editar cuando hay un elemento seleccionado (Ubicación y Tamaño al final) */
	const EDITAR_SUB_CATEGORIES = [
		{ id: "contenido", label: "Contenido", shortLabel: "Contenido", Icon: FormatListBulletedIcon },
		{ id: "estilo", label: "Estilo", shortLabel: "Estilo", Icon: PaletteIcon },
		{ id: "comportamiento", label: "Comportamiento", shortLabel: "Comport.", Icon: TouchAppIcon },
		{ id: "posicion", label: "Posición", shortLabel: "Posición", Icon: LocationOnIcon },
		{ id: "tamano", label: "Tamaño", shortLabel: "Tamaño", Icon: AspectRatioIcon },
	];
	const ANIMACION_SUB = { id: "animacion", label: "Animación", shortLabel: "Anim.", Icon: FlashOnIcon };
	const withAnimacionSub = (list) => {
		const i = list.findIndex((c) => c.id === "posicion");
		if (i < 0) return [...list, ANIMACION_SUB];
		return [...list.slice(0, i), ANIMACION_SUB, ...list.slice(i)];
	};
	const editarSubCategoriesFiltered = (() => {
		// Video: solo 3 apartados — Video, Ubicación, Tamaño
		if (selectedElement?.type === "video") {
			return withAnimacionSub([
				{ id: "contenido", label: "Video", shortLabel: "Video", Icon: VideoLibraryIcon },
				{ id: "posicion", label: "Ubicación", shortLabel: "Ubicación", Icon: LocationOnIcon },
				{ id: "tamano", label: "Tamaño", shortLabel: "Tamaño", Icon: AspectRatioIcon },
			]);
		}
		// Texto: solo 3 apartados — Texto, Ubicación, Tamaño
		if (selectedElement?.type === "text") {
			return withAnimacionSub([
				{ id: "estilo", label: "Texto", shortLabel: "Texto", Icon: TitleIcon },
				{ id: "posicion", label: "Ubicación", shortLabel: "Ubicación", Icon: LocationOnIcon },
				{ id: "tamano", label: "Tamaño", shortLabel: "Tamaño", Icon: AspectRatioIcon },
			]);
		}
		// Botón: solo 3 apartados — Botón, Ubicación, Tamaño
		if (selectedElement?.type === "button") {
			return withAnimacionSub([
				{ id: "contenido", label: "Botón", shortLabel: "Botón", Icon: TouchAppIcon },
				{ id: "posicion", label: "Ubicación", shortLabel: "Ubicación", Icon: LocationOnIcon },
				{ id: "tamano", label: "Tamaño", shortLabel: "Tamaño", Icon: AspectRatioIcon },
			]);
		}
		// Quiz (Pregunta): solo 3 apartados — Pregunta, Ubicación, Tamaño
		if (selectedElement?.type === "quiz") {
			return withAnimacionSub([
				{ id: "contenido", label: "Pregunta", shortLabel: "Pregunta", Icon: LiveHelpIcon },
				{ id: "posicion", label: "Ubicación", shortLabel: "Ubicación", Icon: LocationOnIcon },
				{ id: "tamano", label: "Tamaño", shortLabel: "Tamaño", Icon: AspectRatioIcon },
			]);
		}
		let list = EDITAR_SUB_CATEGORIES.filter((c) => c.id !== "comportamiento");
		// Ocultar Contenido cuando el tipo no tiene opciones en esa sección (ej. texto se edita en el lienzo)
		if (selectedElement?.type === "text") {
			list = list.filter((c) => c.id !== "contenido");
		}
		return withAnimacionSub(list);
	})();
	/** Estilo para separar visualmente cada apartado en el panel Editar (scroll) */
	const EDITAR_SECTION_SEP = { marginTop: 28, paddingTop: 24, borderTop: "1px solid #cbd5e1", borderRadius: 0 };
	const REGISTRATION_CATEGORIES = [
		{ id: "editar", label: "Editar", shortLabel: "Editar", Icon: EditIcon },
		{ id: "configuracion", label: "Configuración", shortLabel: "Config", Icon: SettingsIcon },
		{ id: "diseño", label: "Diseño de registro", shortLabel: "Diseño", Icon: PaletteIcon },
	];

	const currentPage = pages[currentPageIndex] || pages[0];

	const addPageBackgroundRef = useMemo(() => {
		const pid = (p) => (p.pageId || p._id);
		const playable = pages.filter((p) => pid(p) !== REGISTRATION_PAGE_ID);
		const cur = currentPage && pid(currentPage) !== REGISTRATION_PAGE_ID ? currentPage : null;
		return cur || playable.find((p) => p.backgroundImageUrl) || playable[0] || null;
	}, [pages, currentPage]);

	const pageWithBackgroundAddTemplate = useMemo(
		() => buildPageWithBackgroundAddTemplate(addPageBackgroundRef),
		[addPageBackgroundRef]
	);

	const elements = getElementsForViewport(currentPage, activeViewport);
	const viewportDim = VIEWPORTS.find((v) => v.id === activeViewport) || VIEWPORTS[0];
	const isRegistrationPage = (currentPage?.pageId || currentPage?._id) === REGISTRATION_PAGE_ID;

	useEffect(() => {
		if (selectedElement) {
			if (skipOpenEditarOnSelectRef.current) {
				skipOpenEditarOnSelectRef.current = false;
				return;
			}
			setAddPanelCategory("editar");
			setEditarSubSection("contenido");
		}
	}, [selectedElement?.elementId]);
	// Si la subsección actual no está en la lista (ej. Video/Texto solo tienen 3), pasar a la primera disponible
	useEffect(() => {
		if (!selectedElement || addPanelCategory !== "editar") return;
		let filtered;
		if (selectedElement?.type === "video") {
			filtered = [{ id: "contenido" }, { id: "posicion" }, { id: "tamano" }];
		} else if (selectedElement?.type === "text") {
			filtered = [{ id: "estilo" }, { id: "posicion" }, { id: "tamano" }];
		} else if (selectedElement?.type === "button") {
			filtered = [{ id: "contenido" }, { id: "posicion" }, { id: "tamano" }];
		} else if (selectedElement?.type === "quiz") {
			filtered = [{ id: "contenido" }, { id: "posicion" }, { id: "tamano" }];
		} else {
			const list = EDITAR_SUB_CATEGORIES.filter((c) => c.id !== "comportamiento");
			filtered = list;
		}
		if (filtered.length && !filtered.some((c) => c.id === editarSubSection)) {
			setEditarSubSection(filtered[0].id);
		}
	}, [selectedElement?.type, editarSubSection, addPanelCategory]);
	useEffect(() => {
		if (addPanelCategory !== "elementos") setElementosSubSection(null);
	}, [addPanelCategory]);

	useEffect(() => {
		if (isRegistrationPage && !selectedElement) {
			setAddPanelCategory("diseño");
		}
	}, [isRegistrationPage, currentPageIndex, selectedElement]);
	useEffect(() => {
		setHoverPanelElementId(null);
	}, [currentPageIndex, isModalEditMode]);

	useEffect(() => {
		if (!editingScenarioId) return;
		const t = window.setTimeout(() => {
			const el = scenarioNameInputRef.current;
			if (el && typeof el.focus === "function") {
				el.focus();
				if (typeof el.select === "function") el.select();
			}
		}, 50);
		return () => window.clearTimeout(t);
	}, [editingScenarioId]);

	/** Agrupa páginas por escenario en orden de aparición (incluye escenario Registro). */
	const getPagesGroupedByScenario = useCallback(() => {
		const sortedScenarios = (scenariosRaw || []).slice().sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
		const groups = [];
		let currentGroup = null;
		let currentKey = null;
		for (let i = 0; i < pages.length; i++) {
			const p = pages[i];
			const key = getScenarioBlockKey(p);
			const scenario = sortedScenarios.find((s) =>
				isRegistrationScenario(s) ? key === REGISTRATION_SCENARIO_ID : String(s.id) === key
			);
			if (currentKey !== key) {
				currentKey = key;
				currentGroup = { scenario, pageIndices: [] };
				groups.push(currentGroup);
			}
			currentGroup.pageIndices.push(i);
		}
		const usedScenarioIds = new Set();
		pages.forEach((p) => {
			const key = getScenarioBlockKey(p);
			if (key) usedScenarioIds.add(key);
		});
		const emptyScenarios = sortedScenarios.filter((sc) => {
			const id = isRegistrationScenario(sc) ? REGISTRATION_SCENARIO_ID : String(sc.id);
			return !usedScenarioIds.has(id);
		});
		const ord = (sc) => sc?.order ?? 0;
		emptyScenarios.forEach((sc) => {
			const o = ord(sc);
			let insertPos = groups.length;
			for (let i = 0; i < groups.length; i++) {
				const g = groups[i];
				if (!g.scenario) continue;
				if (ord(g.scenario) > o || (ord(g.scenario) === o && String(g.scenario.id) > String(sc.id))) {
					insertPos = i;
					break;
				}
			}
			groups.splice(insertPos, 0, { scenario: sc, pageIndices: [] });
		});
		return groups;
	}, [pages, scenariosRaw]);

	const addPage = useCallback((scenarioId) => {
		if (isRegistrationScenario({ id: scenarioId })) return;
		const targetScId = scenarioId || getDefaultPlayableScenarioId(scenariosRaw) || "";
		const newPage = {
			pageId: genId(),
			order: pages.length,
			name: `Página ${pages.length + 1}`,
			scenarioId: targetScId,
			showFooter: false,
			timerRuns: true,
			elements: [],
			transitionToNext: "none",
			transitionDuration: 350,
		};
		setPages((p) => {
			const lastIdxOfScenario = p.reduce((last, page, i) => (isPageInScenario(page, targetScId) ? i : last), -1);
			const insertAt = lastIdxOfScenario < 0 ? insertIndexForScenarioBlock(p, targetScId, scenariosRaw) : lastIdxOfScenario + 1;
			const next = [...p];
			next.splice(insertAt, 0, newPage);
			return next.map((page, i) => ({ ...page, order: i }));
		});
		setCurrentPageIndex(() => {
			const lastIdxOfScenario = pages.reduce((last, page, i) => (isPageInScenario(page, targetScId) ? i : last), -1);
			if (lastIdxOfScenario < 0) return insertIndexForScenarioBlock(pages, targetScId, scenariosRaw);
			return lastIdxOfScenario + 1;
		});
		setSelectedElement(null);
	}, [pages, scenariosRaw]);

	const addScenario = useCallback(() => {
		const playable = getPlayableScenarios(scenariosRaw);
		const maxOrder = (scenariosRaw || []).reduce((m, s) => Math.max(m, Number(s.order ?? 0)), -1);
		const newSc = { id: genId(), name: `Escenario ${playable.length + 1}`, icon: "flag", order: maxOrder + 1 };
		setScenariosRaw((prev) => [...prev, newSc]);
	}, [scenariosRaw]);

	const reorderScenarios = useCallback((fromSortedIdx, toSortedIdx) => {
		if (fromSortedIdx === toSortedIdx) return;
		const sorted = [...(scenariosRaw || [])].sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
		if (fromSortedIdx < 0 || fromSortedIdx >= sorted.length || toSortedIdx < 0 || toSortedIdx >= sorted.length) return;
		const [removed] = sorted.splice(fromSortedIdx, 1);
		sorted.splice(toSortedIdx, 0, removed);
		const reordered = sorted.map((s, i) => ({ ...s, order: i }));
		const orderIds = reordered.map((s) => (isRegistrationScenario(s) ? REGISTRATION_SCENARIO_ID : String(s.id)));
		const byScenario = {};
		reordered.forEach((s) => {
			const key = isRegistrationScenario(s) ? REGISTRATION_SCENARIO_ID : String(s.id);
			byScenario[key] = [];
		});
		const otherPages = [];
		pages.forEach((p) => {
			const key = getScenarioBlockKey(p);
			if (Object.prototype.hasOwnProperty.call(byScenario, key)) byScenario[key].push(p);
			else otherPages.push(p);
		});
		const nextPages = [...orderIds.flatMap((id) => byScenario[id] || []), ...otherPages];
		const regIdx = nextPages.findIndex((p) => isErRegistrationPage(p));
		if (regIdx >= 0) {
			for (let i = 0; i < regIdx; i++) {
				if (pageHasQuizOrPoints(nextPages[i])) {
					alertError({
						customMessage:
							"No puede haber ninguna página con quiz o que sume/reste puntos antes de la página de registro.",
					});
					return;
				}
			}
		}
		setScenariosRaw(reordered);
		setPages(nextPages.map((pg, i) => ({ ...pg, order: i })));
		setScenarioMenuAnchor(null);
		setScenarioMenuIdx(null);
	}, [scenariosRaw, pages]);

	const movePageToScenario = useCallback((pageIdx, targetScenarioId) => {
		const page = pages[pageIdx];
		if (!page || isErRegistrationPage(page) || isRegistrationScenario({ id: targetScenarioId })) return;
		const pid = (p) => (p.pageId || p._id);
		const prevCurrent = currentPageIndex;
		setPages((p) => {
			const without = p.filter((_, i) => i !== pageIdx);
			const lastIdxInTarget = without.reduce((last, pg, i) => (isPageInScenario(pg, targetScenarioId) ? i : last), -1);
			const insertAt = lastIdxInTarget >= 0 ? lastIdxInTarget + 1 : insertIndexForScenarioBlock(without, targetScenarioId, scenariosRaw);
			const updated = { ...page, scenarioId: targetScenarioId };
			const next = [...without.slice(0, insertAt), updated, ...without.slice(insertAt)];
			return next.map((pg, i) => ({ ...pg, order: i }));
		});
		if (prevCurrent === pageIdx) {
			const without = pages.filter((_, i) => i !== pageIdx);
			const lastIdxInTarget = without.reduce((last, pg, i) => (isPageInScenario(pg, targetScenarioId) ? i : last), -1);
			setCurrentPageIndex(lastIdxInTarget >= 0 ? lastIdxInTarget + 1 : insertIndexForScenarioBlock(without, targetScenarioId, scenariosRaw));
		} else if (prevCurrent > pageIdx) {
			setCurrentPageIndex((i) => i - 1);
		}
		setPageMenuAnchor(null);
		setPageMenuIdx(null);
		setSelectedElement(null);
	}, [pages, currentPageIndex]);

	const addPageFromTemplate = useCallback((plantilla) => {
		const design = plantilla?.design || {};
		const targetScId =
			(currentPage && !isErRegistrationPage(currentPage) ? currentPage.scenarioId : null) ||
			getDefaultPlayableScenarioId(scenariosRaw) ||
			"";
		const templateElements = (design.elements || []).map((e) => ({
			...JSON.parse(JSON.stringify(e)),
			elementId: genId(),
		}));
		const newPage = {
			pageId: genId(),
			order: pages.length,
			name: `Página ${pages.length + 1}`,
			scenarioId: targetScId,
			showFooter: false,
			timerRuns: design.timerRuns !== false,
			backgroundColor: design.backgroundColor ?? "#fff",
			backgroundImageUrl: design.backgroundImageUrl ?? "",
			backgroundImageOpacity: design.backgroundImageOpacity ?? 100,
			elements: templateElements,
			transitionToNext: "none",
			transitionDuration: 350,
		};
		setPages((p) => {
			const lastIdx = p.reduce((last, page, i) => (isPageInScenario(page, targetScId) ? i : last), -1);
			const insertAt = lastIdx >= 0 ? lastIdx + 1 : insertIndexForScenarioBlock(p, targetScId, scenariosRaw);
			const next = [...p];
			next.splice(insertAt, 0, newPage);
			return next.map((pg, i) => ({ ...pg, order: i }));
		});
		setCurrentPageIndex((prev) => {
			const lastIdx = pages.reduce((last, page, i) => (isPageInScenario(page, targetScId) ? i : last), -1);
			return lastIdx >= 0 ? lastIdx + 1 : insertIndexForScenarioBlock(pages, targetScId, scenariosRaw);
		});
		setSelectedElement(null);
		setAddPageTemplateDialogOpen(false);
	}, [pages, currentPage, scenariosRaw]);

	const removePage = useCallback((idx) => {
		const page = pages[idx];
		if (!page || (page.pageId || page._id) === REGISTRATION_PAGE_ID) return;
		if (pages.length <= 1) return;
		setPages((p) => p.filter((_, i) => i !== idx));
		setCurrentPageIndex((i) => (i >= idx && i > 0 ? i - 1 : i));
		setSelectedElement(null);
	}, [pages.length]);

	/** Nuevo quiz en BD con el mismo contenido (preguntas independientes al duplicar página/elemento). */
	const cloneQuizById = useCallback(async (rawQuizId) => {
		const quizId = resolvePlayQuizId(rawQuizId);
		if (!quizId) throw new Error("Sin quiz");
		let src = quizzes.find((q) => String(q?._id) === quizId);
		if (!src) {
			const res = await getQuizById(quizId);
			if (!res?.data) throw new Error("Quiz no encontrado");
			src = res.data;
		}
		const res = await createQuiz(buildQuizDuplicatePayload(src));
		const newQ = res.data;
		if (!newQ?._id) throw new Error("Respuesta inválida");
		const newId = String(newQ._id);
		setQuizzes((prev) => (prev.some((q) => String(q?._id) === newId) ? prev : [...prev, newQ]));
		return newId;
	}, [quizzes]);

	const addPageFromSourcePage = useCallback(
		async (sourcePage) => {
			if (!sourcePage || (sourcePage.pageId || sourcePage._id) === REGISTRATION_PAGE_ID) return;
			const els = sourcePage.elements || [];
			const uniqueQuizIds = collectUniqueQuizIdsFromElements(els);
			const idMap = new Map();
			try {
				for (const oid of uniqueQuizIds) {
					const newId = await cloneQuizById(oid);
					idMap.set(oid, newId);
				}
				const templateElements = els.map((e) => {
					const copy = { ...JSON.parse(JSON.stringify(e)), elementId: genId() };
					const srcQuizId = resolvePlayQuizId(e.content?.quizId);
					if (e.type === "quiz" && srcQuizId && idMap.has(srcQuizId)) {
						copy.content = { ...copy.content, quizId: idMap.get(srcQuizId) };
					}
					return copy;
				});
				const targetScId =
					(currentPage && !isErRegistrationPage(currentPage) ? currentPage.scenarioId : null) ||
					getDefaultPlayableScenarioId(scenariosRaw) ||
					"";
				const newPage = {
					...JSON.parse(JSON.stringify(sourcePage)),
					pageId: genId(),
					order: pages.length,
					name: sourcePage.name || `Página ${pages.length + 1}`,
					scenarioId: targetScId,
					elements: templateElements,
					transitionToNext: sourcePage.transitionToNext || "none",
					transitionDuration: sourcePage.transitionDuration ?? 350,
				};
				delete newPage._id;
				setPages((p) => {
					const lastIdx = p.reduce((last, page, i) => (isPageInScenario(page, targetScId) ? i : last), -1);
					const insertAt = lastIdx >= 0 ? lastIdx + 1 : insertIndexForScenarioBlock(p, targetScId, scenariosRaw);
					const next = [...p];
					next.splice(insertAt, 0, newPage);
					return next.map((pg, i) => ({ ...pg, order: i }));
				});
				setCurrentPageIndex(() => {
					const lastIdx = pages.reduce((last, page, i) => (isPageInScenario(page, targetScId) ? i : last), -1);
					return lastIdx >= 0 ? lastIdx + 1 : insertIndexForScenarioBlock(pages, targetScId, scenariosRaw);
				});
				setSelectedElement(null);
				setAddPageTemplateDialogOpen(false);
			} catch (err) {
				alertError({
					error: err,
					customMessage: "No se pudo crear la página (error al copiar una pregunta). Revisa la conexión.",
				});
			}
		},
		[pages, currentPage, scenariosRaw, cloneQuizById]
	);

	const duplicatePage = useCallback(
		async (idx) => {
			const page = pages[idx];
			if (!page || (page.pageId || page._id) === REGISTRATION_PAGE_ID) return;
			const els = page.elements || [];
			const uniqueQuizIds = collectUniqueQuizIdsFromElements(els);
			const idMap = new Map();
			try {
				for (const oid of uniqueQuizIds) {
					const newId = await cloneQuizById(oid);
					idMap.set(oid, newId);
				}
				const newElements = els.map((e) => {
					const copy = { ...JSON.parse(JSON.stringify(e)), elementId: genId() };
					const srcQuizId = resolvePlayQuizId(e.content?.quizId);
					if (e.type === "quiz" && srcQuizId && idMap.has(srcQuizId)) {
						copy.content = { ...copy.content, quizId: idMap.get(srcQuizId) };
					}
					return copy;
				});
				const clone = {
					...page,
					pageId: genId(),
					order: pages.length,
					name: `${page.name || "Página"} (copia)`,
					elements: newElements,
				};
				setPages((p) => {
					const next = [...p];
					next.splice(idx + 1, 0, clone);
					return next.map((p_, i) => ({ ...p_, order: i }));
				});
				setCurrentPageIndex(idx + 1);
				setSelectedElement(null);
			} catch (err) {
				alertError({
					error: err,
					customMessage: "No se pudo duplicar la página (error al copiar una pregunta). Revisa la conexión.",
				});
			}
		},
		[pages, cloneQuizById]
	);

	const reorderPages = useCallback((fromIdx, toIdx) => {
		if (fromIdx === toIdx) return;
		const pid = (p) => (p.pageId || p._id);
		const arr = [...pages];
		const [removed] = arr.splice(fromIdx, 1);
		arr.splice(toIdx, 0, removed);
		const regIdx = arr.findIndex((p) => pid(p) === REGISTRATION_PAGE_ID);
		if (regIdx >= 0) {
			for (let i = 0; i < regIdx; i++) {
				if (pageHasQuizOrPoints(arr[i])) {
					alertError({
						customMessage:
							"No puede haber ninguna página con quiz o que sume/reste puntos antes de la página de registro.",
					});
					return;
				}
			}
		}
		setPages((p) => {
			const next = [...p];
			const [rem] = next.splice(fromIdx, 1);
			next.splice(toIdx, 0, rem);
			return next.map((page, i) => ({ ...page, order: i }));
		});
		setCurrentPageIndex((i) => {
			if (i === fromIdx) return toIdx;
			if (fromIdx < i && toIdx >= i) return i - 1;
			if (fromIdx > i && toIdx <= i) return i + 1;
			return i;
		});
	}, [pages]);

	/** Mueve una página a una nueva posición (y opcionalmente a otro escenario) por drag-and-drop. dropAfterPageIndex = índice de la página después de la cual insertar (-1 = insertar al inicio). */
	const movePageByDrag = useCallback((fromIdx, dropAfterPageIndex, targetScenarioId) => {
		const pid = (p) => (p.pageId || p._id);
		const page = pages[fromIdx];
		if (!page) return;
		const isReg = isErRegistrationPage(page);
		const targetScId = targetScenarioId || (isReg ? REGISTRATION_SCENARIO_ID : page.scenarioId) || getDefaultPlayableScenarioId(scenariosRaw) || "";
		if (isReg && String(targetScId) !== REGISTRATION_SCENARIO_ID) {
			alertError({ customMessage: "La página de registro solo puede estar en el escenario Registro." });
			return;
		}
		if (!isReg && String(targetScId) === REGISTRATION_SCENARIO_ID) {
			alertError({ customMessage: "Solo la página de registro puede estar en el escenario Registro." });
			return;
		}
		const updated = isReg ? page : { ...page, scenarioId: targetScId };
		const without = pages.filter((_, i) => i !== fromIdx);
		let insertAtClamped;
		if (dropAfterPageIndex < 0) {
			insertAtClamped = insertIndexForScenarioBlock(without, targetScId, scenariosRaw);
		} else {
			const insertAt = fromIdx <= dropAfterPageIndex ? dropAfterPageIndex : dropAfterPageIndex + 1;
			insertAtClamped = Math.min(Math.max(0, insertAt), without.length);
		}
		const next = [...without.slice(0, insertAtClamped), updated, ...without.slice(insertAtClamped)].map((p, i) => ({ ...p, order: i }));
		const regIdx = next.findIndex((p) => pid(p) === REGISTRATION_PAGE_ID);
		if (regIdx >= 0) {
			for (let i = 0; i < regIdx; i++) {
				if (pageHasQuizOrPoints(next[i])) {
					alertError({ customMessage: "No puede haber ninguna página con quiz o que sume/reste puntos antes de la página de registro." });
					return;
				}
			}
		}
		setPages(next);
		setCurrentPageIndex((i) => {
			if (i === fromIdx) return insertAtClamped;
			if (fromIdx < insertAtClamped && i >= insertAtClamped) return i - 1;
			if (fromIdx > insertAtClamped && i <= insertAtClamped) return i + 1;
			return i;
		});
		setSelectedElement(null);
	}, [pages, scenariosRaw]);

	const handleSidebarPageDragOver = useCallback((e) => {
		e.preventDefault();
		e.dataTransfer.dropEffect = "move";
	}, []);

	const handleSidebarPageDrop = useCallback((e, dropAfterPageIndex, targetScenarioId) => {
		e.preventDefault();
		let pageIdx = null;
		const raw = e.dataTransfer.getData("application/json");
		if (raw) {
			try {
				const parsed = JSON.parse(raw);
				if (typeof parsed.pageIdx === "number") pageIdx = parsed.pageIdx;
			} catch (_) {}
		}
		if (pageIdx === null) {
			const text = e.dataTransfer.getData("text/plain");
			const m = text && text.match(/^page-(\d+)$/);
			if (m) pageIdx = parseInt(m[1], 10);
		}
		if (typeof pageIdx !== "number") return;
		movePageByDrag(pageIdx, dropAfterPageIndex, targetScenarioId);
	}, [movePageByDrag]);
	const closePageMenu = useCallback(() => {
		setPageMenuAnchor(null);
		setPageMenuPosition(null);
		setPageMenuIdx(null);
	}, []);

	const applyTemplate = useCallback((plantilla) => {
		if (isRegistrationPage) return;
		const design = plantilla?.design || {};
		const templateElements = (design.elements || []).map((e) => ({
			...JSON.parse(JSON.stringify(e)),
			elementId: genId(),
		}));
		setPages((p) => {
			const next = [...p];
			next[currentPageIndex] = {
				...next[currentPageIndex],
				backgroundColor: design.backgroundColor ?? next[currentPageIndex].backgroundColor ?? "#fff",
				backgroundImageUrl: design.backgroundImageUrl ?? next[currentPageIndex].backgroundImageUrl ?? "",
				backgroundImageOpacity: design.backgroundImageOpacity ?? next[currentPageIndex].backgroundImageOpacity ?? 100,
				elements: templateElements,
			};
			return next;
		});
		setSelectedElement(null);
	}, [currentPageIndex, isRegistrationPage]);

	const addElement = useCallback((type, overrides = {}) => {
		const base = defaultElement(type);
		const { content: contentOverrides, style: styleOverrides, ...rest } = overrides;
		const el = {
			...base,
			...rest,
			content: contentOverrides ? { ...(base.content || {}), ...contentOverrides } : base.content,
			style: styleOverrides ? { ...(base.style || {}), ...styleOverrides } : base.style,
		};
		setPages((p) => {
			const next = [...p];
			const page = { ...next[currentPageIndex], elements: [...(next[currentPageIndex].elements || []), el] };
			next[currentPageIndex] = page;
			return next;
		});
		setSelectedElement(el);
		const imageUrl = type === "image" ? overrides?.content?.url : null;
		if (imageUrl) {
			const elementId = el.elementId;
			const cw = Number(escapeRoom?.canvasWidth) || CANVAS_WIDTH;
			const ch = Number(escapeRoom?.canvasHeight) || CANVAS_HEIGHT;
			resolveImageElementPlacementSize(imageUrl, cw, ch).then((size) => {
				if (!size) return;
				setPages((p) => {
					const next = [...p];
					const page = next[currentPageIndex];
					if (!page) return p;
					next[currentPageIndex] = {
						...page,
						elements: (page.elements || []).map((e) =>
							e.elementId === elementId ? { ...e, width: size.width, height: size.height } : e
						),
					};
					return next;
				});
				setSelectedElement((sel) =>
					sel?.elementId === elementId ? { ...sel, width: size.width, height: size.height } : sel
				);
			});
		}
	}, [currentPageIndex, escapeRoom?.canvasWidth, escapeRoom?.canvasHeight]);

	const updateElement = useCallback((updated) => {
		setPages((p) => {
			const pageIdx = p.findIndex((pg) => (pg.elements || []).some((e) => e.elementId === updated.elementId));
			if (pageIdx < 0) return p;
			const next = [...p];
			const page = next[pageIdx];
			const newElements = (page.elements || []).map((e) => {
				if (e.elementId !== updated.elementId) return e;
				if (activeViewport === "desktop") {
					const isPositionChange =
						(updated.x !== undefined && updated.x !== e.x) ||
						(updated.y !== undefined && updated.y !== e.y) ||
						(updated.width !== undefined && updated.width !== e.width) ||
						(updated.height !== undefined && updated.height !== e.height);
					const preservedBreakpoints = { ...(e.breakpoints || {}) };
					if (!isPositionChange) {
						["tablet", "mobile"].forEach((vp) => {
							if (preservedBreakpoints[vp]) {
								const bp = preservedBreakpoints[vp];
								const posOnly = {};
								if (typeof bp.x === "number") posOnly.x = bp.x;
								if (typeof bp.y === "number") posOnly.y = bp.y;
								if (typeof bp.width === "number") posOnly.width = bp.width;
								if (typeof bp.height === "number") posOnly.height = bp.height;
								if (Object.keys(posOnly).length > 0) {
									preservedBreakpoints[vp] = posOnly;
								} else {
									delete preservedBreakpoints[vp];
								}
							}
						});
					}
					const merged = { ...e, ...pickElementDesktopRootPatch(updated) };
					if (updated.x !== undefined) merged.x = updated.x;
					if (updated.y !== undefined) merged.y = updated.y;
					if (updated.width !== undefined) merged.width = updated.width;
					if (updated.height !== undefined) merged.height = updated.height;
					if (updated.content !== undefined) merged.content = updated.content;
					if (updated.style !== undefined) merged.style = updated.style;
					if (Object.keys(preservedBreakpoints).length > 0) merged.breakpoints = preservedBreakpoints;
					return merged;
				}
				const existingBp = e.breakpoints?.[activeViewport] || {};
				const bp = { ...existingBp };
				if (updated.x !== undefined) bp.x = updated.x;
				if (updated.y !== undefined) bp.y = updated.y;
				if (updated.width !== undefined) bp.width = updated.width;
				if (updated.height !== undefined) bp.height = updated.height;
				if (updated.content !== undefined) bp.content = updated.content;
				if (updated.style !== undefined) bp.style = updated.style;
				return {
					...e,
					...pickElementDesktopRootPatch(updated),
					breakpoints: {
						...(e.breakpoints || {}),
						[activeViewport]: bp,
					},
				};
			});
			next[pageIdx] = { ...page, elements: newElements };
			return next;
		});
		setSelectedElement((prev) => {
			if (prev?.elementId !== updated.elementId) return prev;
			const next = { ...prev, ...pickElementDesktopRootPatch(updated) };
			if (updated.x !== undefined) next.x = updated.x;
			if (updated.y !== undefined) next.y = updated.y;
			if (updated.width !== undefined) next.width = updated.width;
			if (updated.height !== undefined) next.height = updated.height;
			if (updated.content !== undefined) next.content = updated.content;
			if (updated.style !== undefined) next.style = updated.style;
			return next;
		});
	}, [activeViewport]);

	const removeElement = useCallback((elementId) => {
		const el = elements.find((e) => e.elementId === elementId);
		if (el?.registrationLocked) return;
		setPages((p) => {
			const next = [...p];
			next[currentPageIndex].elements = (next[currentPageIndex].elements || []).filter((e) => e.elementId !== elementId);
			return next;
		});
		setSelectedElement(null);
	}, [currentPageIndex, elements]);

	// Modal editing (when editingModalButton is set) - must be before handleCanvasDrop
	const findModalButtonPage = useCallback(() => {
		if (!editingModalButton) return -1;
		return pages.findIndex((p) => (p.elements || []).some((e) => e.elementId === editingModalButton.elementId));
	}, [editingModalButton, pages]);

	const findHintModalPage = useCallback(() => {
		if (!editingHintModal) return -1;
		return pages.findIndex((p) => (p.elements || []).some((e) => e.elementId === editingHintModal.elementId));
	}, [editingHintModal, pages]);

	const getHintModalDesign = useCallback(() => {
		const fallback = { backgroundColor: "#ffffff", elements: [], borderRadius: 12 };
		if (!editingHintModal) return fallback;
		const pageIdx = findHintModalPage();
		if (pageIdx < 0) return fallback;
		const page = pages[pageIdx];
		const hintEl = (page?.elements || []).find((e) => e.elementId === editingHintModal.elementId);
		if (!hintEl) return fallback;
		const c = hintEl.content || {};
		const design = editingHintModal.modalType === "confirm" ? c.confirmModalDesign : c.hintModalDesign;
		return {
			backgroundColor: design?.backgroundColor || "#ffffff",
			elements: design?.elements || [],
			borderRadius: design?.borderRadius ?? 12,
		};
	}, [editingHintModal, findHintModalPage, pages]);

	const updateHintModalDesign = useCallback(
		(updates) => {
			if (!editingHintModal) return;
			const pageIdx = findHintModalPage();
			if (pageIdx < 0) return;
			setPages((p) => {
				const next = [...p];
				const page = next[pageIdx];
				const hintEl = (page.elements || []).find((e) => e.elementId === editingHintModal.elementId);
				if (!hintEl) return next;
				const c = hintEl.content || {};
				const key = editingHintModal.modalType === "confirm" ? "confirmModalDesign" : "hintModalDesign";
				const baseDesign = c[key] || { backgroundColor: "#ffffff", elements: [], borderRadius: 12 };
				const newDesign = { ...baseDesign, ...updates };
				const newHint = { ...hintEl, content: { ...c, [key]: newDesign } };
				next[pageIdx] = { ...page, elements: page.elements.map((e) => (e.elementId === hintEl.elementId ? newHint : e)) };
				return next;
			});
			// Mantener selectedElement sincronizado si estamos editando esa misma pista
			setSelectedElement((prev) => {
				if (!prev || prev.elementId !== editingHintModal.elementId) return prev;
				const c = prev.content || {};
				const key = editingHintModal.modalType === "confirm" ? "confirmModalDesign" : "hintModalDesign";
				const baseDesign = c[key] || { backgroundColor: "#ffffff", elements: [], borderRadius: 12 };
				const newDesign = { ...baseDesign, ...updates };
				return { ...prev, content: { ...c, [key]: newDesign } };
			});
		},
		[editingHintModal, findHintModalPage]
	);

	const getModalDesign = useCallback(() => {
		const fallback = { backgroundColor: "#ffffff", elements: [], borderRadius: 12 };
		if (!editingModalButton) return fallback;
		const pageIdx = findModalButtonPage();
		if (pageIdx < 0) {
			const design = editingModalButton.content?.modalDesign;
			return {
				backgroundColor: design?.backgroundColor || "#ffffff",
				elements: design?.elements || [],
				borderRadius: design?.borderRadius ?? 12,
			};
		}
		const page = pages[pageIdx];
		const btn = (page?.elements || []).find((e) => e.elementId === editingModalButton.elementId);
		const design = btn?.content?.modalDesign || editingModalButton.content?.modalDesign;
		return {
			backgroundColor: design?.backgroundColor || "#ffffff",
			elements: design?.elements || [],
			borderRadius: design?.borderRadius ?? 12,
		};
	}, [editingModalButton, findModalButtonPage, pages]);

	const updateModalDesign = useCallback(
		(updates) => {
			const pageIdx = findModalButtonPage();
			if (pageIdx < 0) return;
			setPages((p) => {
				const next = [...p];
				const page = next[pageIdx];
				const btn = (page.elements || []).find((e) => e.elementId === editingModalButton.elementId);
				if (!btn) return next;
				const design = { ...(btn.content?.modalDesign || { backgroundColor: "#ffffff", elements: [], borderRadius: 12 }), ...updates };
				const newBtn = { ...btn, content: { ...btn.content, modalDesign: design } };
				next[pageIdx] = { ...page, elements: page.elements.map((e) => (e.elementId === btn.elementId ? newBtn : e)) };
				return next;
			});
			setEditingModalButton((prev) => {
				if (!prev || prev.elementId !== editingModalButton.elementId) return prev;
				const design = { ...(prev.content?.modalDesign || { backgroundColor: "#ffffff", elements: [], borderRadius: 12 }), ...updates };
				return { ...prev, content: { ...prev.content, modalDesign: design } };
			});
		},
		[editingModalButton, findModalButtonPage]
	);

	const updateModalElement = useCallback(
		(el) => {
			updateModalDesign({
				elements: (getModalDesign().elements || []).map((e) => (e.elementId === el.elementId ? el : e)),
			});
			setSelectedElement(el);
		},
		[updateModalDesign, getModalDesign]
	);

	const updateHintModalElement = useCallback(
		(el) => {
			updateHintModalDesign({
				elements: (getHintModalDesign().elements || []).map((e) => (e.elementId === el.elementId ? el : e)),
			});
			setSelectedElement(el);
		},
		[updateHintModalDesign, getHintModalDesign]
	);

	const addModalElement = useCallback(
		(type, overrides = {}) => {
			const base = defaultElement(type);
			const { content: co, style: so, ...rest } = overrides;
			const el = {
				...base,
				...rest,
				content: co ? { ...(base.content || {}), ...co } : base.content,
				style: so ? { ...(base.style || {}), ...so } : base.style,
			};
			updateModalDesign({ elements: [...(getModalDesign().elements || []), el] });
			setSelectedElement(el);
		},
		[updateModalDesign, getModalDesign]
	);

	const addHintModalElement = useCallback(
		(type, overrides = {}) => {
			const base = defaultElement(type);
			const { content: co, style: so, ...rest } = overrides;
			const el = {
				...base,
				...rest,
				content: co ? { ...(base.content || {}), ...co } : base.content,
				style: so ? { ...(base.style || {}), ...so } : base.style,
			};
			updateHintModalDesign({ elements: [...(getHintModalDesign().elements || []), el] });
			setSelectedElement(el);
		},
		[updateHintModalDesign, getHintModalDesign]
	);

	const removeModalElement = useCallback(
		(elementId) => {
			updateModalDesign({
				elements: (getModalDesign().elements || []).filter((e) => e.elementId !== elementId),
			});
			setSelectedElement(null);
		},
		[updateModalDesign, getModalDesign]
	);

	const removeHintModalElement = useCallback(
		(elementId) => {
			updateHintModalDesign({
				elements: (getHintModalDesign().elements || []).filter((e) => e.elementId !== elementId),
			});
			setSelectedElement(null);
		},
		[updateHintModalDesign, getHintModalDesign]
	);

	const isButtonModalEditMode = !!editingModalButton;
	const isHintModalEditMode = !!editingHintModal;
	const isModalEditMode = isButtonModalEditMode || isHintModalEditMode;
	const modalDim = isModalEditMode
		? (() => {
			if (isButtonModalEditMode) {
				return MODAL_SIZES.find((s) => s.id === (editingModalButton?.content?.modalSize || "medium")) || MODAL_SIZES[1];
			}
			const pageIdx = findHintModalPage();
			const hintEl =
				pageIdx >= 0 ? (pages[pageIdx]?.elements || []).find((e) => e.elementId === editingHintModal?.elementId) : null;
			const c = hintEl?.content || {};
			const sizeKey = editingHintModal?.modalType === "confirm" ? "confirmModalSize" : "hintModalSize";
			return MODAL_SIZES.find((s) => s.id === (c[sizeKey] || "medium")) || MODAL_SIZES[1];
		})()
		: null;

	const effectiveElements = isButtonModalEditMode
		? (getModalDesign().elements || [])
		: isHintModalEditMode
		? (getHintModalDesign().elements || [])
		: elements;
	const selectedElements = (effectiveElements || []).filter((el) => erSelectedIdsInclude(selectedElementIds, el.elementId));
	const hoveredPanelElement = (effectiveElements || []).find((e) => e.elementId === hoverPanelElementId) || null;
	/** Elementos de la página o del modal, en el mismo orden que el canvas (índice alto = delante). */
	const layerElementsForZPanel = isModalEditMode ? (effectiveElements || []) : elements;
	const effectiveViewportDim = isModalEditMode ? modalDim : viewportDim;
	const effectiveUpdateElement = isButtonModalEditMode ? updateModalElement : isHintModalEditMode ? updateHintModalElement : updateElement;
	const updateElementsInActiveDesign = useCallback((updater) => {
		if (isButtonModalEditMode) {
			const els = getModalDesign().elements || [];
			updateModalDesign({ elements: updater(els) });
			return;
		}
		if (isHintModalEditMode) {
			const els = getHintModalDesign().elements || [];
			updateHintModalDesign({ elements: updater(els) });
			return;
		}
		setPages((p) => {
			const next = [...p];
			const page = next[currentPageIndex];
			if (!page) return next;
			next[currentPageIndex] = { ...page, elements: updater(page.elements || []) };
			return next;
		});
	}, [isButtonModalEditMode, isHintModalEditMode, getModalDesign, updateModalDesign, getHintModalDesign, updateHintModalDesign, setPages, currentPageIndex]);
	const pasteStyle = useCallback(() => {
		if (!copiedStyle || !selectedElement || selectedElement.registrationLocked) return;
		const updated = { ...selectedElement };
		updated.style = { ...(selectedElement.style || {}), ...(copiedStyle.style || {}) };
		if (selectedElement.type === "shape" && copiedStyle.shapeContent) {
			updated.content = { ...(selectedElement.content || {}), ...copiedStyle.shapeContent };
		}
		if (selectedElement.type === "quiz") {
			updated.content = { ...(selectedElement.content || {}) };
			if (copiedStyle.quizOptionsStyle) updated.content.quizOptionsStyle = { ...(selectedElement.content?.quizOptionsStyle || {}), ...copiedStyle.quizOptionsStyle };
			if (copiedStyle.quizOptionsDesign != null) updated.content.quizOptionsDesign = copiedStyle.quizOptionsDesign;
			if (copiedStyle.quizOptionsCustom) updated.content.quizOptionsCustom = { ...(selectedElement.content?.quizOptionsCustom || {}), ...copiedStyle.quizOptionsCustom };
		}
		effectiveUpdateElement(updated);
	}, [copiedStyle, selectedElement, effectiveUpdateElement]);
	const effectiveAddElement = isButtonModalEditMode ? addModalElement : isHintModalEditMode ? addHintModalElement : addElement;
	const effectiveRemoveElement = isButtonModalEditMode ? removeModalElement : isHintModalEditMode ? removeHintModalElement : removeElement;
	const effectiveBgColor = isButtonModalEditMode ? (getModalDesign().backgroundColor || "#ffffff") : isHintModalEditMode ? (getHintModalDesign().backgroundColor || "#ffffff") : null;
	const effectiveModalBorderRadius = isButtonModalEditMode ? (getModalDesign().borderRadius ?? 12) : isHintModalEditMode ? (getHintModalDesign().borderRadius ?? 12) : 0;

	useEffect(() => {
		effectiveElementsRef.current = effectiveElements || [];
	}, [effectiveElements]);

	const handleCanvasDragOver = useCallback((e) => {
		e.preventDefault();
		e.dataTransfer.dropEffect = "copy";
	}, []);

	const handleCanvasDrop = useCallback(
		async (e) => {
			e.preventDefault();
			const raw = e.dataTransfer.getData("application/evenely-media");
			if (!raw) return;
			if (!editingModalButton && !editingHintModal && isRegistrationPage) return;
			let data;
			try {
				data = JSON.parse(raw);
			} catch {
				return;
			}
			const { type, path } = data;
			if (type !== "image" && type !== "video") return;
			const box = canvasDropRef.current;
			const dim = editingModalButton || editingHintModal ? modalDim : viewportDim;
			if (!box) {
				effectiveAddElement(type, { content: { url: path } });
				return;
			}
			const rect = box.getBoundingClientRect();
			const localX = ((e.clientX - rect.left) * dim.width) / rect.width;
			const localY = ((e.clientY - rect.top) * dim.height) / rect.height;
			let w = defaultElement(type).width || 200;
			let h = defaultElement(type).height || 80;
			if (type === "image") {
				const size = await resolveImageElementPlacementSize(path, dim.width, dim.height);
				if (size) {
					w = size.width;
					h = size.height;
				}
			}
			const x = Math.max(0, localX - w / 2);
			const y = Math.max(0, localY - h / 2);
			effectiveAddElement(type, { content: { url: path }, x, y, width: w, height: h });
		},
		[effectiveAddElement, isRegistrationPage, viewportDim, editingModalButton, editingHintModal, modalDim]
	);

	const handleSelectMediaForElement = useCallback(
		(path) => {
			if (!mediaPickerMode) return;
			effectiveAddElement(mediaPickerMode, { content: { url: path } });
			setMediaPickerOpen(false);
			setMediaPickerMode(null);
		},
		[mediaPickerMode, effectiveAddElement]
	);

	const handleUploadMediaForElement = useCallback(
		(e) => {
			const file = e?.target?.files?.[0];
			if (!file || !mediaPickerMode) return;
			const isImg = /\.(jpe?g|png|gif|webp|svg)$/i.test(file.name);
			const isVid = /\.(mp4|webm|ogg|mov)$/i.test(file.name);
			if (mediaPickerMode === "image" && !isImg) {
				alertError({ customMessage: "Solo se permiten imágenes." });
				return;
			}
			if (mediaPickerMode === "video" && !isVid) {
				alertError({ customMessage: "Solo se permiten videos (mp4, webm, ogg, mov)." });
				return;
			}
			uploadUserMedia(file, escapeRoom?._id)
				.then((res) => {
					if (res?.data?.fileURL) {
						setUserMedia((prev) => [{ path: res.data.fileURL, name: file.name, isVideo: isVid }, ...prev]);
						handleSelectMediaForElement(res.data.fileURL);
					}
				})
				.catch((err) => alertError({ error: err, customMessage: "Error al subir." }));
			e.target.value = "";
		},
		[mediaPickerMode, handleSelectMediaForElement]
	);

	const handleSelectImageForElement = useCallback(
		(path) => {
			if (buttonImagePickerTarget && selectedElement?.type === "button") {
				const field = buttonImagePickerTarget === "hover" ? "buttonHoverImageUrl" : "buttonImageUrl";
				effectiveUpdateElement({ ...selectedElement, content: { ...selectedElement.content, [field]: path } });
				setImageElementPickerOpen(false);
				setButtonImagePickerTarget(null);
				return;
			}
			if (!selectedElement || selectedElement.type !== "image") return;
			effectiveUpdateElement({ ...selectedElement, content: { ...selectedElement.content, url: path } });
			setImageElementPickerOpen(false);
			resolveImageElementSizeKeepingWidth(path, selectedElement.width).then((size) => {
				if (!size) return;
				effectiveUpdateElement({
					...selectedElement,
					content: { ...selectedElement.content, url: path },
					width: size.width,
					height: size.height,
				});
			});
		},
		[selectedElement, effectiveUpdateElement, buttonImagePickerTarget]
	);

	const handleUploadImageForElement = useCallback(
		(e) => {
			const file = e?.target?.files?.[0];
			if (!file) return;
			const forButton = buttonImagePickerTarget && selectedElement?.type === "button";
			const forImage = selectedElement?.type === "image";
			if (!forButton && !forImage) return;
			if (!/\.(jpe?g|png|gif|webp|svg)$/i.test(file.name)) {
				alertError({ customMessage: "Solo se permiten imágenes." });
				return;
			}
			uploadUserMedia(file, escapeRoom?._id)
				.then((res) => {
					if (res?.data?.fileURL) {
						setUserMedia((prev) => [{ path: res.data.fileURL, name: file.name, isVideo: false }, ...prev]);
						handleSelectImageForElement(res.data.fileURL);
					}
				})
				.catch((err) => alertError({ error: err, customMessage: "Error al subir la imagen." }));
			e.target.value = "";
		},
		[selectedElement, handleSelectImageForElement, buttonImagePickerTarget]
	);

	const handleSelectVideoForElement = useCallback(
		(path) => {
			if (!selectedElement || selectedElement.type !== "video") return;
			effectiveUpdateElement({ ...selectedElement, content: { ...selectedElement.content, url: path } });
			setVideoElementPickerOpen(false);
		},
		[selectedElement, effectiveUpdateElement]
	);

	const handleUploadVideoForElement = useCallback(
		(e) => {
			const file = e?.target?.files?.[0];
			if (!file || !selectedElement || selectedElement.type !== "video") return;
			if (!/\.(mp4|webm|ogg|mov)$/i.test(file.name)) {
				alertError({ customMessage: "Solo se permiten videos (mp4, webm, ogg, mov)." });
				return;
			}
			uploadUserMedia(file, escapeRoom?._id)
				.then((res) => {
					if (res?.data?.fileURL) {
						setUserMedia((prev) => [{ path: res.data.fileURL, name: file.name, isVideo: true }, ...prev]);
						handleSelectVideoForElement(res.data.fileURL);
					}
				})
				.catch((err) => alertError({ error: err, customMessage: "Error al subir el video." }));
			e.target.value = "";
		},
		[selectedElement, handleSelectVideoForElement]
	);

	const handleUpdateQuiz = useCallback(async (quizId, payload) => {
		const isTextAnswerPayload = payload?.questions?.[0]?.type === "textAnswer";
		if (isTextAnswerPayload) textAnswerCanvasSaveRef.current += 1;
		try {
			const res = await updateQuiz(quizId, payload);
			setQuizzes((prev) => prev.map((q) => (q._id === res.data._id ? res.data : q)));
			setQuizInlineSyncNonce((n) => n + 1);
			return res;
		} finally {
			if (isTextAnswerPayload) textAnswerCanvasSaveRef.current = Math.max(0, textAnswerCanvasSaveRef.current - 1);
		}
	}, [updateQuiz]);

	const updateRegistrationDesign = useCallback((updates) => {
		if (!isRegistrationPage) return;
		setPages((p) => {
			const next = [...p];
			const page = next[currentPageIndex];
			page.registrationDesign = { ...(page.registrationDesign || {}), ...updates };
			return next;
		});
	}, [currentPageIndex, isRegistrationPage]);

	/** Color de acento del registro (ajustes): actualiza la página registro aunque no esté seleccionada */
	const updateRegistrationPrimaryColor = useCallback((updates) => {
		setPages((p) =>
			p.map((page) =>
				(page.pageId || page._id) === REGISTRATION_PAGE_ID
					? { ...page, registrationDesign: { ...(page.registrationDesign || {}), ...updates } }
					: page
			)
		);
	}, []);

	const updatePageDesign = useCallback((updates) => {
		if (isRegistrationPage) return;
		const normalized = { ...updates };
		if (normalized.backgroundImageUrl !== undefined) {
			normalized.backgroundImageUrl = normalizeEscapeRoomMediaPath(normalized.backgroundImageUrl);
		}
		setPages((p) =>
			p.map((page, i) => (i === currentPageIndex ? { ...page, ...normalized } : page))
		);
	}, [currentPageIndex, isRegistrationPage]);

	const applyBackgroundToAllPages = useCallback(() => {
		if (isRegistrationPage) return;
		const bg = currentPage?.backgroundColor || "#ffffff";
		const bgImg = currentPage?.backgroundImageUrl || "";
		const bgOp = currentPage?.backgroundImageOpacity;
		setPages((p) =>
			p.map((page) => {
				if ((page.pageId || page._id) === REGISTRATION_PAGE_ID) return page;
				return { ...page, backgroundColor: bg, backgroundImageUrl: bgImg, backgroundImageOpacity: bgOp };
			})
		);
	}, [currentPage?.backgroundColor, currentPage?.backgroundImageUrl, currentPage?.backgroundImageOpacity, isRegistrationPage]);

	const applyAnimationToAllPages = useCallback(() => {
		if (isRegistrationPage) return;
		const trans = normalizePageTransitionId(currentPage?.transitionToNext || "none");
		const dur = currentPage?.transitionDuration ?? 350;
		setPages((p) =>
			p.map((page) => {
				if ((page.pageId || page._id) === REGISTRATION_PAGE_ID) return page;
				return { ...page, transitionToNext: trans, transitionDuration: dur };
			})
		);
	}, [currentPage?.transitionToNext, currentPage?.transitionDuration, isRegistrationPage]);

	const handleSelectBackgroundImage = useCallback(
		(path) => {
			updatePageDesign({ backgroundImageUrl: normalizeEscapeRoomMediaPath(path) || "" });
			setBackgroundPickerOpen(false);
		},
		[updatePageDesign]
	);

	const handleSelectRegistrationBackground = useCallback(
		(path) => {
			updateRegistrationDesign({ backgroundImageUrl: normalizeEscapeRoomMediaPath(path) || "" });
			setRegistrationBackgroundPickerOpen(false);
		},
		[updateRegistrationDesign]
	);

	const handleSelectLogo = useCallback(
		(path) => {
			updateRegistrationDesign({ logoUrl: path || "" });
			setLogoPickerOpen(false);
		},
		[updateRegistrationDesign]
	);

	const handleUploadAndSelectBackground = useCallback(
		(e) => {
			const file = e?.target?.files?.[0];
			if (!file) return;
			if (!/\.(jpe?g|png|gif|webp|svg)$/i.test(file.name)) {
				alertError({ customMessage: "Solo se permiten imágenes para el fondo." });
				return;
			}
			uploadUserMedia(file, escapeRoom?._id)
				.then((res) => {
					if (res?.data?.fileURL) {
						const stored = normalizeEscapeRoomMediaPath(res.data.fileURL);
						updatePageDesign({ backgroundImageUrl: stored });
						setUserMedia((prev) => [{ path: stored, name: file.name, isVideo: false }, ...prev]);
						setBackgroundPickerOpen(false);
					}
				})
				.catch((err) => alertError({ error: err, customMessage: "Error al subir la imagen." }));
			e.target.value = "";
		},
		[updatePageDesign]
	);

	const handleUploadAndSelectRegistrationBackground = useCallback(
		(e) => {
			const file = e?.target?.files?.[0];
			if (!file) return;
			if (!/\.(jpe?g|png|gif|webp|svg)$/i.test(file.name)) {
				alertError({ customMessage: "Solo se permiten imágenes para el fondo." });
				return;
			}
			uploadUserMedia(file, escapeRoom?._id)
				.then((res) => {
					if (res?.data?.fileURL) {
						const stored = normalizeEscapeRoomMediaPath(res.data.fileURL);
						updateRegistrationDesign({ backgroundImageUrl: stored });
						setUserMedia((prev) => [{ path: stored, name: file.name, isVideo: false }, ...prev]);
						setRegistrationBackgroundPickerOpen(false);
					}
				})
				.catch((err) => alertError({ error: err, customMessage: "Error al subir la imagen." }));
			e.target.value = "";
		},
		[updateRegistrationDesign]
	);

	const handleUploadAndSelectLogo = useCallback(
		(e) => {
			const file = e?.target?.files?.[0];
			if (!file) return;
			if (!/\.(jpe?g|png|gif|webp|svg)$/i.test(file.name)) {
				alertError({ customMessage: "Solo se permiten imágenes para el logo." });
				return;
			}
			uploadUserMedia(file, escapeRoom?._id)
				.then((res) => {
					if (res?.data?.fileURL) {
						updateRegistrationDesign({ logoUrl: res.data.fileURL });
						setUserMedia((prev) => [{ path: res.data.fileURL, name: file.name, isVideo: false }, ...prev]);
						setLogoPickerOpen(false);
					}
				})
				.catch((err) => alertError({ error: err, customMessage: "Error al subir la imagen." }));
			e.target.value = "";
		},
		[updateRegistrationDesign]
	);

	const [dragging, setDragging] = useState(null);
	const [resizing, setResizing] = useState(null);
	/** Rectángulo de selección en coordenadas lógicas del canvas (null si no hay arrastre). */
	const [marqueeRect, setMarqueeRect] = useState(null);
	const [alignmentGuides, setAlignmentGuides] = useState({ x: null, y: null });
	const copiedSizeRef = useRef(null);
	const [hasCopiedSize, setHasCopiedSize] = useState(false);
	const editarSectionRefs = useRef({ posicion: null, tamano: null, contenido: null, estilo: null, comportamiento: null });
	const [copiedElement, setCopiedElement] = useState(null);
	const [copiedStyle, setCopiedStyle] = useState(null);
	const [quizImagePickerFor, setQuizImagePickerFor] = useState(null);
	/** Incrementado tras guardar imagen de opción vía diálogo: cancela debounce en InlineQuizEditor para no pisar el servidor. */
	const [quizInlineSyncNonce, setQuizInlineSyncNonce] = useState(0);
	const textAnswerCanvasSaveRef = useRef(0);
	useEffect(() => {
		if (quizImagePickerFor) loadUserMedia();
	}, [quizImagePickerFor, loadUserMedia]);

	const copyElement = useCallback(() => {
		if (selectedElement) setCopiedElement(JSON.parse(JSON.stringify(selectedElement)));
	}, [selectedElement]);

	const copyStyle = useCallback(() => {
		if (!selectedElement || selectedElement.registrationLocked) return;
		const el = selectedElement;
		const styleData = { style: JSON.parse(JSON.stringify(el.style || {})) };
		if (el.type === "shape" && el.content) {
			styleData.shapeContent = {};
			if (el.content.fillColor !== undefined) styleData.shapeContent.fillColor = el.content.fillColor;
			if (el.content.strokeColor !== undefined) styleData.shapeContent.strokeColor = el.content.strokeColor;
			if (el.content.strokeWidth !== undefined) styleData.shapeContent.strokeWidth = el.content.strokeWidth;
			if (el.content.borderRadius !== undefined) styleData.shapeContent.borderRadius = el.content.borderRadius;
		}
		if ((el.type === "quiz") && el.content) {
			if (el.content.quizOptionsStyle) styleData.quizOptionsStyle = JSON.parse(JSON.stringify(el.content.quizOptionsStyle));
			if (el.content.quizOptionsDesign != null) styleData.quizOptionsDesign = el.content.quizOptionsDesign;
			if (el.content.quizOptionsCustom && Object.keys(el.content.quizOptionsCustom).length > 0) styleData.quizOptionsCustom = JSON.parse(JSON.stringify(el.content.quizOptionsCustom));
		}
		setCopiedStyle(styleData);
	}, [selectedElement]);


	const toDesktopCoords = useCallback((x, y) => {
		if (activeViewport === "desktop") return { x: x || 0, y: y || 0 };
		const vp = VIEWPORTS.find((v) => v.id === activeViewport);
		if (!vp) return { x: x || 0, y: y || 0 };
		const scaleX = vp.width / DESKTOP.width;
		const scaleY = vp.height / DESKTOP.height;
		return { x: Math.round((x || 0) / scaleX), y: Math.round((y || 0) / scaleY) };
	}, [activeViewport]);

	const pasteElement = useCallback(async () => {
		if (!copiedElement) return;
		const toPaste = copiedElement;
		const clone = JSON.parse(JSON.stringify(toPaste));
		clone.elementId = genId();
		delete clone.breakpoints;
		const { x, y } = toDesktopCoords(clone.x, clone.y);
		clone.x = x + 20;
		clone.y = y + 20;
		if (clone.type === "quiz") {
			const srcQuizId = resolvePlayQuizId(clone.content?.quizId);
			if (srcQuizId) {
				try {
					const newId = await cloneQuizById(srcQuizId);
					clone.content = { ...clone.content, quizId: newId };
				} catch (err) {
					alertError({ error: err, customMessage: "No se pudo pegar el bloque de pregunta (error al copiar el quiz)." });
					return;
				}
			}
		}
		if (isModalEditMode) {
			const modalEls = effectiveElements || [];
			const next = { elements: [...modalEls, clone] };
			if (isButtonModalEditMode) updateModalDesign(next);
			else updateHintModalDesign(next);
			setSelectedElement(clone);
		} else {
			setPages((p) => {
				const next = [...p];
				const page = { ...next[currentPageIndex], elements: [...(next[currentPageIndex].elements || []), clone] };
				next[currentPageIndex] = page;
				return next;
			});
			const displayed = getElementsForViewport({ elements: [...(currentPage?.elements || []), clone] }, activeViewport).find((e) => e.elementId === clone.elementId);
			setSelectedElement(displayed || clone);
		}
	}, [copiedElement, currentPageIndex, currentPage?.elements, activeViewport, toDesktopCoords, isModalEditMode, effectiveElements, isButtonModalEditMode, updateModalDesign, updateHintModalDesign, cloneQuizById]);

	const duplicateElement = useCallback(async () => {
		if (!selectedElement) return;
		const baseEl = isModalEditMode
			? (effectiveElements || []).find((e) => e.elementId === selectedElement.elementId) || selectedElement
			: (currentPage?.elements || []).find((e) => e.elementId === selectedElement.elementId) || selectedElement;
		const clone = JSON.parse(JSON.stringify(baseEl));
		clone.elementId = genId();
		delete clone.breakpoints;
		const { x, y } = toDesktopCoords(selectedElement.x, selectedElement.y);
		clone.x = x + 20;
		clone.y = y + 20;
		if (clone.type === "quiz") {
			const srcQuizId = resolvePlayQuizId(clone.content?.quizId);
			if (srcQuizId) {
				try {
					const newId = await cloneQuizById(srcQuizId);
					clone.content = { ...clone.content, quizId: newId };
				} catch (err) {
					alertError({ error: err, customMessage: "No se pudo duplicar la pregunta (error al copiar el quiz)." });
					return;
				}
			}
		}
		if (isModalEditMode) {
			const modalEls = effectiveElements || [];
			const next = { elements: [...modalEls, clone] };
			if (isButtonModalEditMode) updateModalDesign(next);
			else updateHintModalDesign(next);
			setSelectedElement(clone);
		} else {
			setPages((p) => {
				const next = [...p];
				const page = { ...next[currentPageIndex], elements: [...(next[currentPageIndex].elements || []), clone] };
				next[currentPageIndex] = page;
				return next;
			});
			const displayed = getElementsForViewport({ elements: [...(currentPage?.elements || []), clone] }, activeViewport).find((e) => e.elementId === clone.elementId);
			setSelectedElement(displayed || clone);
		}
	}, [selectedElement, currentPageIndex, currentPage?.elements, activeViewport, toDesktopCoords, isModalEditMode, effectiveElements, isButtonModalEditMode, updateModalDesign, updateHintModalDesign, cloneQuizById]);

	const reorderElement = useCallback(
		(dir) => {
			if (!selectedElement) return;
			const els = [...(isModalEditMode ? effectiveElements : elements)];
			const idx = els.findIndex((e) => e.elementId === selectedElement.elementId);
			if (idx < 0) return;
			const [el] = els.splice(idx, 1);
			let newIdx;
			if (dir === "front") newIdx = els.length;
			else if (dir === "back") newIdx = 0;
			else if (dir === "forward") newIdx = Math.min(els.length, idx + 1);
			else newIdx = Math.max(0, idx - 1);
			els.splice(newIdx, 0, el);
			if (isModalEditMode) {
				if (isButtonModalEditMode) updateModalDesign({ elements: els });
				else updateHintModalDesign({ elements: els });
			} else {
				setPages((p) => {
					const next = [...p];
					next[currentPageIndex] = { ...next[currentPageIndex], elements: els };
					return next;
				});
			}
		},
		[selectedElement, elements, effectiveElements, currentPageIndex, isModalEditMode, isButtonModalEditMode, updateModalDesign, updateHintModalDesign]
	);

	useEffect(() => {
		const onKeyDown = (e) => {
			const inInput = e.target.tagName === "INPUT" || e.target.tagName === "TEXTAREA" || e.target.isContentEditable;
			if (inInput) return;
			// Mover elemento seleccionado con flechas (solo en modo "mover", no editando texto)
			if (
				selectedElement &&
				!selectedElement.registrationLocked &&
				!dragging &&
				!resizing &&
				editingTextElementId !== selectedElement.elementId &&
				editingButtonLabelElementId !== selectedElement.elementId &&
				(e.key === "ArrowLeft" || e.key === "ArrowRight" || e.key === "ArrowUp" || e.key === "ArrowDown") &&
				!(e.ctrlKey || e.metaKey || e.altKey)
			) {
				e.preventDefault();
				const step = e.shiftKey ? 10 : 1;
				const dx = e.key === "ArrowLeft" ? -step : e.key === "ArrowRight" ? step : 0;
				const dy = e.key === "ArrowUp" ? -step : e.key === "ArrowDown" ? step : 0;
				const nx = Math.max(0, Math.round((selectedElement.x || 0) + dx));
				const ny = Math.max(0, Math.round((selectedElement.y || 0) + dy));
				effectiveUpdateElement({ ...selectedElement, x: nx, y: ny });
				return;
			}
			if (e.key === "Delete" || e.key === "Backspace") {
				if (selectedElement && !selectedElement.registrationLocked) {
					e.preventDefault();
					effectiveRemoveElement(selectedElement.elementId);
				}
				return;
			}
			if (e.ctrlKey || e.metaKey) {
				if (e.key === "z") {
					e.preventDefault();
					if (e.shiftKey) performRedo();
					else performUndo();
				} else if (e.key === "y") {
					e.preventDefault();
					performRedo();
				} else if (e.key === "c") {
					if (e.shiftKey && selectedElement) {
						e.preventDefault();
						copyStyle();
					} else if (selectedElement) {
						e.preventDefault();
						copyElement();
					}
				} else if (e.key === "v") {
					if (e.shiftKey && copiedStyle) {
						e.preventDefault();
						pasteStyle();
					} else if (copiedElement) {
						e.preventDefault();
						pasteElement();
					}
				} else if (e.key === "d" && selectedElement) {
					e.preventDefault();
					duplicateElement();
				}
			}
		};
		window.addEventListener("keydown", onKeyDown);
		return () => window.removeEventListener("keydown", onKeyDown);
	}, [selectedElement, dragging, resizing, editingTextElementId, editingButtonLabelElementId, copiedElement, copiedStyle, copyElement, pasteElement, copyStyle, pasteStyle, duplicateElement, effectiveUpdateElement, effectiveRemoveElement, performUndo, performRedo]);

	const handleElementContextMenu = useCallback((e, element) => {
		e.preventDefault();
		e.stopPropagation();
		setSelectedElement(element);
		const id = String(element.elementId ?? "");
		selectedElementIdsRef.current = [id];
		setSelectedElementIds([id]);
		setContextMenu({ mouseX: e.clientX, mouseY: e.clientY });
	}, []);

	const handleSelectElement = useCallback((element, ev) => {
		if (suppressMarqueeFollowupRef.current) return;
		const shift = !!(ev && (ev.shiftKey || ev.append));
		const elId = String(element.elementId ?? "");
		if (shift) {
			setSelectedElementIds((prev) => {
				const exists = prev.some((id) => erElIdEq(id, elId));
				const next = exists ? prev : [...prev, elId];
				selectedElementIdsRef.current = next;
				if (!exists) {
					setSelectedElement(element);
				}
				return next;
			});
			return;
		}
		// Sin Shift: si ya hay multiselección y este elemento está dentro, no reducir a uno
		// (si no, el mousedown antes de onDragStart dejaba solo el clicado y el grupo no se movía).
		const prevIds = selectedElementIdsRef.current;
		if (prevIds.length > 1 && prevIds.some((id) => erElIdEq(id, elId))) {
			setSelectedElement(element);
			return;
		}
		const next = [elId];
		selectedElementIdsRef.current = next;
		setSelectedElement(element);
		setSelectedElementIds(next);
	}, []);

	useEffect(() => {
		selectedElementIdsRef.current = selectedElementIds;
	}, [selectedElementIds]);

	const clientToCanvasCoords = useCallback((clientX, clientY) => {
		const el = canvasDropRef.current;
		if (!el) return { x: 0, y: 0 };
		const r = el.getBoundingClientRect();
		const w = effectiveViewportDim?.width ?? 960;
		const h = effectiveViewportDim?.height ?? 540;
		if (r.width <= 0 || r.height <= 0) return { x: 0, y: 0 };
		return {
			x: ((clientX - r.left) / r.width) * w,
			y: ((clientY - r.top) / r.height) * h,
		};
	}, [effectiveViewportDim?.width, effectiveViewportDim?.height]);

	const MARQUEE_MIN_DRAG_CLIENT_PX = 5;
	/** Marquee con Pointer Events: en táctil / vista móvil `mousemove` + `buttons` no funcionan bien. */
	const handleCanvasBackgroundMarqueeMouseDown = useCallback(
		(e) => {
			if (e.button != null && e.button !== 0) return;
			if (dragging || resizing) return;
			const native = e.nativeEvent || e;
			const pointerId = typeof native.pointerId === "number" ? native.pointerId : null;
			const usePointer = pointerId != null;
			const startClientX = e.clientX;
			const startClientY = e.clientY;
			const p0 = clientToCanvasCoords(startClientX, startClientY);
			const session = {
				startX: p0.x,
				startY: p0.y,
				lastX: p0.x,
				lastY: p0.y,
				startClientX,
				startClientY,
				pointerId,
				usePointer,
			};
			let marqueeDragLock = false;
			const captureEl = canvasDropRef.current;
			let didCapture = false;
			if (usePointer && captureEl && typeof captureEl.setPointerCapture === "function") {
				try {
					captureEl.setPointerCapture(pointerId);
					didCapture = true;
				} catch (_) {
					/* ignore */
				}
			}
			const updateRect = (clientX, clientY) => {
				const p = clientToCanvasCoords(clientX, clientY);
				session.lastX = p.x;
				session.lastY = p.y;
				setMarqueeRect({
					x1: Math.min(session.startX, p.x),
					y1: Math.min(session.startY, p.y),
					x2: Math.max(session.startX, p.x),
					y2: Math.max(session.startY, p.y),
				});
			};
			updateRect(startClientX, startClientY);
			const moveOpts = { capture: true, passive: false };
			const upOpts = { capture: true };
			const onMove = (ev) => {
				if (session.usePointer) {
					if (typeof ev.pointerId === "number" && ev.pointerId !== session.pointerId) return;
				} else if (!(ev.buttons & 1)) return;
				if (!marqueeDragLock && Math.hypot(ev.clientX - startClientX, ev.clientY - startClientY) > 2) {
					marqueeDragLock = true;
					document.body.style.userSelect = "none";
				}
				if (marqueeDragLock) ev.preventDefault();
				updateRect(ev.clientX, ev.clientY);
			};
			const cleanup = () => {
				if (session.usePointer) {
					document.removeEventListener("pointermove", onMove, moveOpts);
					document.removeEventListener("pointerup", onUp, upOpts);
					document.removeEventListener("pointercancel", onUp, upOpts);
				} else {
					document.removeEventListener("mousemove", onMove, true);
					document.removeEventListener("mouseup", onUp, true);
				}
				if (didCapture && captureEl && typeof captureEl.releasePointerCapture === "function") {
					try {
						captureEl.releasePointerCapture(session.pointerId);
					} catch (_) {
						/* ignore */
					}
				}
				document.body.style.userSelect = "";
			};
			const onUp = (ev) => {
				if (session.usePointer && typeof ev.pointerId === "number" && ev.pointerId !== session.pointerId) return;
				cleanup();
				setMarqueeRect(null);
				const cx = ev.clientX ?? session.startClientX;
				const cy = ev.clientY ?? session.startClientY;
				const dist = Math.hypot(cx - session.startClientX, cy - session.startClientY);
				if (dist < MARQUEE_MIN_DRAG_CLIENT_PX) return;
				const x1 = Math.min(session.startX, session.lastX);
				const x2 = Math.max(session.startX, session.lastX);
				const y1 = Math.min(session.startY, session.lastY);
				const y2 = Math.max(session.startY, session.lastY);
				const els = effectiveElementsRef.current || [];
				const hits = els.filter((el) => {
					if (el.registrationLocked) return false;
					const ex = Number(el.x) || 0;
					const ey = Number(el.y) || 0;
					const ew = Number(el.width) || 0;
					const eh = Number(el.height) || 0;
					return !(ex + ew < x1 || ex > x2 || ey + eh < y1 || ey > y2);
				});
				suppressMarqueeFollowupRef.current = true;
				window.setTimeout(() => {
					suppressMarqueeFollowupRef.current = false;
				}, 0);
				if (hits.length > 0) {
					setSelectedElementIds((prev) => {
						const next = [...prev];
						for (const h of hits) {
							const hid = String(h.elementId ?? "");
							if (!hid) continue;
							if (!next.some((id) => erElIdEq(id, hid))) next.push(hid);
						}
						selectedElementIdsRef.current = next;
						return next;
					});
					setSelectedElement(hits[hits.length - 1]);
				} else {
					selectedElementIdsRef.current = [];
					setSelectedElement(null);
					setSelectedElementIds([]);
					setEditingTextElementId(null);
					setEditingButtonLabelElementId(null);
				}
			};
			if (session.usePointer) {
				document.addEventListener("pointermove", onMove, moveOpts);
				document.addEventListener("pointerup", onUp, upOpts);
				document.addEventListener("pointercancel", onUp, upOpts);
			} else {
				document.addEventListener("mousemove", onMove, true);
				document.addEventListener("mouseup", onUp, true);
			}
		},
		[dragging, resizing, clientToCanvasCoords]
	);

	useEffect(() => {
		if (!selectedElement && selectedElementIds.length) {
			setSelectedElementIds([]);
		}
	}, [selectedElement, selectedElementIds.length]);

	const onDragStart = useCallback((element, e) => {
		if (e.preventDefault) e.preventDefault();
		if (e.stopPropagation) e.stopPropagation();
		const centerX = (effectiveViewportDim?.width ?? 960) / 2;
		const centerY = (effectiveViewportDim?.height ?? 540) / 2;
		const others = (effectiveElements || []).filter((el) => !erElIdEq(el.elementId, element.elementId));
		const snapXTargets = [centerX];
		const snapYTargets = [centerY];
		others.forEach((el) => {
			const ex = Number(el.x) || 0;
			const ey = Number(el.y) || 0;
			const ew = Number(el.width) || 0;
			const eh = Number(el.height) || 0;
			snapXTargets.push(ex, ex + ew / 2, ex + ew);
			snapYTargets.push(ey, ey + eh / 2, ey + eh);
		});
		const idsNow = selectedElementIdsRef.current;
		const groupMembers = (effectiveElements || []).filter((el) => erSelectedIdsInclude(idsNow, el.elementId));
		const groupElements = erSelectedIdsInclude(idsNow, element.elementId) && groupMembers.length > 1
			? groupMembers.map((el) => ({ ...el }))
			: null;
		setDragging({
			element,
			groupElements,
			startClientX: e.clientX,
			startClientY: e.clientY,
			origX: element.x,
			origY: element.y,
			snapXTargets,
			snapYTargets,
		});
	}, [effectiveElements, effectiveViewportDim]);

	const DRAG_THRESHOLD = 4;
	const SNAP_THRESHOLD = 12; // Ayuda suave al centrar; solo agarra cuando estás muy cerca
	const canvasCenterX = (effectiveViewportDim?.width ?? 960) / 2;
	const canvasCenterY = (effectiveViewportDim?.height ?? 540) / 2;

	useEffect(() => {
		if (!dragging) return;
		document.body.style.cursor = "grabbing";
		document.body.style.userSelect = "none";
		const data = { ...dragging };
		const usePtr = typeof window !== "undefined" && typeof window.PointerEvent !== "undefined";
		const moveOpts = { capture: true, passive: false };
		const upOpts = { capture: true };
		const onMove = (e) => {
			if (usePtr) {
				if (e.pointerType === "mouse" && !(e.buttons & 1)) return;
			} else if (!(e.buttons & 1)) return;
			const dx = (e.clientX - data.startClientX) / canvasZoom;
			const dy = (e.clientY - data.startClientY) / canvasZoom;
			const movedPx = Math.sqrt((e.clientX - data.startClientX) ** 2 + (e.clientY - data.startClientY) ** 2);
			if (movedPx < DRAG_THRESHOLD) return;
			let nx = data.origX + dx;
			let ny = data.origY + dy;
			if (Array.isArray(data.groupElements) && data.groupElements.length > 1) {
				if (isModalEditMode) {
					updateElementsInActiveDesign((els) => els.map((el) => {
						const g = data.groupElements.find((x) => erElIdEq(x.elementId, el.elementId));
						if (!g) return el;
						return { ...el, x: Math.round(g.x + dx), y: Math.round(g.y + dy) };
					}));
				} else {
					data.groupElements.forEach((g) => {
						updateElement({ ...g, x: Math.round(g.x + dx), y: Math.round(g.y + dy) });
					});
				}
				return;
			}
			const w = data.element.width || 100;
			const h = data.element.height || 50;
			const movingX = { left: nx, center: nx + w / 2, right: nx + w };
			const movingY = { top: ny, center: ny + h / 2, bottom: ny + h };

			let bestX = { dist: SNAP_THRESHOLD + 1, target: null, key: null, guide: null };
			let bestY = { dist: SNAP_THRESHOLD + 1, target: null, key: null, guide: null };
			const maybeUseX = (target, key, guide) => {
				const d = Math.abs(movingX[key] - target);
				if (d < bestX.dist) bestX = { dist: d, target, key, guide };
			};
			const maybeUseY = (target, key, guide) => {
				const d = Math.abs(movingY[key] - target);
				if (d < bestY.dist) bestY = { dist: d, target, key, guide };
			};

			(data.snapXTargets || []).forEach((t) => {
				maybeUseX(t, "left", t);
				maybeUseX(t, "center", t);
				maybeUseX(t, "right", t);
			});
			(data.snapYTargets || []).forEach((t) => {
				maybeUseY(t, "top", t);
				maybeUseY(t, "center", t);
				maybeUseY(t, "bottom", t);
			});

			if (bestX.target != null && bestX.dist <= SNAP_THRESHOLD) {
				if (bestX.key === "left") nx = bestX.target;
				else if (bestX.key === "center") nx = bestX.target - w / 2;
				else nx = bestX.target - w;
			}
			if (bestY.target != null && bestY.dist <= SNAP_THRESHOLD) {
				if (bestY.key === "top") ny = bestY.target;
				else if (bestY.key === "center") ny = bestY.target - h / 2;
				else ny = bestY.target - h;
			}

			const nextGuideX = bestX.target != null && bestX.dist <= SNAP_THRESHOLD ? bestX.guide : null;
			const nextGuideY = bestY.target != null && bestY.dist <= SNAP_THRESHOLD ? bestY.guide : null;
			setAlignmentGuides((prev) => (prev.x === nextGuideX && prev.y === nextGuideY ? prev : { x: nextGuideX, y: nextGuideY }));
			effectiveUpdateElement({ ...data.element, x: Math.round(nx), y: Math.round(ny) });
		};
		const onUp = (ev) => {
			if (ev && (ev.type === "mouseup" || ev.type === "pointerup") && ev.button != null && ev.button !== 0) return;
			setDragging(null);
			setAlignmentGuides({ x: null, y: null });
			document.body.style.cursor = "";
			document.body.style.userSelect = "";
		};
		const onBlur = () => {
			setDragging(null);
			setAlignmentGuides({ x: null, y: null });
			document.body.style.cursor = "";
			document.body.style.userSelect = "";
		};
		if (usePtr) {
			document.addEventListener("pointermove", onMove, moveOpts);
			document.addEventListener("pointerup", onUp, upOpts);
			document.addEventListener("pointercancel", onUp, upOpts);
		} else {
			document.addEventListener("mousemove", onMove, true);
			document.addEventListener("mouseup", onUp, true);
		}
		window.addEventListener("blur", onBlur);
		return () => {
			if (usePtr) {
				document.removeEventListener("pointermove", onMove, moveOpts);
				document.removeEventListener("pointerup", onUp, upOpts);
				document.removeEventListener("pointercancel", onUp, upOpts);
			} else {
				document.removeEventListener("mousemove", onMove, true);
				document.removeEventListener("mouseup", onUp, true);
			}
			window.removeEventListener("blur", onBlur);
			document.body.style.cursor = "";
			document.body.style.userSelect = "";
		};
	}, [dragging, effectiveUpdateElement, canvasZoom, updateElementsInActiveDesign, isModalEditMode, updateElement]);

	const onResizeStart = useCallback((element, handle, e) => {
		e.preventDefault();
		e.stopPropagation();
		setAlignmentGuides({ x: null, y: null });
		const idsNow = selectedElementIdsRef.current;
		const groupMembers = (effectiveElements || []).filter((el) => erSelectedIdsInclude(idsNow, el.elementId));
		const groupElements = erSelectedIdsInclude(idsNow, element.elementId) && groupMembers.length > 1
			? groupMembers.map((el) => ({ ...el }))
			: null;
		let groupBox = null;
		if (groupElements && groupElements.length > 1) {
			const left = Math.min(...groupElements.map((el) => Number(el.x) || 0));
			const top = Math.min(...groupElements.map((el) => Number(el.y) || 0));
			const right = Math.max(...groupElements.map((el) => (Number(el.x) || 0) + (Number(el.width) || MIN_SIZE)));
			const bottom = Math.max(...groupElements.map((el) => (Number(el.y) || 0) + (Number(el.height) || MIN_SIZE)));
			groupBox = { x: left, y: top, w: Math.max(MIN_SIZE, right - left), h: Math.max(MIN_SIZE, bottom - top) };
		}
		setResizing({
			element,
			groupElements,
			groupBox,
			handle,
			startClientX: e.clientX,
			startClientY: e.clientY,
			origX: element.x,
			origY: element.y,
			origW: element.width,
			origH: element.height,
		});
	}, [effectiveElements]);

	useEffect(() => {
		if (!resizing) return;
		document.body.style.cursor = "grabbing";
		document.body.style.userSelect = "none";
		const { element, handle, startClientX, startClientY, origX, origY, origW, origH, groupElements, groupBox } = resizing;
		const usePtr = typeof window !== "undefined" && typeof window.PointerEvent !== "undefined";
		const moveOpts = { capture: true, passive: false };
		const upOpts = { capture: true };
		const onMove = (e) => {
			if (usePtr) {
				if (e.pointerType === "mouse" && !(e.buttons & 1)) return;
			} else if (!(e.buttons & 1)) return;
			const dx = (e.clientX - startClientX) / canvasZoom;
			const dy = (e.clientY - startClientY) / canvasZoom;
			let x = origX;
			let y = origY;
			let w = origW;
			let h = origH;
			if (handle.includes("e")) w = Math.max(MIN_SIZE, origW + dx);
			if (handle.includes("s")) h = Math.max(MIN_SIZE, origH + dy);
			if (handle.includes("w")) {
				w = Math.max(MIN_SIZE, origW - dx);
				x = origX + (origW - w);
			}
			if (handle.includes("n")) {
				h = Math.max(MIN_SIZE, origH - dy);
				y = origY + (origH - h);
			}
			if (Array.isArray(groupElements) && groupElements.length > 1 && groupBox) {
				let bx = groupBox.x;
				let by = groupBox.y;
				let bw = groupBox.w;
				let bh = groupBox.h;
				if (handle.includes("e")) bw = Math.max(MIN_SIZE, groupBox.w + dx);
				if (handle.includes("s")) bh = Math.max(MIN_SIZE, groupBox.h + dy);
				if (handle.includes("w")) {
					bw = Math.max(MIN_SIZE, groupBox.w - dx);
					bx = groupBox.x + (groupBox.w - bw);
				}
				if (handle.includes("n")) {
					bh = Math.max(MIN_SIZE, groupBox.h - dy);
					by = groupBox.y + (groupBox.h - bh);
				}
				const sx = bw / Math.max(1, groupBox.w);
				const sy = bh / Math.max(1, groupBox.h);
				if (isModalEditMode) {
					updateElementsInActiveDesign((els) => els.map((el2) => {
						const g = groupElements.find((x2) => erElIdEq(x2.elementId, el2.elementId));
						if (!g) return el2;
						const nx2 = bx + (g.x - groupBox.x) * sx;
						const ny2 = by + (g.y - groupBox.y) * sy;
						const nw2 = Math.max(MIN_SIZE, g.width * sx);
						const nh2 = Math.max(MIN_SIZE, g.height * sy);
						return { ...el2, x: Math.round(nx2), y: Math.round(ny2), width: Math.round(nw2), height: Math.round(nh2) };
					}));
				} else {
					groupElements.forEach((g) => {
						const nx2 = bx + (g.x - groupBox.x) * sx;
						const ny2 = by + (g.y - groupBox.y) * sy;
						const nw2 = Math.max(MIN_SIZE, g.width * sx);
						const nh2 = Math.max(MIN_SIZE, g.height * sy);
						updateElement({ ...g, x: Math.round(nx2), y: Math.round(ny2), width: Math.round(nw2), height: Math.round(nh2) });
					});
				}
				return;
			}
			if (element.type === "image" && isImageCornerResizeHandle(handle)) {
				const locked = applyLockedAspectResize({ x, y, w, h, origX, origY, origW, origH, handle, minSize: MIN_SIZE });
				x = locked.x;
				y = locked.y;
				w = locked.w;
				h = locked.h;
			}
			effectiveUpdateElement({ ...element, x: Math.round(x), y: Math.round(y), width: Math.round(w), height: Math.round(h) });
		};
		const onUp = (ev) => {
			if (ev && (ev.type === "mouseup" || ev.type === "pointerup") && ev.button != null && ev.button !== 0) return;
			setResizing(null);
			document.body.style.cursor = "";
			document.body.style.userSelect = "";
		};
		const onBlur = () => {
			setResizing(null);
			document.body.style.cursor = "";
			document.body.style.userSelect = "";
		};
		if (usePtr) {
			document.addEventListener("pointermove", onMove, moveOpts);
			document.addEventListener("pointerup", onUp, upOpts);
			document.addEventListener("pointercancel", onUp, upOpts);
		} else {
			document.addEventListener("mousemove", onMove, true);
			document.addEventListener("mouseup", onUp, true);
		}
		window.addEventListener("blur", onBlur);
		return () => {
			if (usePtr) {
				document.removeEventListener("pointermove", onMove, moveOpts);
				document.removeEventListener("pointerup", onUp, upOpts);
				document.removeEventListener("pointercancel", onUp, upOpts);
			} else {
				document.removeEventListener("mousemove", onMove, true);
				document.removeEventListener("mouseup", onUp, true);
			}
			window.removeEventListener("blur", onBlur);
			document.body.style.cursor = "";
			document.body.style.userSelect = "";
		};
	}, [resizing, effectiveUpdateElement, canvasZoom, updateElementsInActiveDesign, isModalEditMode, updateElement]);

	const ZOOM_MIN = 0.5;
	const ZOOM_MAX = 5;
	const ZOOM_STEP = 0.1;
	const PAN_STEP = 40;

	useEffect(() => {
		const onKeyDown = (e) => {
			const inInput = e.target.tagName === "INPUT" || e.target.tagName === "TEXTAREA" || e.target.isContentEditable;
			if (inInput) return;
			if (e.ctrlKey || e.metaKey) {
				if (e.key === "=" || e.key === "+") {
					e.preventDefault();
					setCanvasZoom((z) => Math.min(ZOOM_MAX, z + ZOOM_STEP));
				} else if (e.key === "-") {
					e.preventDefault();
					setCanvasZoom((z) => Math.max(ZOOM_MIN, z - ZOOM_STEP));
				}
			}
		};
		window.addEventListener("keydown", onKeyDown);
		return () => window.removeEventListener("keydown", onKeyDown);
	}, []);

	const handleCanvasWheel = useCallback((e) => {
		if (e.ctrlKey || e.metaKey) {
			e.preventDefault();
			const delta = e.deltaY > 0 ? -ZOOM_STEP : ZOOM_STEP;
			setCanvasZoom((z) => Math.min(ZOOM_MAX, Math.max(ZOOM_MIN, z + delta)));
		} else {
			e.preventDefault();
			setCanvasPan((p) => ({
				x: p.x - e.deltaX,
				y: p.y - e.deltaY,
			}));
		}
	}, []);

	useEffect(() => {
		const el = canvasViewportRef.current;
		if (!el) return;
		el.addEventListener("wheel", handleCanvasWheel, { passive: false });
		return () => el.removeEventListener("wheel", handleCanvasWheel);
	}, [handleCanvasWheel]);

	// Desplazamiento con botón central del ratón (rueda pulsada)
	useEffect(() => {
		if (!middleMousePanning) return;
		const { startClientX, startClientY, startPanX, startPanY } = middleMousePanning;
		document.body.style.cursor = "grabbing";
		document.body.style.userSelect = "none";
		const onMove = (e) => {
			setCanvasPan({
				x: startPanX + (e.clientX - startClientX),
				y: startPanY + (e.clientY - startClientY),
			});
		};
		const onUp = (e) => {
			if (e.button === 1) {
				setMiddleMousePanning(null);
			}
		};
		document.addEventListener("mousemove", onMove, true);
		document.addEventListener("mouseup", onUp, true);
		return () => {
			document.removeEventListener("mousemove", onMove, true);
			document.removeEventListener("mouseup", onUp, true);
			document.body.style.cursor = "";
			document.body.style.userSelect = "";
		};
	}, [middleMousePanning]);

	const playPage = pages[playPageIndex] || pages[0];
	const playElements = getElementsForViewport(playPage, playViewport);
	const isPlayRegPage = (playPage?.pageId || playPage?._id) === REGISTRATION_PAGE_ID;
	const invertPlayTransition = (t) =>
		t === "slideLeft"
			? "slideRight"
			: t === "slideRight"
				? "slideLeft"
				: t === "slideUp"
					? "slideDown"
					: t === "slideDown"
						? "slideUp"
						: t;

	const openHintPlayModal = (hintEl, which, penalty = 0) => {
		if (!hintEl) return false;
		const c = hintEl.content || {};
		const sizeKey = which === "confirm" ? "confirmModalSize" : "hintModalSize";
		const designKey = which === "confirm" ? "confirmModalDesign" : "hintModalDesign";
		const sizeDef = MODAL_SIZES.find((s) => s.id === (c[sizeKey] || "medium")) || MODAL_SIZES[1];
		let design = c[designKey];
		if (!design) return false;
		if (which === "confirm") {
			const els = design.elements || [];
			const hasCancel = els.some((e) => e.type === "button" && (e.content?.action === "cancelHint" || e.content?.action === "closeModal"));
			const hasConfirm = els.some((e) => e.type === "button" && e.content?.action === "confirmHint");
			let elements = [...els];
			const w = sizeDef.width;
			const h = sizeDef.height;
			if (!hasCancel) {
				elements.push({
					...defaultElement("button"),
					elementId: genId(),
					x: 24, y: h - 60, width: 160, height: 44,
					content: { action: "cancelHint", label: "Cancelar", icon: "", iconPosition: "before" },
					style: { fontFamily: "Arial, sans-serif", fontSize: 16, fontWeight: "bold", color: "rgba(51, 51, 51, 1)", backgroundColor: "transparent", textAlign: "center", borderRadius: 8 },
				});
			}
			if (!hasConfirm) {
				elements.push({
					...defaultElement("button"),
					elementId: genId(),
					x: w - 184, y: h - 60, width: 160, height: 44,
					content: { action: "confirmHint", label: "Confirmar", icon: "", iconPosition: "before" },
					style: { fontFamily: "Arial, sans-serif", fontSize: 16, fontWeight: "bold", color: "rgba(255, 255, 255, 1)", backgroundColor: "rgba(124, 58, 237, 1)", textAlign: "center", borderRadius: 8 },
				});
			}
			design = { ...design, elements };
		}
		setPlayModalContent({
			design,
			width: sizeDef.width,
			height: sizeDef.height,
			hintContext: { elementId: hintEl.elementId, penalty, step: which },
		});
		return true;
	};

	const handlePlayHintModal = (payload) => {
		// Fallback legacy: usar dialogs si no hay designs
		if (!payload?.elementId) {
			setPlayHintModal(payload || null);
			return;
		}
		const hintEl = (playElements || []).find((e) => e.elementId === payload.elementId);
		const c = hintEl?.content || {};
		const penalty = payload.penalty ?? (c.hintPenalty ?? 0);
		if (payload.type === "confirm") {
			if (!openHintPlayModal(hintEl, "confirm", penalty)) setPlayHintModal(payload);
			return;
		}
		if (payload.type === "hint") {
			if (!openHintPlayModal(hintEl, "hint", penalty)) setPlayHintModal(payload);
		}
	};

	const handlePlayButtonAction = (el) => {
		const registerButtonActivated = () => {
			if (!el?.elementId || el?.type !== "button") return;
			setPlayActivatedByPage((prev) => {
				const key = String(playPageIndex);
				const next = { ...prev };
				next[key] = new Set(prev[key] || []);
				next[key].add(el.elementId);
				return next;
			});
		};
		const action = el?.content?.action;
		if (action === "none") {
			registerButtonActivated();
			return;
		}
		if (action === "closeModal") {
			registerButtonActivated();
			setPlayModalContent(null);
			return;
		}
		if (action === "cancelHint") {
			setPlayModalContent(null);
			return;
		}
		if (action === "confirmHint") {
			const ctx = playModalContent?.hintContext;
			if (ctx?.elementId) {
				if (ctx.penalty > 0) handleQuizHintUsed(ctx.elementId, ctx.penalty);
				const hintEl = (playElements || []).find((e) => e.elementId === ctx.elementId);
				if (!openHintPlayModal(hintEl, "hint", ctx.penalty || 0)) setPlayModalContent(null);
			} else {
				setPlayModalContent(null);
			}
			return;
		}
		if (action === "nextPage") {
			setPlayModalContent(null);
			registerButtonActivated();
			if (playPageIndex < pages.length - 1) {
				const next = playPageIndex + 1;
				playSuppressBranchAlternates(pages[next]?.scenarioId, pages, setPlaySuppressedScenarioIds);
				const pg = pages[playPageIndex];
				setPlayTransitionType(pg?.transitionToNext || "none");
				setPlayTransitionDuration(pg?.transitionDuration ?? 350);
				setPlayTransitionKey((k) => k + 1);
				setPlayPageIndex((i) => i + 1);
			} else {
				setPlayShowResults(true);
			}
		} else if (action === "prevPage") {
			setPlayModalContent(null);
			registerButtonActivated();
			if (playPageIndex > 0) {
				const pg = pages[playPageIndex - 1];
				setPlayTransitionType(invertPlayTransition(pg?.transitionToNext || "none"));
				setPlayTransitionDuration(pg?.transitionDuration ?? 350);
				setPlayTransitionKey((k) => k + 1);
				setPlayPageIndex((i) => i - 1);
			}
		} else if (action === "goToPage" && el?.content?.targetPageId) {
			setPlayModalContent(null);
			registerButtonActivated();
			const targetIdx = pages.findIndex((p) => (p.pageId || p._id) === el.content.targetPageId);
			if (targetIdx >= 0 && targetIdx !== playPageIndex) {
				playSuppressBranchAlternates(pages[targetIdx]?.scenarioId, pages, setPlaySuppressedScenarioIds);
				setPlayTransitionType("fade");
				setPlayTransitionDuration(300);
				setPlayTransitionKey((k) => k + 1);
				setPlayPageIndex(targetIdx);
			}
		} else if (action === "openModal" && el?.content?.modalDesign) {
			registerButtonActivated();
			const sizeDef = MODAL_SIZES.find((s) => s.id === (el.content?.modalSize || "medium")) || MODAL_SIZES[1];
			setPlayModalContent({
				design: el.content.modalDesign,
				width: sizeDef.width,
				height: sizeDef.height,
			});
		} else if (action === "addPoints") {
			registerButtonActivated();
			const delta = Number(el?.content?.pointsDelta);
			if (Number.isFinite(delta) && delta !== 0) {
				setPlayTotalPoints((prev) => (prev || 0) + delta);
			}
		}
	};
	const handlePlayPrev = () => {
		if (playPageIndex <= 0) return;
		const pg = pages[playPageIndex - 1];
		setPlayTransitionType(invertPlayTransition(pg?.transitionToNext || "none"));
		setPlayTransitionDuration(pg?.transitionDuration ?? 350);
		setPlayTransitionKey((k) => k + 1);
		setPlayPageIndex((i) => i - 1);
	};
	const handlePlayNext = () => {
		if (playPageIndex >= pages.length - 1) {
			setPlayShowResults(true);
			return;
		}
		const next = playPageIndex + 1;
		playSuppressBranchAlternates(pages[next]?.scenarioId, pages, setPlaySuppressedScenarioIds);
		const pg = pages[playPageIndex];
		setPlayTransitionType(pg?.transitionToNext || "none");
		setPlayTransitionDuration(pg?.transitionDuration ?? 350);
		setPlayTransitionKey((k) => k + 1);
		setPlayPageIndex((i) => i + 1);
	};
	const handleExitPlay = () => {
		if (document.exitFullscreen) document.exitFullscreen();
		else if (document.webkitExitFullscreen) document.webkitExitFullscreen();
		setPlayMode(false);
		setPlayQuizAnswers({});
		setPlayActivatedByPage({});
		setPlayTotalPoints(0);
		setPlaySuppressedScenarioIds(new Set());
		playLandingAwardedRef.current = new Set();
		setPlayModalContent(null);
		setPlayQuizFeedbackModal(null);
		setPlayShowResults(false);
	};
	const handleQuizOptionSelect = (elementId, optionIndex, correct) => {
		const el =
			playElements.find((e) => e.elementId === elementId) ||
			(playModalContent?.design?.elements || []).find((e) => e.elementId === elementId);
		const quiz = el?.content?.quizId ? quizzes.find((q) => String(q?._id) === String(el.content.quizId)) : null;
		const attemptMode = quiz?.attemptMode || (quiz?.allowMultipleAttempts ? "unlimited" : "single");
		const maxAttempts = Math.max(1, quiz?.maxAttempts ?? 3);
		const opts = quiz?.questions?.[0]?.options || [];
		const totalCorrectCount = opts.filter((o) => o?.correct).length;
		const current = playQuizAnswers[elementId];
		const prevSelections = current?.selections || (current?.selectedIndex != null ? [{ optionIndex: current.selectedIndex, correct: current.correct }] : []);
		if (prevSelections.some((s) => s.optionIndex === optionIndex)) return;
		const hintSources = [
			...(playElements || []),
			...(playModalContent?.design?.elements || []),
		];
		const hintPenaltyOnPage = hintSources
			.filter((e) => e.type === "hint")
			.reduce((sum, h) => sum + (playQuizAnswers[h.elementId]?.hintPenaltyUsed || 0), 0);
		const pointsCorrect = quiz?.pointsCorrect ?? 10;
		const pointsIncorrect = quiz?.pointsIncorrect ?? -5;
		const delta = correct ? pointsCorrect : pointsIncorrect;
		const newSelections = [...prevSelections, { optionIndex, correct }];
		const correctSelectedCount = newSelections.filter((s) => s.correct).length;
		const done = attemptMode === "single"
			? true
			: attemptMode === "limited"
				? correctSelectedCount >= totalCorrectCount || newSelections.length >= maxAttempts
				: correctSelectedCount >= totalCorrectCount;
		const totalPoints = newSelections.reduce((sum, s) =>
			sum + (s.correct ? pointsCorrect : pointsIncorrect), 0);
		const incorrectCount = newSelections.filter((s) => !s.correct).length;
		setPlayQuizAnswers((prev) => ({
			...prev,
			[elementId]: {
				selections: newSelections,
				done,
				hintPenaltyUsed: hintPenaltyOnPage,
				totalPoints,
			},
		}));
		setPlayQuizFeedbackModal({
			correct,
			delta,
			totalCorrect: totalCorrectCount,
			correctCount: correctSelectedCount,
			done,
			totalPoints,
			incorrectCount,
			explanation: quiz?.questions?.[0]?.explanation?.trim() || null,
		});
	};

	const handleQuizCustomAnswer = (elementId, answerType, data) => {
		const el =
			playElements.find((e) => e.elementId === elementId) ||
			(playModalContent?.design?.elements || []).find((e) => e.elementId === elementId);
		const quiz = el?.content?.quizId ? quizzes.find((q) => String(q?._id) === String(el.content.quizId)) : null;
		const isSurvey = String(quiz?.gradingMode || "").toLowerCase() === "survey";
		const pointsCorrect = quiz?.pointsCorrect ?? 10;
		const pointsIncorrect = quiz?.pointsIncorrect ?? -5;
		const current = playQuizAnswers[elementId] || {};
		const attemptCount = (current.attemptCount || 0) + 1;
		let correctCount = 0;
		let totalCount = 0;
		if (answerType === "match") {
			const firstQ = quiz?.questions?.[0];
			const correctPairs = new Set((firstQ?.matchPairs || []).map(([l, r]) => `${l}:${r}`));
			totalCount = (firstQ?.matchLeft || []).length;
			correctCount = (data?.pairs || []).filter(([l, r]) => correctPairs.has(`${l}:${r}`)).length;
		} else if (answerType === "fillBlanks") {
			const firstQ = quiz?.questions?.[0];
			const blanks = (firstQ?.segments || []).filter((s) => s.type === "blank");
			totalCount = blanks.length;
			correctCount = (data?.blanks || []).filter((b) => {
				const seg = blanks.find((s) => s.blankId === b.blankId);
				return seg && String((seg.correctAnswer || "").trim()).toLowerCase() === String((b.answer || "").trim()).toLowerCase();
			}).length;
		} else if (answerType === "textAnswer") {
			const firstQ = quiz?.questions?.[0];
			const submitted = String(data?.text || "").trim();
			totalCount = 1;
			correctCount = isSurvey || quizTextAnswersMatch(submitted, firstQ?.correctAnswer || "") ? 1 : 0;
		}
		const incorrectCount = isSurvey ? 0 : Math.max(0, totalCount - correctCount);
		const allCorrect = isSurvey ? true : (correctCount >= totalCount && totalCount > 0);
		const isCorrect = allCorrect;
		const totalPoints = accumulateCustomQuizPoints({
			quiz,
			isSurvey,
			isCorrect,
			pointsCorrect,
			pointsIncorrect,
			previousTotal: current.totalPoints ?? 0,
		});
		const delta = isSurvey ? 0 : (isCorrect ? pointsCorrect : pointsIncorrect);
		const done = resolveCustomQuizDone({ quiz, isSurvey, allCorrect, attemptCount });
		setPlayQuizAnswers((prev) => ({
			...prev,
			[elementId]: answerType === "match"
				? { pairs: data?.pairs || [], confirmed: true, correct: isCorrect, done, attemptCount, totalPoints }
				: answerType === "textAnswer"
					? { text: data?.text || "", confirmed: true, correct: isCorrect, done, attemptCount, totalPoints }
					: { blanks: data?.blanks || [], confirmed: true, correct: isCorrect, done, attemptCount, totalPoints },
		}));
		const firstQ = quiz?.questions?.[0];
		setPlayQuizFeedbackModal({
			correct: allCorrect,
			delta,
			totalCorrect: totalCount,
			correctCount,
			done,
			totalPoints,
			incorrectCount,
			explanation: firstQ?.explanation?.trim() || null,
		});
	};
	const handleQuizHintUsed = (elementId, penalty) => {
		if (penalty > 0) {
			setPlayTotalPoints((prev) => prev - penalty);
			setPlayQuizAnswers((prev) => {
				const current = prev[elementId] || {};
				return { ...prev, [elementId]: { ...current, hintPenaltyUsed: (current.hintPenaltyUsed || 0) + penalty } };
			});
		}
	};
	const bgImgUrl = playPage?.backgroundImageUrl;
	const bgImgResolved = bgImgUrl ? resolveEscapeRoomMediaUrl(bgImgUrl) : null;
	const playViewportDim = VIEWPORTS.find((v) => v.id === playViewport) || { width: CANVAS_WIDTH, height: CANVAS_HEIGHT };

	return (
		<>
			<style>{`
				@keyframes quiz-option-correct {
					0% { transform: scale(1); box-shadow: 0 1px 4px rgba(0,0,0,0.06); }
					50% { transform: scale(1.04); box-shadow: 0 6px 20px rgba(34,197,94,0.45); }
					100% { transform: scale(1); box-shadow: 0 2px 10px rgba(34,197,94,0.25); }
				}
				@keyframes quiz-option-incorrect {
					0%, 100% { transform: translateX(0); }
					20% { transform: translateX(-8px); }
					40% { transform: translateX(8px); }
					60% { transform: translateX(-5px); }
					80% { transform: translateX(5px); }
				}
				@keyframes er-editor-btn-heartbeat {
					0%, 100% { transform: scale(0.97); }
					12% { transform: scale(1.03); }
					26% { transform: scale(0.97); }
					40% { transform: scale(1.01); }
					54% { transform: scale(0.97); }
				}
				.er-editor-btn-heartbeat {
					animation: er-editor-btn-heartbeat 1.4s ease-in-out infinite;
					transform-origin: center center;
				}
				@keyframes er-modal-overlay-in { from { opacity: 0; } to { opacity: 1; } }
				@keyframes er-modal-content-in { from { opacity: 0; transform: scale(0.94); } to { opacity: 1; transform: scale(1); } }
			`}</style>
			<Menu
				open={!!contextMenu}
				onClose={() => setContextMenu(null)}
				anchorReference="anchorPosition"
				anchorPosition={contextMenu ? { top: contextMenu.mouseY, left: contextMenu.mouseX } : undefined}
				MenuListProps={{ style: { minWidth: 200 } }}
			>
				<MenuItem onClick={() => { copyElement(); setContextMenu(null); }} disabled={!selectedElement || selectedElement.registrationLocked}>
					<ListItemIcon><FileCopyIcon fontSize="small" /></ListItemIcon>
					<ListItemText>Copiar</ListItemText>
				</MenuItem>
				<MenuItem onClick={() => { pasteElement(); setContextMenu(null); }} disabled={!copiedElement}>
					<ListItemIcon><AssignmentIcon fontSize="small" /></ListItemIcon>
					<ListItemText>Pegar</ListItemText>
				</MenuItem>
				<MenuItem onClick={() => { reorderElement("front"); setContextMenu(null); }} disabled={!selectedElement || selectedElement.registrationLocked}>
					<ListItemIcon><FlipToFrontIcon fontSize="small" /></ListItemIcon>
					<ListItemText>Tirar hacia delante</ListItemText>
				</MenuItem>
				<MenuItem onClick={() => { reorderElement("back"); setContextMenu(null); }} disabled={!selectedElement || selectedElement.registrationLocked}>
					<ListItemIcon><FlipToBackIcon fontSize="small" /></ListItemIcon>
					<ListItemText>Tirar hacia atrás</ListItemText>
				</MenuItem>
				<MenuItem onClick={() => { duplicateElement(); setContextMenu(null); }} disabled={!selectedElement || selectedElement.registrationLocked}>
					<ListItemIcon><ControlPointDuplicateIcon fontSize="small" /></ListItemIcon>
					<ListItemText>Duplicar</ListItemText>
				</MenuItem>
				<MenuItem onClick={() => { copyStyle(); setContextMenu(null); }} disabled={!selectedElement || selectedElement.registrationLocked}>
					<ListItemIcon><FormatPaintIcon fontSize="small" /></ListItemIcon>
					<ListItemText>Copiar estilo</ListItemText>
				</MenuItem>
				<MenuItem onClick={() => { pasteStyle(); setContextMenu(null); }} disabled={!copiedStyle || !selectedElement || selectedElement.registrationLocked}>
					<ListItemIcon><PaletteIcon fontSize="small" /></ListItemIcon>
					<ListItemText>Pegar estilo</ListItemText>
				</MenuItem>
				<MenuItem onClick={() => { effectiveRemoveElement(selectedElement?.elementId); setContextMenu(null); }} disabled={!selectedElement || selectedElement.registrationLocked} style={{ color: "#dc2626" }}>
					<ListItemIcon><DeleteIcon fontSize="small" style={{ color: "#dc2626" }} /></ListItemIcon>
					<ListItemText>Eliminar elemento</ListItemText>
				</MenuItem>
			</Menu>
			{playMode ? (
		<PlayModeView
			playModeContainerRef={playModeContainerRef}
			pages={pages}
			playPageIndex={playPageIndex}
			playViewport={playViewport}
			playViewportDim={playViewportDim}
			playScale={playScale}
			setPlayScale={setPlayScale}
			setPlayMode={setPlayMode}
			setPlayViewport={setPlayViewport}
			playTransitionKey={playTransitionKey}
			playTransitionType={playTransitionType}
			playTransitionDuration={playTransitionDuration}
			setPlayTransitionType={setPlayTransitionType}
			setPlayTransitionDuration={setPlayTransitionDuration}
			setPlayTransitionKey={setPlayTransitionKey}
			setPlayPageIndex={setPlayPageIndex}
			playPage={playPage}
			playElements={playElements}
			isPlayRegPage={isPlayRegPage}
			bgImgResolved={bgImgResolved}
			handlePlayButtonAction={handlePlayButtonAction}
			handlePlayPrev={handlePlayPrev}
			handlePlayNext={handlePlayNext}
			handleExitPlay={handleExitPlay}
			handleQuizOptionSelect={handleQuizOptionSelect}
			handleQuizCustomAnswer={handleQuizCustomAnswer}
			handleQuizHintUsed={handleQuizHintUsed}
			setPlayHintModal={handlePlayHintModal}
			playHintModal={playHintModal}
			playQuizAnswers={playQuizAnswers}
			playTotalPoints={playTotalPoints}
			playModalContent={playModalContent}
			setPlayModalContent={setPlayModalContent}
			playQuizFeedbackModal={playQuizFeedbackModal}
			setPlayQuizFeedbackModal={setPlayQuizFeedbackModal}
			quizzes={quizzes}
			scenarios={scenariosRaw}
			playActivatedByPage={playActivatedByPage}
			playFooterOpen={playFooterOpen}
			setPlayFooterOpen={setPlayFooterOpen}
			playSuppressedScenarioIds={playSuppressedScenarioIds}
			playShowResults={playShowResults}
			onCloseResults={handleExitPlay}
		/>
			) : (
		<>
		<Box display="flex" flexDirection="column" height="100vh">
			{/* Barra superior */}
			<Box display="flex" alignItems="center" justifyContent="space-between" px={2} py={1} borderBottom={1} borderColor="divider">
				<TextField
					value={name}
					onChange={(e) => setName(e.target.value)}
					placeholder="Nombre del escape room"
					variant="outlined"
					size="small"
					style={{ minWidth: 200 }}
				/>
				<Box display="flex" alignItems="center" style={{ gap: 4 }}>
					<Tooltip title="Deshacer (Ctrl+Z)">
						<span>
							<IconButton size="small" onClick={performUndo} disabled={!canUndo}>
								<UndoIcon fontSize="small" />
							</IconButton>
						</span>
					</Tooltip>
					<Tooltip title="Rehacer (Ctrl+Y)">
						<span>
							<IconButton size="small" onClick={performRedo} disabled={!canRedo}>
								<RedoIcon fontSize="small" />
							</IconButton>
						</span>
					</Tooltip>
					<Box style={{ width: 1, height: 20, backgroundColor: "#ddd", margin: "0 4px" }} />
					<Tooltip title="Copiar (Ctrl+C)">
						<span>
							<IconButton size="small" onClick={copyElement} disabled={!selectedElement || selectedElement.registrationLocked}>
								<FileCopyIcon fontSize="small" />
							</IconButton>
						</span>
					</Tooltip>
					<Tooltip title="Pegar (Ctrl+V)">
						<span>
							<IconButton size="small" onClick={pasteElement} disabled={!copiedElement}>
								<AssignmentIcon fontSize="small" />
							</IconButton>
						</span>
					</Tooltip>
					<Tooltip title="Duplicar (Ctrl+D)">
						<span>
							<IconButton size="small" onClick={duplicateElement} disabled={!selectedElement || selectedElement.registrationLocked}>
								<ControlPointDuplicateIcon fontSize="small" />
							</IconButton>
						</span>
					</Tooltip>
					<Tooltip title="Copiar estilo (Ctrl+Shift+C)">
						<span>
							<IconButton size="small" onClick={copyStyle} disabled={!selectedElement || selectedElement.registrationLocked}>
								<FormatPaintIcon fontSize="small" />
							</IconButton>
						</span>
					</Tooltip>
					<Tooltip title="Pegar estilo (Ctrl+Shift+V)">
						<span>
							<IconButton size="small" onClick={pasteStyle} disabled={!copiedStyle || !selectedElement || selectedElement.registrationLocked}>
								<PaletteIcon fontSize="small" />
							</IconButton>
						</span>
					</Tooltip>
					<Box style={{ width: 1, height: 20, backgroundColor: "#ddd", margin: "0 4px" }} />
					<Tooltip title="Traer adelante un paso">
						<span>
							<IconButton size="small" onClick={() => reorderElement("forward")} disabled={!selectedElement || selectedElement.registrationLocked}>
								<ArrowUpwardIcon fontSize="small" />
							</IconButton>
						</span>
					</Tooltip>
					<Tooltip title="Enviar atrás un paso">
						<span>
							<IconButton size="small" onClick={() => reorderElement("backward")} disabled={!selectedElement || selectedElement.registrationLocked}>
								<ArrowDownwardIcon fontSize="small" />
							</IconButton>
						</span>
					</Tooltip>
					<Tooltip title="Traer al frente">
						<span>
							<IconButton size="small" onClick={() => reorderElement("front")} disabled={!selectedElement || selectedElement.registrationLocked}>
								<FlipToFrontIcon fontSize="small" />
							</IconButton>
						</span>
					</Tooltip>
					<Tooltip title="Enviar atrás">
						<span>
							<IconButton size="small" onClick={() => reorderElement("back")} disabled={!selectedElement || selectedElement.registrationLocked}>
								<FlipToBackIcon fontSize="small" />
							</IconButton>
						</span>
					</Tooltip>
				</Box>
				<Box display="flex" alignItems="center" style={{ gap: 12 }}>
					<Button
						variant="outlined"
						size="small"
						className="er-editor-play-btn"
						startIcon={<PlayArrowIcon style={{ fontSize: 18, color: "#64748b" }} />}
						onClick={() => {
							setPlayTotalPoints(0);
							playLandingAwardedRef.current = new Set();
							setPlaySuppressedScenarioIds(new Set());
							setPlayPageIndex(currentPageIndex);
							setPlayViewport(activeViewport);
							setPlayMode(true);
						}}
						style={{
							textTransform: "none",
							borderRadius: 8,
							padding: "5px 12px",
							fontSize: 13,
							fontWeight: 600,
							color: "#334155",
							borderColor: "#e2e8f0",
							backgroundColor: "#fff",
							boxShadow: "none",
							minHeight: 32,
						}}
					>
						Reproducir
					</Button>
					<Box fontSize={12} color={saving ? "#64748b" : "#94a3b8"} display="flex" alignItems="center" style={{ gap: 6 }}>
						{saving ? "Guardando…" : "Guardado automático"}
					</Box>
					{onDelete && (
						<Button color="secondary" onClick={onDelete} style={{ marginLeft: 8 }}>
							Eliminar
						</Button>
					)}
				</Box>
			</Box>

			<Box display="flex" flex={1} overflow="hidden" minHeight={0}>
				{/* Panel izquierdo: páginas */}
				<Box width={180} borderRight={1} borderColor="divider" display="flex" flexDirection="column" minHeight={0} flexShrink={0}>
					<Box p={1.5} flexShrink={0}>
						<Box fontWeight="bold" fontSize={13} color="#1e293b">
							Páginas
						</Box>
						<Box fontSize={11} color="#64748b" mt={0.25}>Clic en una página para editarla</Box>
					</Box>
					<Box flex={1} minHeight={0} px={1.5} pb={1} style={{ overflowY: "auto", overflowX: "hidden" }} onDragOver={handleSidebarPageDragOver}>
					{getPagesGroupedByScenario().map((group, groupIdx) => {
						const isRegScenario = isRegistrationScenario(group.scenario);
						const targetScId = isRegScenario ? REGISTRATION_SCENARIO_ID : group.scenario?.id || "";
						return (
							<Box key={group.scenario ? `sc-${group.scenario.id}-${groupIdx}` : `reg-${groupIdx}`} mb={1.5}>
								<Box display="flex" alignItems="center" style={{ gap: 6, marginBottom: 6 }}>
									{isRegScenario ? (
										<>
											<AssignmentIcon style={{ fontSize: 16, color: "#64748b" }} />
											<Box fontSize={11} fontWeight={600} color="#334155" flex={1}>Registro</Box>
											{scenariosRaw.length > 1 && (
												<Tooltip title="Más opciones">
													<IconButton size="small" style={{ padding: 2, flexShrink: 0 }} onClick={(e) => {
														e.stopPropagation();
														const sorted = [...scenariosRaw].sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
														setScenarioMenuAnchor(e.currentTarget);
														setScenarioMenuIdx(sorted.findIndex((s) => isRegistrationScenario(s)));
													}}>
														<MoreVertIcon style={{ fontSize: 14 }} />
													</IconButton>
												</Tooltip>
											)}
										</>
									) : (
										<>
											{(() => {
												const rawSid = group.pageIndices.length ? pages[group.pageIndices[0]]?.scenarioId : group.scenario?.id;
												const resolvedSc = scenariosRaw.find((s) => String(s.id) === String(rawSid ?? ""));
												const scModel = resolvedSc || group.scenario;
												if (!scModel) return null;
												const editKey = String(scModel.id);
												const scIdx = scenariosRaw.findIndex((s) => String(s.id) === editKey);
												const IconComp = scModel.icon && BUTTON_ICON_MAP[scModel.icon] ? BUTTON_ICON_MAP[scModel.icon] : FlagIcon;
												const displayName = scenariosRaw.find((s) => String(s.id) === editKey)?.name ?? scModel.name ?? "";
												const commitScenarioName = () => {
													window.clearTimeout(scenarioNameBlurTimerRef.current);
													scenarioNameBlurTimerRef.current = null;
													setScenariosRaw((prev) => {
														const sc = prev.find((s) => String(s.id) === editKey);
														if (!sc) return prev;
														const order = prev.slice().sort((a, b) => (a.order ?? 0) - (b.order ?? 0)).findIndex((s) => String(s.id) === editKey);
														if (!String(sc.name || "").trim()) {
															return prev.map((s) => (String(s.id) === editKey ? { ...s, name: `Escenario ${order + 1}` } : s));
														}
														return prev;
													});
													setEditingScenarioId(null);
												};
												const scheduleBlurCommit = () => {
													window.clearTimeout(scenarioNameBlurTimerRef.current);
													scenarioNameBlurTimerRef.current = window.setTimeout(commitScenarioName, 280);
												};
												return (
													<>
														<Tooltip title="Cambiar icono">
															<Box
																onClick={(e) => {
																	e.stopPropagation();
																	setScenarioIconPickerSearch("");
																	setScenarioIconPickerIdx(scIdx >= 0 ? scIdx : 0);
																}}
																display="flex"
																alignItems="center"
																justifyContent="center"
																style={{
																	cursor: "pointer",
																	padding: 4,
																	margin: -4,
																	borderRadius: 6,
																	flexShrink: 0,
																}}
																onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = "rgba(124,58,237,0.12)"; }}
																onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = "transparent"; }}
															>
																<IconComp style={{ fontSize: 16, color: "#5b21b6" }} />
															</Box>
														</Tooltip>
														<Box fontSize={11} fontWeight={600} color="#334155" flex={1} minWidth={0} overflow="hidden" display="flex" alignItems="center" style={{ minHeight: 40 }}>
															{String(editingScenarioId) === editKey ? (
																<TextField
																	size="small"
																	fullWidth
																	variant="outlined"
																	value={displayName}
																	onChange={(e) => {
																		const name = e.target != null ? e.target.value : "";
																		setScenariosRaw((prev) => prev.map((s) => (String(s.id) === editKey ? { ...s, name } : s)));
																	}}
																	onFocus={() => {
																		window.clearTimeout(scenarioNameBlurTimerRef.current);
																		scenarioNameBlurTimerRef.current = null;
																	}}
																	onBlur={scheduleBlurCommit}
																	onKeyDown={(e) => {
																		if (e.key === "Enter") {
																			e.preventDefault();
																			window.clearTimeout(scenarioNameBlurTimerRef.current);
																			commitScenarioName();
																		}
																		if (e.key === "Escape") {
																			e.preventDefault();
																			window.clearTimeout(scenarioNameBlurTimerRef.current);
																			setEditingScenarioId(null);
																		}
																	}}
																	inputRef={(el) => {
																		scenarioNameInputRef.current = el;
																	}}
																	inputProps={{ style: { fontSize: 11, fontWeight: 600, padding: "8px 10px" } }}
																	onClick={(e) => e.stopPropagation()}
																	onMouseDown={(e) => e.stopPropagation()}
																/>
															) : (
																<button
																	type="button"
																	title="Clic para editar el nombre"
																	onMouseDown={(e) => {
																		e.stopPropagation();
																		e.preventDefault();
																		window.clearTimeout(scenarioNameBlurTimerRef.current);
																		setEditingScenarioId(editKey);
																	}}
																	style={{
																		width: "100%",
																		minHeight: 36,
																		margin: 0,
																		padding: "6px 8px",
																		border: "none",
																		borderRadius: 6,
																		background: "transparent",
																		cursor: "text",
																		fontSize: 11,
																		fontWeight: 600,
																		color: "#334155",
																		textAlign: "left",
																		overflow: "hidden",
																		textOverflow: "ellipsis",
																		whiteSpace: "nowrap",
																		fontFamily: "inherit",
																	}}
																	onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = "rgba(124,58,237,0.08)"; }}
																	onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = "transparent"; }}
																>
																	{scModel.name || "Escenario"}
																</button>
															)}
														</Box>
													</>
												);
											})()}
											{scenariosRaw.length > 1 && (
												<Tooltip title="Más opciones">
													<IconButton size="small" style={{ padding: 2, flexShrink: 0 }} onClick={(e) => { e.stopPropagation(); setScenarioMenuAnchor(e.currentTarget); setScenarioMenuIdx(scenariosRaw.findIndex((s) => s.id === group.scenario.id)); }}>
														<MoreVertIcon style={{ fontSize: 14 }} />
													</IconButton>
												</Tooltip>
											)}
										</>
									)}
								</Box>
								<Box onDragOver={handleSidebarPageDragOver} onDrop={(e) => handleSidebarPageDrop(e, -1, targetScId)} style={{ minHeight: group.pageIndices.length === 0 ? 36 : 20, marginBottom: 6, borderRadius: 6, border: "2px dashed transparent" }} sx={{ "&:hover": { borderColor: "#94a3b8", backgroundColor: "rgba(124,58,237,0.08)" } }} />
								{!isRegScenario && group.pageIndices.length === 0 && (
									<Box mb={1} px={0.5}>
										<Box fontSize={10} color="#94a3b8" mb={0.75} fontStyle="italic">
											Sin páginas
										</Box>
										<Button size="small" fullWidth variant="outlined" onClick={() => addPage(targetScId)} style={{ textTransform: "none", fontSize: 11, padding: "4px 8px", borderColor: "#e2e8f0", color: "#64748b" }}>
											+ Añadir página
										</Button>
									</Box>
								)}
								{group.pageIndices.map((idx) => {
									const page = pages[idx];
									const isRegistration = (page?.pageId || page?._id) === REGISTRATION_PAGE_ID;
									return (
										<Box
											key={`sidebar-pg-${idx}-${page.pageId || page._id || "p"}`}
											onDragOver={handleSidebarPageDragOver}
											onDrop={(e) => handleSidebarPageDrop(e, idx, targetScId)}
											style={{ marginBottom: 6 }}
										>
											<Box
												draggable
												onDragStart={(e) => {
													setDraggingPageIdx(idx);
													e.dataTransfer.setData("application/json", JSON.stringify({ pageIdx: idx }));
													e.dataTransfer.setData("text/plain", "page-" + idx);
													e.dataTransfer.effectAllowed = "move";
													e.dataTransfer.setDragImage(e.currentTarget, 0, 0);
													e.stopPropagation();
												}}
												onDragEnd={() => setDraggingPageIdx(null)}
												onClick={() => {
													setCurrentPageIndex(idx);
													setSelectedElement(null);
												}}
												onContextMenu={(e) => {
													e.preventDefault();
													e.stopPropagation();
													setCurrentPageIndex(idx);
													setSelectedElement(null);
													setPageMenuAnchor(null);
													setPageMenuPosition({ mouseX: e.clientX, mouseY: e.clientY });
													setPageMenuIdx(idx);
												}}
												style={{
													position: "relative",
													cursor: "grab",
													border: currentPageIndex === idx ? "2px solid #1976d2" : "1px solid #ddd",
													borderRadius: 6,
													padding: 4,
													backgroundColor: currentPageIndex === idx ? "#e8f4fd" : "#fff",
													boxShadow: currentPageIndex === idx ? "0 2px 6px rgba(25,118,210,0.2)" : "0 1px 2px rgba(0,0,0,0.08)",
													opacity: draggingPageIdx === idx ? 0.65 : 1,
												}}
												sx={{ "& *": { WebkitUserDrag: "none", userSelect: "none" } }}
											>
												<PagePreviewThumbnail
													elements={page.elements}
													registrationDesign={isRegistration ? page.registrationDesign : undefined}
													isRegistration={isRegistration}
													backgroundColor={!isRegistration ? page.backgroundColor : undefined}
													backgroundImageUrl={!isRegistration && page.backgroundImageUrl ? resolveEscapeRoomMediaUrl(page.backgroundImageUrl) : undefined}
													backgroundImageOpacity={!isRegistration ? page.backgroundImageOpacity : undefined}
													quizzes={quizzes}
												/>
												{!isRegistration && (
													<IconButton
														size="small"
														onClick={(e) => { e.stopPropagation(); setPageMenuPosition(null); setPageMenuAnchor(e.currentTarget); setPageMenuIdx(idx); }}
														onDragStart={(e) => e.stopPropagation()}
														style={{ position: "absolute", top: 2, right: 2, backgroundColor: "rgba(255,255,255,0.9)", width: 24, height: 24, padding: 0 }}
													>
														<MoreVertIcon style={{ fontSize: 16 }} />
													</IconButton>
												)}
											</Box>
										</Box>
									);
								})}
								<Box
									onDragOver={handleSidebarPageDragOver}
									onDrop={(e) => handleSidebarPageDrop(e, group.pageIndices[group.pageIndices.length - 1], targetScId)}
									style={{ minHeight: 20, marginBottom: 6, borderRadius: 6, border: "2px dashed transparent" }}
									sx={{ "&:hover": { borderColor: "#94a3b8", backgroundColor: "rgba(124,58,237,0.08)" } }}
								/>
							</Box>
						);
					})}
					<Box
						onClick={() => setAddPageTemplateDialogOpen(true)}
						style={{ marginTop: 6, marginBottom: 6, cursor: "pointer" }}
					>
						<Box
							style={{
								position: "relative",
								border: "1px dashed #cbd5e1",
								borderRadius: 6,
								padding: 4,
								backgroundColor: "#f8fafc",
								width: THUMB_WIDTH + 8,
								height: THUMB_HEIGHT + 8,
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
							}}
						>
							<AddIcon style={{ fontSize: 36, color: "#94a3b8" }} />
						</Box>
					</Box>
					</Box>
					<Menu
						anchorEl={pageMenuAnchor}
						open={pageMenuAnchor !== null || pageMenuPosition !== null}
						onClose={closePageMenu}
						anchorReference={pageMenuPosition ? "anchorPosition" : "anchorEl"}
						anchorPosition={pageMenuPosition ? { top: pageMenuPosition.mouseY, left: pageMenuPosition.mouseX } : undefined}
						anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
						transformOrigin={{ vertical: "top", horizontal: "right" }}
					>
						<MenuItem onClick={() => { if (pageMenuIdx !== null && pageMenuIdx > 0) { reorderPages(pageMenuIdx, pageMenuIdx - 1); closePageMenu(); } }} disabled={pageMenuIdx == null || pageMenuIdx <= 0}>
							<ListItemIcon><ArrowUpwardIcon fontSize="small" /></ListItemIcon>
							<ListItemText>Subir</ListItemText>
						</MenuItem>
						<MenuItem onClick={() => { if (pageMenuIdx !== null && pageMenuIdx < pages.length - 1) { reorderPages(pageMenuIdx, pageMenuIdx + 1); closePageMenu(); } }} disabled={pageMenuIdx == null || pageMenuIdx >= pages.length - 1}>
							<ListItemIcon><ArrowDownwardIcon fontSize="small" /></ListItemIcon>
							<ListItemText>Bajar</ListItemText>
						</MenuItem>
						<MenuItem onClick={() => { if (pageMenuIdx !== null) duplicatePage(pageMenuIdx); closePageMenu(); }} disabled={pageMenuIdx != null && (pages[pageMenuIdx]?.pageId || pages[pageMenuIdx]?._id) === REGISTRATION_PAGE_ID}>
							<ListItemIcon><ControlPointDuplicateIcon fontSize="small" /></ListItemIcon>
							<ListItemText>Duplicar</ListItemText>
						</MenuItem>
						{scenariosRaw && scenariosRaw.length > 1 && pageMenuIdx != null && !isErRegistrationPage(pages[pageMenuIdx]) && scenariosRaw.slice().sort((a, b) => (a.order ?? 0) - (b.order ?? 0)).filter((sc) => !isRegistrationScenario(sc) && (pages[pageMenuIdx]?.scenarioId || "") !== sc.id).map((sc) => (
							<MenuItem key={sc.id} onClick={() => { movePageToScenario(pageMenuIdx, sc.id); closePageMenu(); }}>
								<ListItemIcon style={{ minWidth: 28 }}><ArrowForwardIcon style={{ fontSize: 16 }} /></ListItemIcon>
								<ListItemText>Mover a {sc.name || sc.id}</ListItemText>
							</MenuItem>
						))}
						{pages.length > 1 && pageMenuIdx != null && (pages[pageMenuIdx]?.pageId || pages[pageMenuIdx]?._id) !== REGISTRATION_PAGE_ID && (
							<MenuItem onClick={() => { if (pageMenuIdx !== null) removePage(pageMenuIdx); closePageMenu(); }} style={{ color: "#d32f2f" }}>
								<ListItemIcon><DeleteIcon fontSize="small" style={{ color: "#d32f2f" }} /></ListItemIcon>
								<ListItemText>Eliminar</ListItemText>
							</MenuItem>
						)}
					</Menu>
					<Menu anchorEl={scenarioMenuAnchor} open={scenarioMenuAnchor !== null} onClose={() => { setScenarioMenuAnchor(null); setScenarioMenuIdx(null); }} anchorOrigin={{ vertical: "bottom", horizontal: "left" }} transformOrigin={{ vertical: "top", horizontal: "left" }}>
						{scenarioMenuIdx != null && scenarioMenuIdx >= 0 && (() => {
							const sortedScenarios = [...scenariosRaw].sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
							const sc = sortedScenarios[scenarioMenuIdx];
							if (!sc) return null;
							const sortedIdx = scenarioMenuIdx;
							const isRegMenu = isRegistrationScenario(sc);
							return (
								<>
									<MenuItem onClick={() => { if (sortedIdx > 0) reorderScenarios(sortedIdx, sortedIdx - 1); }} disabled={sortedIdx <= 0}>
										<ListItemIcon><ArrowUpwardIcon fontSize="small" /></ListItemIcon>
										<ListItemText>Subir</ListItemText>
									</MenuItem>
									<MenuItem onClick={() => { if (sortedIdx >= 0 && sortedIdx < sortedScenarios.length - 1) reorderScenarios(sortedIdx, sortedIdx + 1); }} disabled={sortedIdx < 0 || sortedIdx >= sortedScenarios.length - 1}>
										<ListItemIcon><ArrowDownwardIcon fontSize="small" /></ListItemIcon>
										<ListItemText>Bajar</ListItemText>
									</MenuItem>
									{!isRegMenu && getPlayableScenarios(scenariosRaw).length > 1 && (
										<MenuItem onClick={() => {
											const removedId = sc?.id;
											if (!removedId) return;
											const fallbackId = getDefaultPlayableScenarioId(scenariosRaw.filter((s) => String(s.id) !== String(removedId)));
											setScenariosRaw((prev) => prev.filter((s) => String(s.id) !== String(removedId)));
											if (fallbackId) setPages((prev) => prev.map((p) => (isErRegistrationPage(p) ? p : { ...p, scenarioId: (p.scenarioId || "") === removedId ? fallbackId : p.scenarioId })));
											setScenarioMenuAnchor(null);
											setScenarioMenuIdx(null);
										}} style={{ color: "#d32f2f" }}>
											<ListItemIcon><DeleteIcon fontSize="small" style={{ color: "#d32f2f" }} /></ListItemIcon>
											<ListItemText>Eliminar escenario</ListItemText>
										</MenuItem>
									)}
								</>
							);
						})()}
					</Menu>
				</Box>

				{/* Canvas central */}
				<Box flex={1} display="flex" flexDirection="column" overflow="hidden" bgcolor="#e5e7eb">
					<Box
						display="flex"
						alignItems="center"
						justifyContent="space-between"
						py={1}
						px={2}
						bgcolor="#f3f4f6"
						borderBottom="1px solid #e5e7eb"
						style={{ gap: 8 }}
					>
						<Box display="flex" alignItems="center" style={{ gap: 4 }}>
							{isModalEditMode ? (
								<>
									<Button
										size="small"
										variant="outlined"
										startIcon={<CloseIcon />}
										onClick={() => { setEditingModalButton(null); setEditingHintModal(null); setSelectedElement(null); }}
										style={{ textTransform: "none" }}
									>
										Cerrar editor de modal
									</Button>
									<Box fontSize={12} color="#64748b" ml={1}>
										Modal {modalDim?.label} ({effectiveViewportDim?.width}×{effectiveViewportDim?.height})
									</Box>
								</>
							) : (
								<>
									{VIEWPORTS.map((vp) => {
										const Icon = vp.Icon;
										return (
										<Tooltip key={vp.id} title={vp.label} placement="bottom">
											<IconButton
												size="small"
												onClick={() => setActiveViewport(vp.id)}
												style={{
													backgroundColor: activeViewport === vp.id ? "#7c3aed" : "transparent",
													color: activeViewport === vp.id ? "#fff" : "#64748b",
												}}
											>
												<Icon fontSize="small" />
											</IconButton>
										</Tooltip>
										);
									})}
									<Box fontSize={11} color="#64748b" ml={0.5}>
										{viewportDim.width}×{viewportDim.height}
									</Box>
								</>
							)}
							{!isModalEditMode && activeViewport !== "desktop" && !isRegistrationPage && (
								<Tooltip title="Aplicar diseño de escritorio (se adaptará al tamaño actual)">
									<Button
										size="small"
										variant="outlined"
										onClick={() => {
											setPages((p) => {
												const next = [...p];
												const page = next[currentPageIndex];
												page.elements = (page.elements || []).map((e) => {
													const { [activeViewport]: _, ...rest } = e.breakpoints || {};
													return { ...e, breakpoints: Object.keys(rest).length ? rest : undefined };
												});
												return next;
											});
										}}
										style={{ marginLeft: 8, fontSize: 10 }}
									>
										Desde escritorio
									</Button>
								</Tooltip>
							)}
						</Box>
						<Box display="flex" alignItems="center" style={{ gap: 8 }}>
						<Tooltip title="Alejar (Ctrl-)">
							<IconButton size="small" onClick={() => setCanvasZoom((z) => Math.max(ZOOM_MIN, z - ZOOM_STEP))}>
								<Box fontSize={18} fontWeight="bold" style={{ lineHeight: 1 }}>−</Box>
							</IconButton>
						</Tooltip>
						<Box fontSize={12} fontWeight={600} minWidth={48} textAlign="center">
							{Math.round(canvasZoom * 100)}%
						</Box>
						<Tooltip title="Acercar (Ctrl+)">
							<IconButton size="small" onClick={() => setCanvasZoom((z) => Math.min(ZOOM_MAX, z + ZOOM_STEP))}>
								<Box fontSize={18} fontWeight="bold" style={{ lineHeight: 1 }}>+</Box>
							</IconButton>
						</Tooltip>
						<Box width={1} height={16} bgcolor="#d1d5db" mx={0.5} />
						<Tooltip title="Restablecer vista">
							<IconButton
								size="small"
								onClick={() => {
									setCanvasZoom(1);
									setCanvasPan({ x: 0, y: 0 });
								}}
							>
								<Box fontSize={11}>1:1</Box>
							</IconButton>
						</Tooltip>
						</Box>
					</Box>
					<Box
						ref={canvasViewportRef}
						flex={1}
						display="flex"
						alignItems="center"
						justifyContent="center"
						overflow="hidden"
						style={{ cursor: middleMousePanning ? "grabbing" : "grab", touchAction: "none" }}
						onClick={(e) => {
							// Al hacer clic fuera del canvas, deseleccionar todo
							if (canvasDropRef.current && !canvasDropRef.current.contains(e.target)) {
								selectedElementIdsRef.current = [];
								setSelectedElementIds([]);
								setSelectedElement(null);
								setEditingTextElementId(null);
								setEditingButtonLabelElementId(null);
							}
						}}
						onMouseDown={(e) => {
							if (e.button === 1) {
								e.preventDefault();
								setMiddleMousePanning({
									startClientX: e.clientX,
									startClientY: e.clientY,
									startPanX: canvasPan.x,
									startPanY: canvasPan.y,
								});
							}
						}}
					>
						<Box
							style={{
								transform: `translate(${canvasPan.x}px, ${canvasPan.y}px) scale(${canvasZoom})`,
								transformOrigin: "center center",
								transition: "none",
							}}
						>
							<Box
								ref={canvasDropRef}
								onDragOver={handleCanvasDragOver}
								onDrop={handleCanvasDrop}
								onPointerDownCapture={(e) => {
									if (isRegistrationPage) return;
									if (e.button !== 0) return;
									if (dragging || resizing) return;
									if (e.target.closest?.("[data-er-editor-ui]")) return;
									const hitEl = e.target.closest?.("[data-er-canvas-el='1']");
									if (hitEl && !e.altKey) return;
									if (hitEl && e.altKey) {
										e.preventDefault();
										e.stopPropagation();
									}
									handleCanvasBackgroundMarqueeMouseDown(e);
								}}
								style={{
									width: effectiveViewportDim.width,
									height: effectiveViewportDim.height,
									backgroundColor: effectiveBgColor != null
										? effectiveBgColor
										: isRegistrationPage
										? (currentPage?.registrationDesign?.backgroundColor || "#ffffff")
										: (currentPage?.backgroundColor || "#fff"),
									borderRadius: effectiveModalBorderRadius,
									boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
									position: "relative",
									overflow: "visible",
								}}
							>
								{!isRegistrationPage && (
									<div
										role="presentation"
										style={{
											position: "absolute",
											inset: 0,
											zIndex: 0,
											cursor: "default",
										}}
										onClick={() => {
											if (suppressMarqueeFollowupRef.current) return;
											selectedElementIdsRef.current = [];
											setSelectedElementIds([]);
											setSelectedElement(null);
											setEditingTextElementId(null);
											setEditingButtonLabelElementId(null);
										}}
										onContextMenu={(e) => {
											e.preventDefault();
											setContextMenu(null);
										}}
									/>
								)}
								{!isModalEditMode && !isRegistrationPage && currentPage?.backgroundImageUrl && (
									<div
										style={{
											position: "absolute",
											top: 0,
											left: 0,
											right: 0,
											bottom: 0,
											zIndex: 1,
											backgroundImage: `url(${resolveEscapeRoomMediaUrl(currentPage.backgroundImageUrl)})`,
											backgroundSize: "cover",
											backgroundPosition: "center",
											opacity: currentPage?.backgroundImageOpacity != null ? currentPage.backgroundImageOpacity / 100 : 1,
											pointerEvents: "none",
										}}
									/>
								)}
								{!isModalEditMode && (
									<EscapeRoomPlayHudZoneOverlay viewportId={activeViewport} showScore />
								)}
								{isRegistrationPage ? (
									<div
										style={{
											position: "absolute",
											top: 0,
											left: 0,
											right: 0,
											bottom: 0,
											width: "100%",
											height: "100%",
											display: "flex",
											alignItems: "center",
											justifyContent: "center",
										}}
									>
										<div
											style={{
												display: "flex",
												flexDirection: "column",
												alignItems: "center",
												gap: 12,
												padding: "24px 48px",
												background: "rgba(255,255,255,0.9)",
												borderRadius: 12,
												boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
												border: "1px solid rgba(0,0,0,0.06)",
											}}
										>
											<AssignmentIcon style={{ fontSize: 40, color: "#7D00FC", opacity: 0.9 }} />
											<span style={{ fontSize: 28, fontWeight: 700, color: "#1a1a1a", letterSpacing: "0.15em", textTransform: "uppercase" }}>
												Registro
											</span>
											<span style={{ fontSize: 13, color: "#666", fontWeight: 500 }}>
												Página de inscripción
											</span>
										</div>
									</div>
								) : (
									<>
										{alignmentGuides.x != null && (
											<div
												style={{
													position: "absolute",
													top: 0,
													bottom: 0,
													left: alignmentGuides.x,
													width: 1,
													background: "#7c3aed",
													opacity: 0.85,
													pointerEvents: "none",
													zIndex: 9,
												}}
											/>
										)}
										{alignmentGuides.y != null && (
											<div
												style={{
													position: "absolute",
													left: 0,
													right: 0,
													top: alignmentGuides.y,
													height: 1,
													background: "#7c3aed",
													opacity: 0.85,
													pointerEvents: "none",
													zIndex: 9,
												}}
											/>
										)}
										{marqueeRect && (
											<div
												style={{
													position: "absolute",
													left: marqueeRect.x1,
													top: marqueeRect.y1,
													width: Math.max(0, marqueeRect.x2 - marqueeRect.x1),
													height: Math.max(0, marqueeRect.y2 - marqueeRect.y1),
													border: "1px solid rgba(124, 58, 237, 0.95)",
													background: "rgba(124, 58, 237, 0.1)",
													pointerEvents: "none",
													zIndex: 98,
													boxSizing: "border-box",
												}}
											/>
										)}
										{effectiveElements.map((el) => (
											<ElementRenderer
												key={el.elementId}
												element={el}
												selected={erSelectedIdsInclude(selectedElementIds, el.elementId) || erElIdEq(hoverPanelElementId, el.elementId)}
												onSelect={handleSelectElement}
												onUpdate={effectiveUpdateElement}
												onUpdateQuiz={handleUpdateQuiz}
												onDragStart={onDragStart}
												onResizeStart={onResizeStart}
												isLocked={false}
												canvasZoom={canvasZoom}
												editorBreakpointId={activeViewport}
												quizData={el.type === "quiz" ? quizzes.find((q) => String(q?._id) === resolvePlayQuizId(el.content?.quizId)) : undefined}
												onRequestOptionImagePicker={(elementId, optionIndex) => setQuizImagePickerFor({ elementId, optionIndex })}
												editingTextElementId={editingTextElementId}
												setEditingTextElementId={setEditingTextElementId}
												editingButtonLabelElementId={editingButtonLabelElementId}
												setEditingButtonLabelElementId={setEditingButtonLabelElementId}
												onContextMenu={handleElementContextMenu}
												playerScore={0}
											/>
										))}
										{hoveredPanelElement && (
											<div
												style={{
													position: "absolute",
													left: hoveredPanelElement.x,
													top: hoveredPanelElement.y,
													width: hoveredPanelElement.width,
													height: hoveredPanelElement.height,
													border: "2px dashed #7c3aed",
													borderRadius: hoveredPanelElement.type === "shape" ? 0 : 6,
													boxShadow: "0 0 0 2px rgba(124,58,237,0.12)",
													pointerEvents: "none",
													zIndex: 12,
												}}
											/>
										)}
										{selectedElement?.type === "text" && !isRegistrationPage && (
											<TextFloatingToolbar
												element={selectedElement}
												onUpdate={effectiveUpdateElement}
												onDuplicate={() => duplicateElement()}
												fontOptions={allFontOptions}
											/>
										)}
										{selectedElement?.type === "quiz" && !isRegistrationPage && (
											<QuizOptionsFloatingToolbar
												element={selectedElement}
												onUpdate={effectiveUpdateElement}
												fontOptions={allFontOptions}
											/>
										)}
									</>
								)}
							</Box>
						</Box>
					</Box>
				</Box>

				{/* Panel derecho */}
				<Box
					width={400}
					minWidth={400}
					flexShrink={0}
					borderLeft={1}
					borderColor="divider"
					display="flex"
					flexDirection="row"
					overflow="hidden"
					minHeight={0}
					bgcolor="#fff"
				>
					<>
						<Box
							width={80}
							display="flex"
							flexDirection="column"
							alignItems="stretch"
							py={1.5}
							px={0.5}
							style={{
								background: "linear-gradient(180deg, #f8f9fa 0%, #f1f3f5 100%)",
								borderRight: "1px solid rgba(0,0,0,0.06)",
								boxShadow: "inset -1px 0 0 rgba(255,255,255,0.5)",
							}}
						>
							{selectedElement && addPanelCategory === "editar"
								? (
									<>
										<Tooltip title="Atrás" placement="left">
											<Box
												onClick={() => {
													selectedElementIdsRef.current = [];
													setSelectedElementIds([]);
													setSelectedElement(null);
													setAddPanelCategory(isRegistrationPage ? "diseño" : "elementos");
													setElementosSubSection(null);
												}}
												display="flex"
												flexDirection="column"
												alignItems="center"
												justifyContent="center"
												py={1.25}
												mx={0.5}
												mb={0.5}
												style={{
													cursor: "pointer",
													borderRadius: 12,
													background: "transparent",
													boxShadow: "none",
													border: "1px solid transparent",
													transition: "all 0.2s ease",
												}}
												onMouseEnter={(e) => {
													e.currentTarget.style.background = "rgba(255,255,255,0.6)";
													e.currentTarget.style.boxShadow = "0 1px 4px rgba(0,0,0,0.05)";
												}}
												onMouseLeave={(e) => {
													e.currentTarget.style.background = "transparent";
													e.currentTarget.style.boxShadow = "none";
												}}
											>
												<Box
													display="flex"
													alignItems="center"
													justifyContent="center"
													style={{
														width: 36,
														height: 36,
														borderRadius: 10,
														background: "rgba(0,0,0,0.04)",
													}}
												>
													<ArrowBackIcon style={{ fontSize: 20, color: "#64748b" }} />
												</Box>
												<Box fontSize={10} mt={0.75} fontWeight={500} style={{ color: "#64748b", textAlign: "center", lineHeight: 1.2 }}>
													Atrás
												</Box>
											</Box>
										</Tooltip>
										{editarSubCategoriesFiltered.map(({ id, label, shortLabel, Icon }) => {
										const active = editarSubSection === id;
										return (
											<Tooltip key={id} title={label} placement="left">
												<Box
													onClick={() => {
														setEditarSubSection(id);
														const el = editarSectionRefs.current[id];
														if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
													}}
													display="flex"
													flexDirection="column"
													alignItems="center"
													justifyContent="center"
													py={1.25}
													mx={0.5}
													mb={0.5}
													style={{
														cursor: "pointer",
														borderRadius: 12,
														background: active ? "#fff" : "transparent",
														boxShadow: active ? "0 2px 8px rgba(0,0,0,0.08)" : "none",
														border: active ? "1px solid rgba(0,0,0,0.06)" : "1px solid transparent",
														transition: "all 0.2s ease",
													}}
													onMouseEnter={(e) => {
														if (!active) {
															e.currentTarget.style.background = "rgba(255,255,255,0.6)";
															e.currentTarget.style.boxShadow = "0 1px 4px rgba(0,0,0,0.05)";
														}
													}}
													onMouseLeave={(e) => {
														if (!active) {
															e.currentTarget.style.background = "transparent";
															e.currentTarget.style.boxShadow = "none";
														}
													}}
												>
													<Box
														display="flex"
														alignItems="center"
														justifyContent="center"
														style={{
															width: 36,
															height: 36,
															borderRadius: 10,
															background: active ? "linear-gradient(135deg, #7c3aed 0%, #5b21b6 100%)" : "rgba(0,0,0,0.04)",
														}}
													>
														<Icon style={{ fontSize: 20, color: active ? "#fff" : "#64748b" }} />
													</Box>
													<Box fontSize={10} mt={0.75} fontWeight={active ? 600 : 500} style={{ color: active ? "#7c3aed" : "#64748b", textAlign: "center", lineHeight: 1.2 }}>
														{shortLabel}
													</Box>
												</Box>
											</Tooltip>
										);
									})}
									</>
								)
								: (isRegistrationPage ? REGISTRATION_CATEGORIES : ADD_CATEGORIES).map(({ id, label, shortLabel, Icon }) => {
									const isEditar = id === "editar";
									const disabled = isEditar && !selectedElement && isRegistrationPage;
									return (
									<Tooltip key={id} title={disabled ? "Selecciona un elemento" : label} placement="left">
										<Box
											onClick={() => {
												if (disabled) return;
												setAddPanelCategory(id);
												setElementosSubSection(null);
											}}
											display="flex"
											flexDirection="column"
											alignItems="center"
											justifyContent="center"
											py={1.25}
											mx={0.5}
											mb={0.5}
											style={{
												cursor: disabled ? "not-allowed" : "pointer",
												opacity: disabled ? 0.5 : 1,
												borderRadius: 12,
												background: addPanelCategory === id ? "#fff" : "transparent",
												boxShadow: addPanelCategory === id ? "0 2px 8px rgba(0,0,0,0.08)" : "none",
												border: addPanelCategory === id ? "1px solid rgba(0,0,0,0.06)" : "1px solid transparent",
												transition: "all 0.2s ease",
											}}
											onMouseEnter={(e) => {
												if (!disabled && addPanelCategory !== id) {
													e.currentTarget.style.background = "rgba(255,255,255,0.6)";
													e.currentTarget.style.boxShadow = "0 1px 4px rgba(0,0,0,0.05)";
												}
											}}
											onMouseLeave={(e) => {
												if (!disabled && addPanelCategory !== id) {
													e.currentTarget.style.background = "transparent";
													e.currentTarget.style.boxShadow = "none";
												}
											}}
										>
											<Box
												display="flex"
												alignItems="center"
												justifyContent="center"
												style={{
													width: 36,
													height: 36,
													borderRadius: 10,
													background: addPanelCategory === id ? "linear-gradient(135deg, #7c3aed 0%, #5b21b6 100%)" : "rgba(0,0,0,0.04)",
												}}
											>
												<Icon
													style={{
														fontSize: 20,
														color: addPanelCategory === id ? "#fff" : "#64748b",
													}}
												/>
											</Box>
											<Box
												fontSize={10}
												mt={0.75}
												fontWeight={addPanelCategory === id ? 600 : 500}
												style={{
													color: addPanelCategory === id ? "#7c3aed" : "#64748b",
													textAlign: "center",
													lineHeight: 1.2,
												}}
											>
												{shortLabel}
											</Box>
										</Box>
									</Tooltip>
									);
								})}
							</Box>
							<Box flex={1} minHeight={0} minWidth={0} display="flex" flexDirection="column" style={{ overflow: "hidden" }}>
								<div
									style={{
										flex: 1,
										minHeight: 0,
										overflowY: "auto",
										overflowX: "hidden",
										background: "#f1f5f9",
										borderLeft: "1px solid #e2e8f0",
										padding: 16,
									}}
								>
								{addPanelCategory === "editar" && selectedElement ? (
									<>
										{selectedElement.type === "text" && (
											<Box ref={(el) => { editarSectionRefs.current.estilo = el; }} style={EDITAR_SECTION_SEP}>
												<TextElementStylePanel
													selectedElement={selectedElement}
													effectiveUpdateElement={effectiveUpdateElement}
													allFontOptions={allFontOptions}
													fontLabel={fontLabel}
													onOpenFontManager={() => {
														setFontManagerTarget("text");
														setFontManagerOpen(true);
													}}
												/>
											</Box>
										)}

										{selectedElement.type === "image" && (
											<Box ref={(el) => { if (selectedElement?.type === "image") editarSectionRefs.current.contenido = el; }}>
											<ErEditAccordion title="Imagen" icon={ImageIcon} defaultOpen>
											<ErEditAccordion title="Archivo" nested defaultOpen>
													<Box
														onClick={() => setImageElementPickerOpen(true)}
														display="flex"
														alignItems="center"
														style={{ gap: 12, padding: 12, borderRadius: 10, border: "2px dashed #cbd5e1", background: "#fff", cursor: "pointer" }}
														onMouseEnter={(e) => { e.currentTarget.style.borderColor = "#7c3aed"; e.currentTarget.style.background = "#faf5ff"; }}
														onMouseLeave={(e) => { e.currentTarget.style.borderColor = "#cbd5e1"; e.currentTarget.style.background = "#fff"; }}
													>
														{selectedElement.content?.url ? (
															<Box style={{ width: 56, height: 42, borderRadius: 8, overflow: "hidden", flexShrink: 0, background: "#f1f5f9" }}>
																<img src={selectedElement.content.url.startsWith("http") || selectedElement.content.url.startsWith("/") || selectedElement.content.url.startsWith("data:") ? selectedElement.content.url : `${SERVER_URL}/${selectedElement.content.url}`} alt="" style={{ width: "100%", height: "100%", objectFit: "cover" }} onError={(e) => { e.target.style.display = "none"; }} />
															</Box>
														) : (
															<Box display="flex" alignItems="center" justifyContent="center" style={{ width: 56, height: 42, borderRadius: 8, background: "#f1f5f9", flexShrink: 0 }}>
																<ImageIcon style={{ fontSize: 24, color: "#94a3b8" }} />
															</Box>
														)}
														<Box flex={1} minWidth={0}>
															<Box fontSize={13} fontWeight={600} color="#1e293b">{selectedElement.content?.url ? "Imagen asignada" : "Sin imagen"}</Box>
															<Box fontSize={11} color="#64748b">{selectedElement.content?.url ? "Clic para elegir otra" : "Clic para elegir de multimedia"}</Box>
														</Box>
													</Box>
											</ErEditAccordion>
											</ErEditAccordion>
											</Box>
										)}
										{selectedElement.type === "image" && (
											<Box ref={(el) => { if (selectedElement?.type === "image") editarSectionRefs.current.estilo = el; }} style={EDITAR_SECTION_SEP}>
											<ErEditAccordion title="Estilo de imagen" icon={PaletteIcon} defaultOpen>
												<ErEditAccordion title="Opacidad" nested defaultOpen>
													<Tooltip title="Opacidad del elemento">
														<Box display="flex" alignItems="center" style={{ gap: 12, padding: "14px 16px", borderRadius: 10, background: "#fff", border: "1px solid #e2e8f0" }} mb={1.5}>
															<OpacityIcon style={{ fontSize: 24, color: "#64748b" }} />
															<Box fontSize={14} fontWeight={600} color="#334155">Opacidad</Box>
															<Box fontSize={13} color="#64748b" ml="auto">{Math.round((selectedElement.style?.opacity != null ? selectedElement.style.opacity : 1) * 100)}%</Box>
														</Box>
													</Tooltip>
													<Slider
														value={(selectedElement.style?.opacity != null ? selectedElement.style.opacity : 1) * 100}
														onChange={(_, v) => effectiveUpdateElement({ ...selectedElement, style: { ...selectedElement.style, opacity: v / 100 } })}
														min={0}
														max={100}
														valueLabelDisplay="auto"
														valueLabelFormat={(v) => `${v}%`}
														style={{ color: "#7c3aed" }}
													/>
												</ErEditAccordion>
												<ErEditAccordion title="Color de imagen" nested defaultOpen>
													<Box fontSize={12} color="#64748b" mb={1.25}>Aplica un tinte sin modificar el archivo original.</Box>
													<ToggleButtonGroup
														size="small"
														exclusive
														value={selectedElement.style?.imageBlendMode || "none"}
														onChange={(_, val) => {
															if (val == null) return;
															effectiveUpdateElement({ ...selectedElement, style: { ...selectedElement.style, imageBlendMode: val } });
														}}
														style={{ marginBottom: 12 }}
													>
														<ToggleButton value="none" style={{ textTransform: "none" }}>Ninguno</ToggleButton>
														<ToggleButton value="multiply" style={{ textTransform: "none" }}>Multiplicar</ToggleButton>
														<ToggleButton value="color" style={{ textTransform: "none" }}>Sustituir color</ToggleButton>
													</ToggleButtonGroup>
													{(selectedElement.style?.imageBlendMode || "none") !== "none" && (
														<Box display="flex" flexDirection="column" style={{ gap: 10 }}>
															<Box display="flex" alignItems="center" style={{ gap: 10, padding: "10px 12px", borderRadius: 10, border: "1px solid #e2e8f0", background: "#fff" }}>
																<Box fontSize={12} fontWeight={600} color="#64748b" style={{ minWidth: 48 }}>Color</Box>
																<RgbaColorPickerPopover
																	label=""
																	value={normalizeColorToRgba(selectedElement.style?.imageBlendColor, 1)}
																	onChange={(c) => effectiveUpdateElement({ ...selectedElement, style: { ...selectedElement.style, imageBlendColor: c } })}
																/>
															</Box>
															<Box display="flex" alignItems="center" style={{ gap: 10, padding: "10px 12px", borderRadius: 10, border: "1px solid #e2e8f0", background: "#fff" }}>
																<Box fontSize={12} fontWeight={600} color="#64748b" style={{ minWidth: 68 }}>Intensidad</Box>
																<Box fontSize={12} color="#64748b" style={{ minWidth: 42 }}>
																	{Math.round((Number.isFinite(Number(selectedElement.style?.imageBlendOpacity)) ? Number(selectedElement.style?.imageBlendOpacity) : 0.35) * 100)}%
																</Box>
																<Slider
																	value={(Number.isFinite(Number(selectedElement.style?.imageBlendOpacity)) ? Number(selectedElement.style?.imageBlendOpacity) : 0.35) * 100}
																	onChange={(_, v) => effectiveUpdateElement({ ...selectedElement, style: { ...selectedElement.style, imageBlendOpacity: v / 100 } })}
																	min={0}
																	max={100}
																	valueLabelDisplay="auto"
																	valueLabelFormat={(v) => `${v}%`}
																	style={{ color: "#7c3aed", flex: 1 }}
																/>
															</Box>
														</Box>
													)}
												</ErEditAccordion>
												<ErEditAccordion title="Rotación y espejo" nested defaultOpen>
													<Box fontSize={12} color="#64748b" mb={1}>
														{Math.round(Number.isFinite(Number(selectedElement.style?.imageRotation)) ? Number(selectedElement.style.imageRotation) : 0)}°
													</Box>
													<Slider
														value={Number.isFinite(Number(selectedElement.style?.imageRotation)) ? Number(selectedElement.style.imageRotation) : 0}
														onChange={(_, v) => effectiveUpdateElement({ ...selectedElement, style: { ...selectedElement.style, imageRotation: v } })}
														min={0}
														max={360}
														valueLabelDisplay="auto"
														valueLabelFormat={(v) => `${v}°`}
														style={{ color: "#7c3aed", marginBottom: 12 }}
													/>
													<Box display="flex" flexWrap="wrap" alignItems="center" style={{ gap: 8 }}>
														<ToggleButtonGroup
															size="small"
															exclusive={false}
															value={[
																...(selectedElement.style?.imageFlipX ? ["flipX"] : []),
																...(selectedElement.style?.imageFlipY ? ["flipY"] : []),
															]}
															onChange={(_, vals) => {
																effectiveUpdateElement({
																	...selectedElement,
																	style: {
																		...selectedElement.style,
																		imageFlipX: (vals || []).includes("flipX"),
																		imageFlipY: (vals || []).includes("flipY"),
																	},
																});
															}}
														>
															<ToggleButton value="flipX" style={{ textTransform: "none", gap: 6, padding: "6px 12px" }}>
																<SwapHorizIcon style={{ fontSize: 18 }} />
																Espejo X
															</ToggleButton>
															<ToggleButton value="flipY" style={{ textTransform: "none", gap: 6, padding: "6px 12px" }}>
																<SwapVertIcon style={{ fontSize: 18 }} />
																Espejo Y
															</ToggleButton>
														</ToggleButtonGroup>
														<Button
															size="small"
															variant="outlined"
															onClick={() => effectiveUpdateElement({
																...selectedElement,
																style: {
																	...selectedElement.style,
																	imageRotation: 0,
																	imageFlipX: false,
																	imageFlipY: false,
																},
															})}
															style={{ textTransform: "none", borderColor: "#cbd5e1", color: "#64748b" }}
														>
															Restablecer
														</Button>
													</Box>
												</ErEditAccordion>
												<ErEditAccordion title="Redondeo" nested defaultOpen>
													<Box fontSize={12} color="#64748b" mb={0.5}>
														{selectedElement.style?.borderRadiusPercent ?? 0}%
													</Box>
													<Slider
														value={selectedElement.style?.borderRadiusPercent ?? 0}
														onChange={(_, v) => effectiveUpdateElement({ ...selectedElement, style: { ...selectedElement.style, borderRadiusPercent: v } })}
														min={0}
														max={100}
														valueLabelDisplay="auto"
														valueLabelFormat={(v) => `${v}%`}
														style={{ color: "#7c3aed" }}
													/>
												</ErEditAccordion>
												<ErEditAccordion title="Marco" nested defaultOpen={false}>
													<Box fontSize={12} color="#64748b" lineHeight={1.45} mb={1.25}>
														Borde alrededor de la imagen. Sigue el redondeo. 0 = sin marco.
													</Box>
													<Box display="flex" flexDirection="column" style={{ gap: 12 }}>
														<TextField
															label="Grosor del borde (px)"
															type="number"
															size="small"
															fullWidth
															variant="outlined"
															inputProps={{ min: 0, max: 40 }}
															value={selectedElement.style?.borderWidth != null ? selectedElement.style.borderWidth : ""}
															onChange={(e) => {
																const t = String(e.target.value ?? "").trim();
																if (t === "") {
																	const { borderWidth, ...restStyle } = selectedElement.style || {};
																	effectiveUpdateElement({ ...selectedElement, style: restStyle });
																	return;
																}
																const n = parseInt(t, 10);
																if (!Number.isNaN(n)) {
																	effectiveUpdateElement({
																		...selectedElement,
																		style: { ...selectedElement.style, borderWidth: Math.min(40, Math.max(0, n)) },
																	});
																}
															}}
														/>
														<Box style={{ width: "100%", maxWidth: "100%", overflow: "hidden" }}>
															<RgbaColorPickerPopover
																label="Color del borde"
																value={normalizeColorToRgba(selectedElement.style?.borderColor || "rgba(124, 58, 237, 1)")}
																onChange={(color) => effectiveUpdateElement({ ...selectedElement, style: { ...selectedElement.style, borderColor: color } })}
															/>
														</Box>
													</Box>
												</ErEditAccordion>
											</ErEditAccordion>
											</Box>
										)}

										{selectedElement.type === "video" && (
											<Box ref={(el) => { if (selectedElement?.type === "video") editarSectionRefs.current.contenido = el; }} style={EDITAR_SECTION_SEP}>
											<ErEditAccordion title="Video" icon={VideoLibraryIcon} defaultOpen>
											<ErEditAccordion title="Archivo" nested defaultOpen>
												<Box
													onClick={() => setVideoElementPickerOpen(true)}
													display="flex"
													alignItems="center"
													style={{ gap: 12, padding: 12, borderRadius: 10, border: "2px dashed #cbd5e1", background: "#fff", cursor: "pointer", marginBottom: 12 }}
													onMouseEnter={(e) => { e.currentTarget.style.borderColor = "#7c3aed"; e.currentTarget.style.background = "#faf5ff"; }}
													onMouseLeave={(e) => { e.currentTarget.style.borderColor = "#cbd5e1"; e.currentTarget.style.background = "#fff"; }}
												>
													{selectedElement.content?.url ? (
														<Box style={{ width: 88, height: 56, borderRadius: 8, overflow: "hidden", flexShrink: 0, background: "#0f172a" }}>
															<video
																src={selectedElement.content.url.startsWith("http") || selectedElement.content.url.startsWith("/") || selectedElement.content.url.startsWith("data:") ? selectedElement.content.url : `${SERVER_URL}/${selectedElement.content.url}`}
																preload="metadata"
																muted
																playsInline
																style={{ width: "100%", height: "100%", objectFit: "cover" }}
															/>
														</Box>
													) : (
														<Box display="flex" alignItems="center" justifyContent="center" style={{ width: 88, height: 56, borderRadius: 8, background: "#f1f5f9", flexShrink: 0 }}>
															<VideoLibraryIcon style={{ fontSize: 28, color: "#94a3b8" }} />
														</Box>
													)}
													<Box flex={1} minWidth={0}>
														<Box fontSize={13} fontWeight={600} color="#1e293b">{selectedElement.content?.url ? "Video asignado" : "Sin video"}</Box>
														<Box fontSize={11} color="#64748b">{selectedElement.content?.url ? "Clic para elegir otro" : "Clic para elegir de multimedia"}</Box>
													</Box>
												</Box>
											</ErEditAccordion>
											<ErEditAccordion title="Reproducción" nested defaultOpen>
												<Box display="flex" flexDirection="column" style={{ gap: 16 }}>
													<Tooltip title="Reproducir automáticamente al cargar (autoplay)">
														<Box display="flex" alignItems="center" style={{ gap: 14, padding: "14px 16px", minHeight: 52, borderRadius: 10, background: "#fff", border: "1px solid #e2e8f0" }}>
															<PlayArrowIcon style={{ fontSize: 24, color: "#64748b" }} />
															<Switch
																checked={!!selectedElement.content?.autoplay}
																onChange={(e) => effectiveUpdateElement({ ...selectedElement, content: { ...selectedElement.content, autoplay: e.target.checked } })}
																color="primary"
															/>
															<Box component="span" fontSize={14} fontWeight={500} color="#334155">Autoplay</Box>
														</Box>
													</Tooltip>
													<Tooltip title="Repetir el video en bucle (loop)">
														<Box display="flex" alignItems="center" style={{ gap: 14, padding: "14px 16px", minHeight: 52, borderRadius: 10, background: "#fff", border: "1px solid #e2e8f0" }}>
															<LoopIcon style={{ fontSize: 24, color: "#64748b" }} />
															<Switch
																checked={!!selectedElement.content?.loop}
																onChange={(e) => effectiveUpdateElement({ ...selectedElement, content: { ...selectedElement.content, loop: e.target.checked } })}
																color="primary"
															/>
															<Box component="span" fontSize={14} fontWeight={500} color="#334155">Bucle</Box>
														</Box>
													</Tooltip>
													<Tooltip title="Mostrar controles del reproductor (play, volumen, etc.)">
														<Box display="flex" alignItems="center" style={{ gap: 14, padding: "14px 16px", minHeight: 52, borderRadius: 10, background: "#fff", border: "1px solid #e2e8f0" }}>
															<SettingsIcon style={{ fontSize: 24, color: "#64748b" }} />
															<Switch
																checked={selectedElement.content?.showControls !== false}
																onChange={(e) => effectiveUpdateElement({ ...selectedElement, content: { ...selectedElement.content, showControls: e.target.checked } })}
																color="primary"
															/>
															<Box component="span" fontSize={14} fontWeight={500} color="#334155">Controles</Box>
														</Box>
													</Tooltip>
												</Box>
											</ErEditAccordion>
											<ErEditAccordion title="Opacidad" nested defaultOpen>
												<Box fontSize={13} fontWeight={500} color="#334155" mb={1}>Opacidad {Math.round(selectedElement.content?.opacity ?? 100)}%</Box>
												<Slider
													value={selectedElement.content?.opacity != null ? selectedElement.content.opacity : 100}
													onChange={(_, v) => effectiveUpdateElement({ ...selectedElement, content: { ...selectedElement.content, opacity: v } })}
													min={0}
													max={100}
													valueLabelDisplay="auto"
													valueLabelFormat={(v) => `${v}%`}
													style={{ color: "#7c3aed" }}
												/>
											</ErEditAccordion>
											</ErEditAccordion>
											</Box>
										)}

										{selectedElement.type === "quiz" && (
											<Box ref={(el) => { if (selectedElement?.type === "quiz") editarSectionRefs.current.contenido = el; }} style={EDITAR_SECTION_SEP}>
												<ErEditAccordion title="Quiz" icon={LiveHelpIcon} defaultOpen>
												<ErEditAccordion title="Pregunta" nested defaultOpen>
													{selectedElement.content?.quizId ? (
														<InlineQuizEditor
															quiz={quizzes.find((q) => q._id === selectedElement.content?.quizId)}
															onSave={(saved) => setQuizzes((prev) => prev.map((q) => (q._id === saved._id ? saved : q)))}
															updateQuiz={handleUpdateQuiz}
															userMedia={userMedia}
															elementId={selectedElement.elementId}
															onRequestOptionImagePicker={(elementId, optionIndex) => setQuizImagePickerFor({ elementId, optionIndex })}
															quizInlineSyncNonce={quizInlineSyncNonce}
															textAnswerCanvasSaveRef={textAnswerCanvasSaveRef}
														/>
													) : (
														<Button
															fullWidth
															variant="contained"
															size="medium"
															onClick={async () => {
																try {
																	const res = await createQuiz({
																		fullName: "Pregunta",
																		questions: [{ type: "multipleChoice", text: "Pregunta", options: [{ text: "Opción 1", imageUrl: "", correct: true }], explanation: "" }],
																		pointsCorrect: 10,
																		pointsIncorrect: -5,
																		allowMultipleAttempts: false,
																		attemptMode: "single",
																		maxAttempts: 3,
																	});
																	loadQuizzes();
																	effectiveUpdateElement({ ...selectedElement, content: { ...selectedElement.content, quizId: res.data._id } });
																} catch (e) {
																	alertError({ error: e, customMessage: "No se pudo crear la pregunta." });
																}
															}}
															style={{ textTransform: "none", background: "linear-gradient(135deg, #7c3aed 0%, #5b21b6 100%)" }}
														>
															Crear pregunta
														</Button>
													)}
												</ErEditAccordion>

												<ErEditAccordion title="Apariencia del bloque" icon={PaletteIcon} nested defaultOpen>
													<Box display="flex" flexWrap="wrap" alignItems="flex-start" style={{ gap: 16 }}>
														<Box>
															<Box fontSize={11} fontWeight={600} color="#64748b" mb={0.5}>Fondo</Box>
															<RgbaColorPickerPopover
																label=""
																value={getQuizBlockBackground(selectedElement)}
																onChange={(rgba) =>
																	effectiveUpdateElement({
																		...selectedElement,
																		content: { ...selectedElement.content, quizBackgroundRgba: rgba },
																		style: { ...selectedElement.style, backgroundColor: rgba },
																	})
																}
															/>
														</Box>
														<Box display="flex" flexDirection="column" style={{ gap: 8 }}>
															<Box fontSize={11} fontWeight={600} color="#64748b">Borde</Box>
															<Box display="flex" alignItems="center" style={{ gap: 8 }}>
																<DraftIntTextField label="Grosor" size="small" min={0} max={10} style={{ width: 72 }}
																	value={getQuizBlockBorderWidth(selectedElement)}
																	onCommit={(v) => effectiveUpdateElement({ ...selectedElement, content: { ...selectedElement.content, quizBorderWidth: v } })} />
																<RgbaColorPickerPopover label="" value={getQuizBlockBorderColorForPicker(selectedElement)}
																	onChange={(rgba) => effectiveUpdateElement({ ...selectedElement, content: { ...selectedElement.content, quizBorderRgba: rgba } })} />
															</Box>
														</Box>
														<Box>
															<Box fontSize={11} fontWeight={600} color="#64748b" mb={0.5}>Sombra</Box>
															<Box display="flex" flexWrap="wrap" alignItems="flex-start" style={{ gap: 16, rowGap: 12 }}>
																<Box style={{ width: 100, flexShrink: 0 }}>
																	<DraftIntTextField label="Difuminado" size="small" min={0} max={24} fullWidth
																		value={getQuizBlockShadowBlur(selectedElement)}
																		onCommit={(v) => effectiveUpdateElement({ ...selectedElement, content: { ...selectedElement.content, quizBlockShadowBlur: v } })} />
																</Box>
																<Box style={{ width: 108, flexShrink: 0 }}>
																	<DraftIntTextField label="Opacidad" size="small" min={0} max={100} fullWidth
																		value={selectedElement.content?.quizBlockShadowOpacity ?? 8}
																		onCommit={(v) => effectiveUpdateElement({ ...selectedElement, content: { ...selectedElement.content, quizBlockShadowOpacity: v } })} />
																</Box>
															</Box>
															<Box fontSize={11} color="#94a3b8" mt={0.5}>Difuminado 0 = sin sombra · Opacidad en %</Box>
														</Box>
													</Box>
												</ErEditAccordion>

												<ErEditAccordion title="Opciones del quiz" icon={FormatListBulletedIcon} nested defaultOpen>
													<ErEditAccordion title="Plantilla" nested defaultOpen>
														<Box style={{ width: "100%", maxWidth: "100%" }}>
															<ToggleButtonGroup
																size="medium"
																exclusive
																style={{ width: "100%", display: "flex", flexWrap: "wrap" }}
																value={(() => { const d = selectedElement.content?.quizOptionsDesign || "classic"; return (QUIZ_OPTION_DESIGNS[d] !== undefined) ? d : "classic"; })()}
																onChange={(_, val) => { if (val != null) effectiveUpdateElement({ ...selectedElement, content: { ...selectedElement.content, quizOptionsDesign: val } }); }}
															>
																<ToggleButton value="classic" style={{ textTransform: "none", flex: "1 1 0", minWidth: 0, minHeight: 44, padding: "6px 8px", fontSize: 12 }}>Clásico</ToggleButton>
																<ToggleButton value="letter" style={{ textTransform: "none", flex: "1 1 0", minWidth: 0, minHeight: 44, padding: "6px 8px", fontSize: 12 }}>Letras</ToggleButton>
																<ToggleButton value="segmented" style={{ textTransform: "none", flex: "1 1 0", minWidth: 0, minHeight: 44, padding: "6px 8px", fontSize: 12 }}>Segmentado</ToggleButton>
															</ToggleButtonGroup>
														</Box>
													</ErEditAccordion>
													<ErEditAccordion title="Tipografía" nested defaultOpen>
														<Box display="flex" flexWrap="wrap" alignItems="flex-start" style={{ gap: 16 }}>
															<FormControl size="small" style={{ minWidth: 140 }}>
																<InputLabel>Fuente</InputLabel>
																<Select value={selectedElement.content?.quizOptionsStyle?.fontFamily || "Arial, sans-serif"}
																	onChange={(e) => {
																		const v = e.target.value;
																		if (v === ADD_FONT_OPTION) {
																			setFontManagerTarget("quizOptions");
																			setFontManagerOpen(true);
																			return;
																		}
																		effectiveUpdateElement({ ...selectedElement, content: { ...selectedElement.content, quizOptionsStyle: { ...selectedElement.content?.quizOptionsStyle, fontFamily: v } } });
																	}}
																	label="Fuente">
																	{allFontOptions.map((f) => <MenuItem key={f} value={f} style={{ fontFamily: f }}>{fontLabel(f)}</MenuItem>)}
																	<MenuItem value={ADD_FONT_OPTION}>+ Añadir Fuente</MenuItem>
																</Select>
															</FormControl>
															<Box>
																<Box fontSize={12} fontWeight={600} color="#64748b" mb={1}>Tamaño</Box>
																<DraftIntTextField label="" min={8} max={120} size="small" style={{ width: 88 }}
																	value={selectedElement.content?.quizOptionsStyle?.fontSize ?? 12}
																	onCommit={(n) => effectiveUpdateElement({ ...selectedElement, content: { ...selectedElement.content, quizOptionsStyle: { ...selectedElement.content?.quizOptionsStyle, fontSize: n } } })} />
															</Box>
															<Box>
																<Box fontSize={12} fontWeight={600} color="#64748b" mb={1}>Estilo</Box>
																<ToggleButtonGroup size="medium" exclusive={false}
																	value={[(selectedElement.content?.quizOptionsStyle?.fontWeight === "bold" && "bold") || null, (selectedElement.content?.quizOptionsStyle?.fontStyle === "italic" && "italic") || null].filter(Boolean)}
																	onChange={(_, val) => {
																		if (!val) return;
																		const st = { ...selectedElement.content?.quizOptionsStyle };
																		st.fontWeight = val.includes("bold") ? "bold" : "normal";
																		st.fontStyle = val.includes("italic") ? "italic" : "normal";
																		effectiveUpdateElement({ ...selectedElement, content: { ...selectedElement.content, quizOptionsStyle: st } });
																	}}>
																	<ToggleButton value="bold" style={{ minWidth: 48, minHeight: 44 }}><FormatBoldIcon style={{ fontSize: 20 }} /></ToggleButton>
																	<ToggleButton value="italic" style={{ minWidth: 48, minHeight: 44 }}><FormatItalicIcon style={{ fontSize: 20 }} /></ToggleButton>
																</ToggleButtonGroup>
															</Box>
														</Box>
														<Box mt={2}>
															<TextEffectPicker
																effectStyle={pickEffectBundle(selectedElement.content?.quizOptionsStyle || {}, "text")}
																fallbackColor={selectedElement.content?.quizOptionsStyle?.color || "#334155"}
																onEffectStyleChange={(patch) => effectiveUpdateElement({
																	...selectedElement,
																	content: {
																		...selectedElement.content,
																		quizOptionsStyle: mergeEffectBundlePatch(selectedElement.content?.quizOptionsStyle || {}, "text", patch),
																	},
																})}
															/>
														</Box>
													</ErEditAccordion>
													<ErEditAccordion title="Alineación" nested defaultOpen>
														<Box mb={2}>
															<Box fontSize={12} fontWeight={600} color="#64748b" mb={1}>Alineación opciones</Box>
															<ToggleButtonGroup size="medium" exclusive
																value={selectedElement.content?.quizOptionsStyle?.textAlign || "left"}
																onChange={(_, val) => { if (val != null) effectiveUpdateElement({ ...selectedElement, content: { ...selectedElement.content, quizOptionsStyle: { ...selectedElement.content?.quizOptionsStyle, textAlign: val } } }); }}>
																<ToggleButton value="left" style={{ minWidth: 48, minHeight: 44 }}><FormatAlignLeftIcon style={{ fontSize: 20 }} /></ToggleButton>
																<ToggleButton value="center" style={{ minWidth: 48, minHeight: 44 }}><FormatAlignCenterIcon style={{ fontSize: 20 }} /></ToggleButton>
																<ToggleButton value="right" style={{ minWidth: 48, minHeight: 44 }}><FormatAlignRightIcon style={{ fontSize: 20 }} /></ToggleButton>
																<ToggleButton value="justify" style={{ minWidth: 48, minHeight: 44 }}><FormatAlignJustifyIcon style={{ fontSize: 20 }} /></ToggleButton>
															</ToggleButtonGroup>
														</Box>
														<Box>
															<Box fontSize={12} fontWeight={600} color="#64748b" mb={1}>Alineación pregunta</Box>
															<ToggleButtonGroup size="medium" exclusive
																value={selectedElement.content?.quizQuestionTextAlign || "left"}
																onChange={(_, val) => {
																	if (val != null) effectiveUpdateElement({ ...selectedElement, content: { ...selectedElement.content, quizQuestionTextAlign: val } });
																}}>
																<ToggleButton value="left" style={{ minWidth: 48, minHeight: 44 }}><FormatAlignLeftIcon style={{ fontSize: 20 }} /></ToggleButton>
																<ToggleButton value="center" style={{ minWidth: 48, minHeight: 44 }}><FormatAlignCenterIcon style={{ fontSize: 20 }} /></ToggleButton>
																<ToggleButton value="right" style={{ minWidth: 48, minHeight: 44 }}><FormatAlignRightIcon style={{ fontSize: 20 }} /></ToggleButton>
															</ToggleButtonGroup>
														</Box>
													</ErEditAccordion>
													<ErEditAccordion title="Efecto visual de la caja" nested defaultOpen>
														{(() => {
															const qc = selectedElement.content?.quizOptionsCustom || {};
															const designId = selectedElement.content?.quizOptionsDesign || "classic";
															const designDefaults = QUIZ_OPTION_DESIGNS[designId] || QUIZ_OPTION_DESIGNS.classic;
															return (
																<TextEffectPicker
																	embedded
																	effectStyle={pickEffectBundle(qc, "optionBox")}
																	fallbackColor={qc.optionBorderColor || designDefaults.defaultBorder || "#e2e8f0"}
																	onEffectStyleChange={(patch) => effectiveUpdateElement({
																		...selectedElement,
																		content: {
																			...selectedElement.content,
																			quizOptionsCustom: mergeEffectBundlePatch(qc, "optionBox", patch),
																		},
																	})}
																/>
															);
														})()}
													</ErEditAccordion>
													<ErEditAccordion title="Colores e imágenes" nested defaultOpen>
														<Box display="flex" flexWrap="wrap" alignItems="flex-start" style={{ gap: 20 }}>
															<Box>
																<Box fontSize={12} fontWeight={600} color="#64748b" mb={1}>Color texto</Box>
																<HexColorPickerPopover label="" value={selectedElement.content?.quizOptionsStyle?.color || "#334155"}
																	onChange={(c) => effectiveUpdateElement({ ...selectedElement, content: { ...selectedElement.content, quizOptionsStyle: { ...selectedElement.content?.quizOptionsStyle, color: c } } })} />
															</Box>
															<Box>
																<Box fontSize={12} fontWeight={600} color="#64748b" mb={1}>Color texto hover</Box>
																<HexColorPickerPopover label="" value={selectedElement.content?.quizOptionsStyle?.hoverColor || ""}
																	onChange={(c) => effectiveUpdateElement({ ...selectedElement, content: { ...selectedElement.content, quizOptionsStyle: { ...selectedElement.content?.quizOptionsStyle, hoverColor: c || undefined } } })} />
															</Box>
															<Box>
																<Box fontSize={12} fontWeight={600} color="#64748b" mb={1}>Alt. imágenes (px)</Box>
																<DraftIntTextField label="" min={40} max={400} size="small" style={{ width: 100 }}
																	value={selectedElement.content?.quizOptionsImageMaxHeight ?? 120}
																	onCommit={(n) => effectiveUpdateElement({ ...selectedElement, content: { ...selectedElement.content, quizOptionsImageMaxHeight: n } })} />
															</Box>
														</Box>
														{selectedElement.content?.quizId && (() => {
															const quizTf = quizzes.find((q) => q._id === selectedElement.content?.quizId);
															const firstQTf = quizTf?.questions?.[0];
															if (firstQTf?.type === "trueFalse") {
																return (
																	<Box>
																		<Box fontSize={11} color="#94a3b8" mb={1}>Solo para Verdadero/Falso. Si no defines color, se usa el estilo normal (verde/rojo).</Box>
																		<Box display="flex" flexWrap="wrap" alignItems="flex-start" style={{ gap: 20 }}>
																			<Box>
																				<Box fontSize={12} fontWeight={600} color="#64748b" mb={1}>Verdadero (opcional)</Box>
																				<HexColorPickerPopover label="" value={selectedElement.content?.quizTrueColor || ""} onChange={(c) => effectiveUpdateElement({ ...selectedElement, content: { ...selectedElement.content, quizTrueColor: c || undefined } })} />
																			</Box>
																			<Box>
																				<Box fontSize={12} fontWeight={600} color="#64748b" mb={1}>Falso (opcional)</Box>
																				<HexColorPickerPopover label="" value={selectedElement.content?.quizFalseColor || ""} onChange={(c) => effectiveUpdateElement({ ...selectedElement, content: { ...selectedElement.content, quizFalseColor: c || undefined } })} />
																			</Box>
																		</Box>
																	</Box>
																);
															}
															return null;
														})()}
													</ErEditAccordion>
													{selectedElement.content?.quizId && (() => {
															const quiz = quizzes.find((q) => q._id === selectedElement.content?.quizId);
															const firstQ = quiz?.questions?.[0];
															const hasLayout = firstQ && (firstQ.type === "trueFalse" || firstQ.type === "multipleChoice" || firstQ.type === "imageChoice" || firstQ.type === "optionsWithImages");
															if (!hasLayout) return null;
															const meta = {
																fullName: quiz.fullName,
																pointsCorrect: quiz.pointsCorrect,
																pointsIncorrect: quiz.pointsIncorrect,
																allowMultipleAttempts: quiz.allowMultipleAttempts,
																attemptMode: quiz.attemptMode,
																maxAttempts: quiz.maxAttempts,
															};
															const saveLayouts = async (patch) => {
																if (!quiz?._id) return;
																try {
																	await handleUpdateQuiz(quiz._id, { ...meta, questions: [{ ...firstQ, ...patch }] });
																} catch (err) {
																	/* noop */
																}
															};
															const layoutSelect = (label, value, field) => {
																const inherit = field === "optionsLayoutTablet" || field === "optionsLayoutMobile";
																return (
																	<FormControl key={field} variant="outlined" size="small" fullWidth style={{ marginTop: 10 }}>
																		<InputLabel>{label}</InputLabel>
																		<Select
																			label={label}
																			value={value || ""}
																			onChange={(e) => saveLayouts({ [field]: e.target.value })}
																		>
																			{inherit ? (
																				<MenuItem value="">
																					<em>Igual que ordenador</em>
																				</MenuItem>
																			) : null}
																			<MenuItem value="row">Columna (opciones en columna)</MenuItem>
																			<MenuItem value="columns">Fila (opciones en fila)</MenuItem>
																			<MenuItem value="grid">Cuadrícula</MenuItem>
																		</Select>
																	</FormControl>
																);
															};
															return (
																<ErEditAccordion title="Disposición" nested defaultOpen>
																	<Box fontSize={12} fontWeight={600} color="#64748b" mb={0.5}>
																		Disposición de opciones
																	</Box>
																	<Box fontSize={11} color="#94a3b8" mb={1}>
																		Tableta y móvil son independientes del ordenador. “Igual que ordenador” solo aplica a tableta/móvil.
																	</Box>
																	{layoutSelect("Ordenador", firstQ.optionsLayout || "row", "optionsLayout")}
																	{layoutSelect("Tableta", firstQ.optionsLayoutTablet ?? "", "optionsLayoutTablet")}
																	{layoutSelect("Móvil", firstQ.optionsLayoutMobile ?? "", "optionsLayoutMobile")}
																</ErEditAccordion>
															);
														})()}
												</ErEditAccordion>
												</ErEditAccordion>
											</Box>
										)}

										{selectedElement.type === "hint" && (
								<Box ref={(el) => { if (selectedElement?.type === "hint") editarSectionRefs.current.contenido = el; }} style={EDITAR_SECTION_SEP}>
								<ErEditAccordion title="Pista" icon={LiveHelpIcon} defaultOpen>
									<ErEditAccordion title="Texto y penalización" nested defaultOpen>
										<TextField label="Texto del botón" placeholder="Pista" size="small" fullWidth variant="outlined"
											value={selectedElement.content?.label || "Pista"}
											onChange={(e) => effectiveUpdateElement({ ...selectedElement, content: { ...selectedElement.content, label: e.target.value || "Pista" } })}
											style={{ marginBottom: 12 }} />
										<DraftIntTextField label="Penalización (pts)" min={0} max={999999} fullWidth variant="outlined"
											value={selectedElement.content?.hintPenalty ?? 0}
											onCommit={(n) => effectiveUpdateElement({ ...selectedElement, content: { ...selectedElement.content, hintPenalty: n } })}
											style={{ marginBottom: 12 }} />
									</ErEditAccordion>
									<ErEditAccordion title="Modales" icon={TouchAppIcon} nested defaultOpen>
											<ErEditAccordion title="Modal de confirmación" nested defaultOpen>
												<FormControl size="small" fullWidth variant="outlined" style={{ marginTop: 8 }}>
													<InputLabel shrink htmlFor="hint-confirm-size-select">Tamaño</InputLabel>
													<Select
														native
														value={selectedElement.content?.confirmModalSize || "medium"}
														onChange={(e) => effectiveUpdateElement({ ...selectedElement, content: { ...selectedElement.content, confirmModalSize: e.target.value } })}
														label="Tamaño"
														inputProps={{ id: "hint-confirm-size-select" }}
													>
														{MODAL_SIZES.map((s) => <option key={s.id} value={s.id}>{s.label} ({s.width}×{s.height})</option>)}
													</Select>
												</FormControl>
												<Button
													fullWidth
													variant="contained"
													size="small"
													startIcon={<EditIcon />}
													onClick={() => {
														const c = selectedElement.content || {};
														const existing = c.confirmModalDesign || { backgroundColor: "#ffffff", elements: [], borderRadius: 12 };
														const els = existing.elements || [];
														const hasCancel = els.some((e) => e.type === "button" && (e.content?.action === "cancelHint" || e.content?.action === "closeModal"));
														const hasConfirm = els.some((e) => e.type === "button" && e.content?.action === "confirmHint");
														let elements = [...els];
														const modalW = (MODAL_SIZES.find((s) => s.id === (c.confirmModalSize || "medium")) || MODAL_SIZES[1]).width;
														const modalH = (MODAL_SIZES.find((s) => s.id === (c.confirmModalSize || "medium")) || MODAL_SIZES[1]).height;
														if (!hasCancel) {
															elements.push({
																...defaultElement("button"),
																elementId: genId(),
																x: 24, y: modalH - 60, width: 160, height: 44,
																content: { action: "cancelHint", label: "Cancelar", icon: "", iconPosition: "before" },
																style: { fontFamily: "Arial, sans-serif", fontSize: 16, fontWeight: "bold", color: "rgba(51, 51, 51, 1)", backgroundColor: "transparent", textAlign: "center", borderRadius: 8 },
															});
														}
														if (!hasConfirm) {
															elements.push({
																...defaultElement("button"),
																elementId: genId(),
																x: modalW - 184, y: modalH - 60, width: 160, height: 44,
																content: { action: "confirmHint", label: "Confirmar", icon: "", iconPosition: "before" },
																style: { fontFamily: "Arial, sans-serif", fontSize: 16, fontWeight: "bold", color: "rgba(255, 255, 255, 1)", backgroundColor: "rgba(124, 58, 237, 1)", textAlign: "center", borderRadius: 8 },
															});
														}
														const init = { ...existing, elements };
														effectiveUpdateElement({ ...selectedElement, content: { ...c, confirmModalDesign: init, confirmModalSize: c.confirmModalSize || "medium" } });
														setEditingHintModal({ elementId: selectedElement.elementId, modalType: "confirm" });
														setSelectedElement(null);
													}}
													style={{ marginTop: 10, textTransform: "none" }}
												>
													Editar modal de confirmación
												</Button>
											</ErEditAccordion>
											<ErEditAccordion title="Modal de la pista" nested defaultOpen>
												<FormControl size="small" fullWidth variant="outlined" style={{ marginTop: 8 }}>
													<InputLabel shrink htmlFor="hint-modal-size-select">Tamaño</InputLabel>
													<Select
														native
														value={selectedElement.content?.hintModalSize || "medium"}
														onChange={(e) => effectiveUpdateElement({ ...selectedElement, content: { ...selectedElement.content, hintModalSize: e.target.value } })}
														label="Tamaño"
														inputProps={{ id: "hint-modal-size-select" }}
													>
														{MODAL_SIZES.map((s) => <option key={s.id} value={s.id}>{s.label} ({s.width}×{s.height})</option>)}
													</Select>
												</FormControl>
												<Button
													fullWidth
													variant="contained"
													size="small"
													startIcon={<EditIcon />}
													onClick={() => {
														const c = selectedElement.content || {};
														const init = c.hintModalDesign || { backgroundColor: "#ffffff", elements: [], borderRadius: 12 };
														effectiveUpdateElement({ ...selectedElement, content: { ...c, hintModalDesign: init, hintModalSize: c.hintModalSize || "medium" } });
														setEditingHintModal({ elementId: selectedElement.elementId, modalType: "hint" });
														setSelectedElement(null);
													}}
													style={{ marginTop: 10, textTransform: "none" }}
												>
													Editar modal de la pista
												</Button>
											</ErEditAccordion>
									</ErEditAccordion>
								</ErEditAccordion>
								</Box>
										)}
									{selectedElement.type === "hint" && (
									<Box ref={(el) => { if (selectedElement?.type === "hint") editarSectionRefs.current.estilo = el; }} style={EDITAR_SECTION_SEP}>
									<ErEditAccordion title="Apariencia" icon={PaletteIcon} defaultOpen>
										<ErEditAccordion title="Fondo" nested defaultOpen>
										<FormControl size="small" fullWidth style={{ marginBottom: 12 }}>
											<InputLabel>Fondo</InputLabel>
											<Select value={(selectedElement.style?.backgroundColor || "rgba(245, 243, 255, 1)") === "transparent" ? "transparent" : "color"}
												onChange={(e) => effectiveUpdateElement({ ...selectedElement, style: { ...selectedElement.style, backgroundColor: e.target.value === "transparent" ? "transparent" : "rgba(245, 243, 255, 1)" } })}
												label="Fondo">
												<MenuItem value="transparent">Sin fondo</MenuItem>
												<MenuItem value="color">Con color</MenuItem>
											</Select>
										</FormControl>
										{(selectedElement.style?.backgroundColor || "rgba(245, 243, 255, 1)") !== "transparent" && (
											<Box mb={1.5}><RgbaColorPickerPopover label="Color de fondo" value={selectedElement.style?.backgroundColor || "rgba(245, 243, 255, 1)"}
												onChange={(color) => effectiveUpdateElement({ ...selectedElement, style: { ...selectedElement.style, backgroundColor: color } })} /></Box>
										)}
										<Box mb={1.5}>
											<RgbaColorPickerPopover label="Color al pasar el ratón" value={selectedElement.style?.hoverBackgroundColor || getDefaultHoverColor(selectedElement.style?.backgroundColor || "rgba(245, 243, 255, 1)") || "rgba(230, 228, 240, 1)"}
												onChange={(color) => effectiveUpdateElement({ ...selectedElement, style: { ...selectedElement.style, hoverBackgroundColor: color } })} />
										</Box>
										</ErEditAccordion>
										<ErEditAccordion title="Colores" nested defaultOpen>
										<Box mb={1.5}><RgbaColorPickerPopover label="Color texto e icono" value={selectedElement.style?.color || "rgba(124, 58, 237, 1)"}
											onChange={(color) => effectiveUpdateElement({ ...selectedElement, style: { ...selectedElement.style, color } })} /></Box>
										<Box mb={1.5}><RgbaColorPickerPopover label="Color del borde" value={selectedElement.style?.borderColor || "rgba(124, 58, 237, 1)"}
											onChange={(color) => effectiveUpdateElement({ ...selectedElement, style: { ...selectedElement.style, borderColor: color } })} /></Box>
										</ErEditAccordion>
										<ErEditAccordion title="Borde y forma" nested defaultOpen>
										<DraftIntTextField label="Grosor del borde (px)" min={0} max={40} fullWidth style={{ marginBottom: 12 }}
											value={selectedElement.style?.borderWidth ?? 1}
											onCommit={(n) => effectiveUpdateElement({ ...selectedElement, style: { ...selectedElement.style, borderWidth: n } })} />
										<DraftIntTextField label="Redondeo (0=recto, 50=redondeado)" min={0} max={200} fullWidth style={{ marginBottom: 12 }}
											value={selectedElement.style?.borderRadius ?? 8}
											onCommit={(n) => effectiveUpdateElement({ ...selectedElement, style: { ...selectedElement.style, borderRadius: n } })} />
										</ErEditAccordion>
										<ErEditAccordion title="Tipografía" nested defaultOpen>
										<DraftIntTextField label="Tamaño de fuente" min={10} max={72} fullWidth helperText="px"
											value={selectedElement.style?.fontSize ?? 14}
											onCommit={(n) => effectiveUpdateElement({ ...selectedElement, style: { ...selectedElement.style, fontSize: n } })} />
										</ErEditAccordion>
									</ErEditAccordion>
									</Box>
									)}

							{selectedElement.type === "button" && (
								<Box ref={(el) => { if (selectedElement?.type === "button") editarSectionRefs.current.contenido = el; }} style={EDITAR_SECTION_SEP}>
								<>
									<ErEditAccordion title="Al hacer clic" icon={TouchAppIcon} defaultOpen>
										<ErEditAccordion title="Acción" nested defaultOpen>
										<Box fontSize={11} color="#64748b" mb={1}>¿Qué pasa cuando el usuario pulsa este botón?</Box>
										<Box display="flex" flexDirection="column" style={{ gap: 8 }}>
											{isModalEditMode ? (
												<>
													{isHintModalEditMode && editingHintModal?.modalType === "confirm" && (
														<>
															<Box onClick={() => { const next = { ...selectedElement.content, action: "confirmHint" }; effectiveUpdateElement({ ...selectedElement, content: next }); }}
																display="flex" alignItems="center" style={{ gap: 12, padding: 12, borderRadius: 10, border: (selectedElement.content?.action || "closeModal") === "confirmHint" ? "2px solid #475569" : "1px solid #e2e8f0", background: (selectedElement.content?.action || "closeModal") === "confirmHint" ? "#f1f5f9" : "#fff", cursor: "pointer" }}>
																<CheckCircleIcon style={{ fontSize: 24, color: "#16a34a" }} />
																<Box><Box fontSize={13} fontWeight={600}>Confirmar pista</Box><Box fontSize={11} color="#64748b">Acepta y cierra la pista</Box></Box>
															</Box>
															<Box onClick={() => { const next = { ...selectedElement.content, action: "cancelHint" }; effectiveUpdateElement({ ...selectedElement, content: next }); }}
																display="flex" alignItems="center" style={{ gap: 12, padding: 12, borderRadius: 10, border: selectedElement.content?.action === "cancelHint" ? "2px solid #475569" : "1px solid #e2e8f0", background: selectedElement.content?.action === "cancelHint" ? "#f1f5f9" : "#fff", cursor: "pointer" }}>
																<CloseIcon style={{ fontSize: 24, color: "#64748b" }} />
																<Box><Box fontSize={13} fontWeight={600}>Cancelar pista</Box><Box fontSize={11} color="#64748b">Cierra sin aceptar</Box></Box>
															</Box>
														</>
													)}
													<Box onClick={() => { effectiveUpdateElement({ ...selectedElement, content: { ...selectedElement.content, action: "closeModal" } }); }}
														display="flex" alignItems="center" style={{ gap: 12, padding: 12, borderRadius: 10, border: (selectedElement.content?.action || "closeModal") === "closeModal" ? "2px solid #475569" : "1px solid #e2e8f0", background: (selectedElement.content?.action || "closeModal") === "closeModal" ? "#f1f5f9" : "#fff", cursor: "pointer" }}>
														<CloseIcon style={{ fontSize: 24, color: "#475569" }} />
														<Box><Box fontSize={13} fontWeight={600}>Cerrar modal</Box><Box fontSize={11} color="#64748b">Cierra esta ventana</Box></Box>
													</Box>
													<Box onClick={() => { effectiveUpdateElement({ ...selectedElement, content: { ...selectedElement.content, action: "nextPage" } }); }}
														display="flex" alignItems="center" style={{ gap: 12, padding: 12, borderRadius: 10, border: (selectedElement.content?.action || "nextPage") === "nextPage" ? "2px solid #475569" : "1px solid #e2e8f0", background: (selectedElement.content?.action || "nextPage") === "nextPage" ? "#f1f5f9" : "#fff", cursor: "pointer" }}>
														<ArrowForwardIcon style={{ fontSize: 24, color: "#475569" }} />
														<Box><Box fontSize={13} fontWeight={600}>Siguiente página</Box><Box fontSize={11} color="#64748b">Pasa a la siguiente</Box></Box>
													</Box>
													<Box onClick={() => { effectiveUpdateElement({ ...selectedElement, content: { ...selectedElement.content, action: "prevPage" } }); }}
														display="flex" alignItems="center" style={{ gap: 12, padding: 12, borderRadius: 10, border: selectedElement.content?.action === "prevPage" ? "2px solid #475569" : "1px solid #e2e8f0", background: selectedElement.content?.action === "prevPage" ? "#f1f5f9" : "#fff", cursor: "pointer" }}>
														<ArrowBackIcon style={{ fontSize: 24, color: "#64748b" }} />
														<Box><Box fontSize={13} fontWeight={600}>Página anterior</Box><Box fontSize={11} color="#64748b">Vuelve atrás</Box></Box>
													</Box>
													<Box onClick={() => { const next = { ...selectedElement.content, action: "goToPage", targetPageId: selectedElement.content?.targetPageId || currentPage?.pageId || currentPage?._id || (pages[0] && (pages[0].pageId || pages[0]._id)) }; effectiveUpdateElement({ ...selectedElement, content: next }); }}
														display="flex" alignItems="center" style={{ gap: 12, padding: 12, borderRadius: 10, border: selectedElement.content?.action === "goToPage" ? "2px solid #475569" : "1px solid #e2e8f0", background: selectedElement.content?.action === "goToPage" ? "#f1f5f9" : "#fff", cursor: "pointer" }}>
														<OpenInNewIcon style={{ fontSize: 24, color: "#64748b" }} />
														<Box><Box fontSize={13} fontWeight={600}>Ir a una página concreta</Box><Box fontSize={11} color="#64748b">Elige a cuál (abajo)</Box></Box>
													</Box>
													<Box onClick={() => { const next = { ...selectedElement.content, action: "openModal", modalSize: selectedElement.content?.modalSize || "medium", modalDesign: selectedElement.content?.modalDesign || { backgroundColor: "#ffffff", elements: [], borderRadius: 12 } }; effectiveUpdateElement({ ...selectedElement, content: next }); }}
														display="flex" alignItems="center" style={{ gap: 12, padding: 12, borderRadius: 10, border: selectedElement.content?.action === "openModal" ? "2px solid #475569" : "1px solid #e2e8f0", background: selectedElement.content?.action === "openModal" ? "#f1f5f9" : "#fff", cursor: "pointer" }}>
														<ViewModuleIcon style={{ fontSize: 24, color: "#64748b" }} />
														<Box><Box fontSize={13} fontWeight={600}>Abrir ventana (modal)</Box><Box fontSize={11} color="#64748b">Muestra contenido en una ventana</Box></Box>
													</Box>
													<Box onClick={() => { const next = { ...selectedElement.content, action: "addPoints", pointsDelta: selectedElement.content?.pointsDelta ?? 10 }; effectiveUpdateElement({ ...selectedElement, content: next }); }}
														display="flex" alignItems="center" style={{ gap: 12, padding: 12, borderRadius: 10, border: selectedElement.content?.action === "addPoints" ? "2px solid #475569" : "1px solid #e2e8f0", background: selectedElement.content?.action === "addPoints" ? "#f1f5f9" : "#fff", cursor: "pointer" }}>
														<EmojiEventsIcon style={{ fontSize: 24, color: "#64748b" }} />
														<Box><Box fontSize={13} fontWeight={600}>Sumar puntos</Box><Box fontSize={11} color="#64748b">Suma o resta puntos (negativo permitido)</Box></Box>
													</Box>
												</>
											) : (
												<>
													<Box onClick={() => { effectiveUpdateElement({ ...selectedElement, content: { ...selectedElement.content, action: "nextPage" } }); }}
														display="flex" alignItems="center" style={{ gap: 12, padding: 12, borderRadius: 10, border: (selectedElement.content?.action || "nextPage") === "nextPage" ? "2px solid #475569" : "1px solid #e2e8f0", background: (selectedElement.content?.action || "nextPage") === "nextPage" ? "#f1f5f9" : "#fff", cursor: "pointer" }}>
														<ArrowForwardIcon style={{ fontSize: 24, color: "#475569" }} />
														<Box><Box fontSize={13} fontWeight={600}>Siguiente página</Box><Box fontSize={11} color="#64748b">Pasa a la siguiente</Box></Box>
													</Box>
													<Box onClick={() => { effectiveUpdateElement({ ...selectedElement, content: { ...selectedElement.content, action: "prevPage" } }); }}
														display="flex" alignItems="center" style={{ gap: 12, padding: 12, borderRadius: 10, border: selectedElement.content?.action === "prevPage" ? "2px solid #475569" : "1px solid #e2e8f0", background: selectedElement.content?.action === "prevPage" ? "#f1f5f9" : "#fff", cursor: "pointer" }}>
														<ArrowBackIcon style={{ fontSize: 24, color: "#64748b" }} />
														<Box><Box fontSize={13} fontWeight={600}>Página anterior</Box><Box fontSize={11} color="#64748b">Vuelve atrás</Box></Box>
													</Box>
													<Box onClick={() => { const next = { ...selectedElement.content, action: "goToPage", targetPageId: selectedElement.content?.targetPageId || currentPage?.pageId || currentPage?._id || (pages[0] && (pages[0].pageId || pages[0]._id)) }; effectiveUpdateElement({ ...selectedElement, content: next }); }}
														display="flex" alignItems="center" style={{ gap: 12, padding: 12, borderRadius: 10, border: selectedElement.content?.action === "goToPage" ? "2px solid #475569" : "1px solid #e2e8f0", background: selectedElement.content?.action === "goToPage" ? "#f1f5f9" : "#fff", cursor: "pointer" }}>
														<OpenInNewIcon style={{ fontSize: 24, color: "#64748b" }} />
														<Box><Box fontSize={13} fontWeight={600}>Ir a una página concreta</Box><Box fontSize={11} color="#64748b">Elige a cuál (abajo)</Box></Box>
													</Box>
													<Box onClick={() => { const next = { ...selectedElement.content, action: "openModal", modalSize: selectedElement.content?.modalSize || "medium", modalDesign: selectedElement.content?.modalDesign || { backgroundColor: "#ffffff", elements: [], borderRadius: 12 } }; effectiveUpdateElement({ ...selectedElement, content: next }); }}
														display="flex" alignItems="center" style={{ gap: 12, padding: 12, borderRadius: 10, border: selectedElement.content?.action === "openModal" ? "2px solid #475569" : "1px solid #e2e8f0", background: selectedElement.content?.action === "openModal" ? "#f1f5f9" : "#fff", cursor: "pointer" }}>
														<ViewModuleIcon style={{ fontSize: 24, color: "#64748b" }} />
														<Box><Box fontSize={13} fontWeight={600}>Abrir ventana (modal)</Box><Box fontSize={11} color="#64748b">Muestra contenido en una ventana</Box></Box>
													</Box>
													<Box onClick={() => { const next = { ...selectedElement.content, action: "addPoints", pointsDelta: selectedElement.content?.pointsDelta ?? 10 }; effectiveUpdateElement({ ...selectedElement, content: next }); }}
														display="flex" alignItems="center" style={{ gap: 12, padding: 12, borderRadius: 10, border: selectedElement.content?.action === "addPoints" ? "2px solid #475569" : "1px solid #e2e8f0", background: selectedElement.content?.action === "addPoints" ? "#f1f5f9" : "#fff", cursor: "pointer" }}>
														<EmojiEventsIcon style={{ fontSize: 24, color: "#64748b" }} />
														<Box><Box fontSize={13} fontWeight={600}>Sumar puntos</Box><Box fontSize={11} color="#64748b">Suma o resta puntos (negativo permitido)</Box></Box>
													</Box>
												</>
											)}
										</Box>
										</ErEditAccordion>
										{selectedElement.content?.action === "addPoints" && (
											<ErEditAccordion title="Puntos" nested defaultOpen>
												<TextField
													label="Puntos (puede ser negativo)"
													type="number"
													size="small"
													fullWidth
													variant="outlined"
													helperText="Activa «Un solo uso» si no quieres que se pueda pulsar varias veces."
													inputProps={{ step: 1 }}
													value={selectedElement.content?.pointsDelta ?? 10}
													onChange={(e) => {
														const n = Number(e.target.value);
														effectiveUpdateElement({
															...selectedElement,
															content: {
																...selectedElement.content,
																pointsDelta: Number.isFinite(n) ? n : 0,
															},
														});
													}}
												/>
											</ErEditAccordion>
										)}
										{selectedElement.content?.action === "openModal" && (
											<ErEditAccordion title="Ventana modal" nested defaultOpen>
												<Box fontSize={12} fontWeight={600} color="#475569" mb={1}>Tamaño del modal</Box>
												<FormControl size="small" fullWidth variant="outlined">
													<Select value={selectedElement.content?.modalSize || "medium"} onChange={(e) => effectiveUpdateElement({ ...selectedElement, content: { ...selectedElement.content, modalSize: e.target.value } })}>
														{MODAL_SIZES.map((s) => <MenuItem key={s.id} value={s.id}>{s.label} ({s.width}×{s.height})</MenuItem>)}
													</Select>
												</FormControl>
												<Button fullWidth variant="contained" color="primary" startIcon={<EditIcon />} onClick={() => setEditingModalButton(selectedElement)} style={{ marginTop: 12, textTransform: "none" }}>
													Editar contenido del modal
												</Button>
											</ErEditAccordion>
										)}
										{selectedElement.content?.action === "goToPage" && (
											<ErEditAccordion title="Página de destino" nested defaultOpen>
												<Box fontSize={12} fontWeight={600} color="#475569" mb={1}>Elige la página de destino</Box>
												<Box display="flex" flexDirection="column" style={{ gap: 10 }}>
													{(() => {
														const sortedScenarios = [...(scenariosRaw || [])].sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
														const scenarioBlocks = sortedScenarios
															.map((sc) => ({
																id: String(sc.id || ""),
																label: sc.name || "Escenario",
																pages: pages.filter((p) => (p.pageId || p._id) !== REGISTRATION_PAGE_ID && String(p.scenarioId || "") === String(sc.id || "")),
															}))
															.filter((b) => b.pages.length > 0);
														const registrationPages = pages.filter((p) => (p.pageId || p._id) === REGISTRATION_PAGE_ID);
														const unassignedPages = pages.filter((p) => (p.pageId || p._id) !== REGISTRATION_PAGE_ID && !String(p.scenarioId || "").trim());
														const blocks = [
															...registrationPages.length ? [{ id: "registration", label: "Registro", pages: registrationPages }] : [],
															...scenarioBlocks,
															...unassignedPages.length ? [{ id: "without-scenario", label: "Sin escenario", pages: unassignedPages }] : [],
														];
														return blocks.map((block) => (
															<Box key={block.id}>
																<Box fontSize={11} fontWeight={700} color="#64748b" mb={0.75}>{block.label}</Box>
																<Box display="flex" flexWrap="wrap" style={{ gap: 8 }}>
																	{block.pages.map((page) => {
																		const pageId = page.pageId || page._id;
																		const isSelected = (selectedElement.content?.targetPageId || "") === pageId;
																		const bgUrl = page.backgroundImageUrl ? resolveEscapeRoomMediaUrl(page.backgroundImageUrl) : undefined;
																		const pageNum = pages.findIndex((p) => (p.pageId || p._id) === pageId) + 1;
																		return (
																			<Box key={pageId} onClick={() => effectiveUpdateElement({ ...selectedElement, content: { ...selectedElement.content, targetPageId: pageId } })}
																				style={{ width: "calc(50% - 4px)", borderRadius: 10, overflow: "hidden", border: isSelected ? "2px solid #7c3aed" : "1px solid #e2e8f0", background: isSelected ? "#f5f3ff" : "#fff", cursor: "pointer" }}>
																				<PagePreviewThumbnail elements={page.elements || []} registrationDesign={(page.pageId || page._id) === REGISTRATION_PAGE_ID ? page.registrationDesign : undefined} isRegistration={(page.pageId || page._id) === REGISTRATION_PAGE_ID} backgroundColor={(page.pageId || page._id) !== REGISTRATION_PAGE_ID ? page.backgroundColor : undefined} backgroundImageUrl={bgUrl} backgroundImageOpacity={page.backgroundImageOpacity} quizzes={quizzes} />
																				<Box fontSize={11} fontWeight={600} color={isSelected ? "#7c3aed" : "#334155"} textAlign="center" py={0.75}>{`Página ${pageNum}`}</Box>
																			</Box>
																		);
																	})}
																</Box>
															</Box>
														));
													})()}
												</Box>
											</ErEditAccordion>
										)}
									</ErEditAccordion>
									{(() => {
										const inModal = isModalEditMode;
										const showWhenValue = selectedElement.content?.showWhen || "always";
										const showWhenOptions = [
											{ value: "always", label: "Siempre visible", hint: "Se muestra desde el inicio", Icon: VisibilityOutlinedIcon },
											{ value: "afterSeconds", label: "Al cabo de X segundos", hint: inModal ? "Al abrir el modal" : "Al entrar en la página", Icon: ScheduleIcon },
											{ value: "quizCompleted", label: "Al completar el quiz", hint: inModal ? "Cuando acabe el quiz del modal" : "Cuando acabe el quiz de la página", Icon: LiveHelpIcon },
											{ value: "allButtonsActivated", label: "Tras pulsar todos los botones", hint: inModal ? "Los demás botones del modal" : "Los demás botones de esta página", Icon: DoneAllIcon },
										];
										const hideAfter = Math.max(0, Number(selectedElement.content?.hideAfterSeconds) || 0);
										const hideTimed = hideAfter > 0;
										const cardStyle = (selected) => ({
											gap: 12,
											padding: 12,
											borderRadius: 10,
											border: selected ? "2px solid #475569" : "1px solid #e2e8f0",
											background: selected ? "#f1f5f9" : "#fff",
											cursor: "pointer",
										});
										return (
											<Box mb={3} p={2.5} borderRadius={12} style={{ background: "#f8fafc", border: "1px solid #e2e8f0" }}>
												<Box fontSize={14} fontWeight={700} color="#334155" mb={1.5} display="flex" alignItems="center" style={{ gap: 10 }}>
													<Box p={1} borderRadius={10} style={{ background: "#64748b", color: "#fff" }}>
														<VisibilityOutlinedIcon style={{ fontSize: 22 }} />
													</Box>
													Cuándo se ve el botón
												</Box>
												<Box fontSize={11} color="#64748b" mb={2}>Controla cuándo aparece y si desaparece solo.</Box>

												<Box fontSize={12} fontWeight={700} color="#475569" mb={1} style={{ letterSpacing: "0.04em", textTransform: "uppercase" }}>
													Aparece
												</Box>
												<Box display="flex" flexDirection="column" style={{ gap: 8 }} mb={2.5}>
													{showWhenOptions.map(({ value, label, hint, Icon: OptIcon }) => {
														const selected = showWhenValue === value;
														return (
															<Box
																key={value}
																onClick={() => effectiveUpdateElement({
																	...selectedElement,
																	content: { ...selectedElement.content, showWhen: value },
																})}
																style={cardStyle(selected)}
															>
																<Box display="flex" alignItems="center" style={{ gap: 12 }}>
																	<OptIcon style={{ fontSize: 24, color: selected ? "#475569" : "#64748b", flexShrink: 0 }} />
																	<Box minWidth={0} flex={1}>
																		<Box fontSize={13} fontWeight={600} color="#334155">{label}</Box>
																		<Box fontSize={11} color="#64748b">{hint}</Box>
																	</Box>
																</Box>
																{selected && value === "afterSeconds" ? (
																	<Box mt={1.5} onClick={(e) => e.stopPropagation()}>
																		<TextField
																			label="Aparecer a los (s)"
																			type="number"
																			size="small"
																			fullWidth
																			variant="outlined"
																			inputProps={{ min: 0, max: 600, step: 0.5 }}
																			value={selectedElement.content?.showAfterSeconds ?? 0}
																			onChange={(e) => effectiveUpdateElement({
																				...selectedElement,
																				content: {
																					...selectedElement.content,
																					showAfterSeconds: Math.max(0, Number(e.target.value) || 0),
																				},
																			})}
																		/>
																	</Box>
																) : null}
															</Box>
														);
													})}
												</Box>

												<Box fontSize={12} fontWeight={700} color="#475569" mb={1} style={{ letterSpacing: "0.04em", textTransform: "uppercase" }}>
													Desaparece
												</Box>
												<Box display="flex" flexDirection="column" style={{ gap: 8 }}>
													<Box
														onClick={() => effectiveUpdateElement({
															...selectedElement,
															content: { ...selectedElement.content, hideAfterSeconds: 0 },
														})}
														display="flex"
														alignItems="center"
														style={cardStyle(!hideTimed)}
													>
														<VisibilityOutlinedIcon style={{ fontSize: 24, color: !hideTimed ? "#475569" : "#64748b", flexShrink: 0 }} />
														<Box minWidth={0}>
															<Box fontSize={13} fontWeight={600} color="#334155">No desaparece</Box>
															<Box fontSize={11} color="#64748b">Se queda visible en la página</Box>
														</Box>
													</Box>
													<Box
														onClick={() => {
															if (!hideTimed) {
																effectiveUpdateElement({
																	...selectedElement,
																	content: { ...selectedElement.content, hideAfterSeconds: 5 },
																});
															}
														}}
														style={cardStyle(hideTimed)}
													>
														<Box display="flex" alignItems="center" style={{ gap: 12 }}>
															<ScheduleIcon style={{ fontSize: 24, color: hideTimed ? "#475569" : "#64748b", flexShrink: 0 }} />
															<Box minWidth={0} flex={1}>
																<Box fontSize={13} fontWeight={600} color="#334155">Al cabo de X segundos</Box>
																<Box fontSize={11} color="#64748b">Tras aparecer, se oculta solo</Box>
															</Box>
														</Box>
														{hideTimed ? (
															<Box mt={1.5} onClick={(e) => e.stopPropagation()}>
																<TextField
																	label="Desaparecer después de (s)"
																	type="number"
																	size="small"
																	fullWidth
																	variant="outlined"
																	helperText="Tras aparecer. 0 = no desaparece solo."
																	inputProps={{ min: 0.5, max: 600, step: 0.5 }}
																	value={hideAfter}
																	onChange={(e) => {
																		const n = Math.max(0, Number(e.target.value) || 0);
																		effectiveUpdateElement({
																			...selectedElement,
																			content: {
																				...selectedElement.content,
																				hideAfterSeconds: n,
																			},
																		});
																	}}
																/>
															</Box>
														) : null}
													</Box>
												</Box>
											</Box>
										);
									})()}
								</>
								</Box>
								)}
								{selectedElement.type === "button" && (
									<Box ref={(el) => { if (selectedElement?.type === "button") editarSectionRefs.current.comportamiento = el; }} style={EDITAR_SECTION_SEP}>
									<ErEditAccordion title="Latido y un solo uso" icon={TouchAppIcon} defaultOpen={false}>
										<ErEditAccordion title="Latido" nested defaultOpen>
											<Tooltip title="El botón late en bucle para llamar la atención">
												<Box
													display="flex"
													alignItems="center"
													justifyContent="space-between"
													style={{ gap: 12, marginTop: 14, padding: "10px 12px", borderRadius: 10, background: "#fff", border: "1px solid #e2e8f0" }}
												>
													<Box display="flex" alignItems="center" style={{ gap: 10, minWidth: 0 }}>
														<FavoriteIcon style={{ fontSize: 22, color: "#64748b" }} />
														<Box>
															<Box fontSize={13} fontWeight={600} color="#334155">Latido</Box>
														</Box>
													</Box>
													<Switch
														checked={!!selectedElement.content?.continuousPulse}
														onChange={(e) => effectiveUpdateElement({ ...selectedElement, content: { ...selectedElement.content, continuousPulse: e.target.checked } })}
														color="primary"
													/>
												</Box>
											</Tooltip>
										</ErEditAccordion>
										<ErEditAccordion title="Un solo uso" nested defaultOpen>
											<Tooltip title="Solo se puede pulsar una vez; luego queda desactivado">
												<Box
													display="flex"
													alignItems="center"
													justifyContent="space-between"
													style={{ gap: 12, padding: "10px 12px", borderRadius: 10, background: "#f8fafc", border: "1px solid #e2e8f0" }}
												>
													<Box display="flex" alignItems="center" style={{ gap: 10, minWidth: 0 }}>
														<LockIcon style={{ fontSize: 22, color: "#64748b" }} />
														<Box fontSize={13} fontWeight={600} color="#334155">Activar un solo uso</Box>
													</Box>
													<Switch
														checked={!!selectedElement.content?.onlyOnce}
														onChange={(e) => effectiveUpdateElement({ ...selectedElement, content: { ...selectedElement.content, onlyOnce: e.target.checked } })}
														color="primary"
													/>
												</Box>
											</Tooltip>
										</ErEditAccordion>
									</ErEditAccordion>
									</Box>
								)}
								{selectedElement.type === "button" && (
									<Box ref={(el) => { if (selectedElement?.type === "button") editarSectionRefs.current.estilo = el; }} style={EDITAR_SECTION_SEP}>
										<ButtonElementStylePanel
											selectedElement={selectedElement}
											effectiveUpdateElement={effectiveUpdateElement}
											allFontOptions={allFontOptions}
											fontLabel={fontLabel}
											onOpenFontManager={() => {
												setFontManagerTarget("button");
												setFontManagerOpen(true);
											}}
											onOpenIconPicker={() => {
												setIconPickerSearch("");
												setIconPickerOpen(true);
											}}
											onOpenButtonImagePicker={(target) => {
												setButtonImagePickerTarget(target);
												setImageElementPickerOpen(true);
											}}
										/>
									</Box>
								)}

							{selectedElement.type === "shape" && (
								<Box ref={(el) => { if (selectedElement?.type === "shape") editarSectionRefs.current.contenido = el; }} style={EDITAR_SECTION_SEP}>
									<ShapeElementContentPanel selectedElement={selectedElement} effectiveUpdateElement={effectiveUpdateElement} />
								</Box>
								)}
								{selectedElement.type === "shape" && (
									<Box ref={(el) => { if (selectedElement?.type === "shape") editarSectionRefs.current.estilo = el; }} style={EDITAR_SECTION_SEP}>
										<ShapeElementStylePanel selectedElement={selectedElement} effectiveUpdateElement={effectiveUpdateElement} />
									</Box>
								)}

							{selectedElement && !isRegistrationPage && (
								<Box ref={(el) => { editarSectionRefs.current.animacion = el; }} style={EDITAR_SECTION_SEP}>
									<ElementEntryAnimationPanel
										selectedElement={selectedElement}
										effectiveUpdateElement={effectiveUpdateElement}
									/>
								</Box>
							)}

							<Box ref={(el) => { editarSectionRefs.current.posicion = el; }} style={EDITAR_SECTION_SEP}>
								<ErEditAccordion title="Ubicación" icon={LocationOnIcon} defaultOpen>
								<ErEditAccordion title="Coordenadas" nested defaultOpen>
								<Box display="flex" style={{ gap: 10 }}>
									<DraftIntTextField label="X" min={-2000} max={8000} allowNegative value={selectedElement.x}
										onCommit={(n) => effectiveUpdateElement({ ...selectedElement, x: n })}
										style={{ flex: 1 }} />
									<DraftIntTextField label="Y" min={-2000} max={8000} allowNegative value={selectedElement.y}
										onCommit={(n) => effectiveUpdateElement({ ...selectedElement, y: n })}
										style={{ flex: 1 }} />
								</Box>
								</ErEditAccordion>
								<ErEditAccordion title="Centrar en lienzo" nested defaultOpen>
								<Box display="flex" style={{ gap: 10, flexWrap: "nowrap" }}>
									<Tooltip title="Centrar el elemento en el eje horizontal del lienzo">
										<Button
											size="medium"
											variant="outlined"
											fullWidth
											startIcon={<FormatAlignCenterIcon style={{ fontSize: 20 }} />}
											onClick={() => {
												const vp = effectiveViewportDim || { width: CANVAS_WIDTH, height: CANVAS_HEIGHT };
												const w = selectedElement.width || 100;
												const centerX = Math.round(vp.width / 2 - w / 2);
												effectiveUpdateElement({ ...selectedElement, x: centerX });
											}}
											style={{ textTransform: "none", padding: "10px 14px", whiteSpace: "nowrap", flex: 1, minWidth: 0 }}
										>
											↔ Centro X
										</Button>
									</Tooltip>
									<Tooltip title="Centrar el elemento en el eje vertical del lienzo">
										<Button
											size="medium"
											variant="outlined"
											fullWidth
											startIcon={<VerticalAlignCenterIcon style={{ fontSize: 20 }} />}
											onClick={() => {
												const vp = effectiveViewportDim || { width: CANVAS_WIDTH, height: CANVAS_HEIGHT };
												const h = selectedElement.height || 50;
												const centerY = Math.round(vp.height / 2 - h / 2);
												effectiveUpdateElement({ ...selectedElement, y: centerY });
											}}
											style={{ textTransform: "none", padding: "10px 14px", whiteSpace: "nowrap", flex: 1, minWidth: 0 }}
										>
											↕ Centro Y
										</Button>
									</Tooltip>
								</Box>
								</ErEditAccordion>
								</ErEditAccordion>
							</Box>
							<Box ref={(el) => { editarSectionRefs.current.tamano = el; }} style={EDITAR_SECTION_SEP}>
								<ErEditAccordion title="Tamaño" icon={AspectRatioIcon} defaultOpen>
								<ErEditAccordion title="Dimensiones" nested defaultOpen>
								<Box display="flex" justifyContent="flex-end" style={{ gap: 4, marginBottom: 10 }}>
									<Tooltip title="Copiar tamaño">
										<IconButton size="small" onClick={() => { copiedSizeRef.current = { width: selectedElement.width || 100, height: selectedElement.height || 50 }; setHasCopiedSize(true); }} style={{ padding: 6 }}>
											<FileCopyIcon style={{ fontSize: 18, color: "#64748b" }} />
										</IconButton>
									</Tooltip>
									<Tooltip title="Pegar tamaño">
										<IconButton size="small" onClick={() => { const s = copiedSizeRef.current; if (s) effectiveUpdateElement({ ...selectedElement, width: s.width, height: s.height }); }} disabled={!hasCopiedSize} style={{ padding: 6 }}>
											<AssignmentIcon style={{ fontSize: 18, color: hasCopiedSize ? "#64748b" : "#cbd5e1" }} />
										</IconButton>
									</Tooltip>
								</Box>
								<Box display="flex" style={{ gap: 10 }}>
									<DraftIntTextField label="Ancho" min={1} max={8000} value={selectedElement.width}
										onCommit={(n) => effectiveUpdateElement({ ...selectedElement, width: n })}
										style={{ flex: 1 }} />
									<DraftIntTextField label="Alto" min={1} max={8000} value={selectedElement.height}
										onCommit={(n) => effectiveUpdateElement({ ...selectedElement, height: n })}
										style={{ flex: 1 }} />
								</Box>
								</ErEditAccordion>
								</ErEditAccordion>
							</Box>

							<Box mt={2} pt={2} style={{ borderTop: "1px solid #e2e8f0" }}>
							<Button
								fullWidth
								color="secondary"
								variant="outlined"
								size="medium"
								startIcon={<DeleteIcon />}
								onClick={() => effectiveRemoveElement(selectedElement.elementId)}
								style={{ textTransform: "none", padding: "10px 16px" }}
							>
								Eliminar elemento
							</Button>
							</Box>
									</>
								) : addPanelCategory === "editar" && !selectedElement && isRegistrationPage ? (
									<Box p={2} textAlign="center" color="text.secondary" fontSize={13}>
										Selecciona un elemento en el lienzo para editarlo
									</Box>
								) : addPanelCategory === "editar" && !selectedElement && isModalEditMode ? (
									<Box mb={3} p={2.5} borderRadius={12} style={{ background: "#f8fafc", border: "1px solid #e2e8f0" }}>
										<Box fontSize={13} fontWeight={600} color="#334155" mb={1.5} display="flex" alignItems="center" style={{ gap: 8 }}>
											<Box p={0.75} borderRadius={8} style={{ background: "#fff", border: "1px solid #e2e8f0" }}>
												<PaletteIcon style={{ fontSize: 18, color: "#64748b" }} />
											</Box>
											Diseño del modal
										</Box>
										<Box mb={1.5}>
											<RgbaColorPickerPopover
												label="Color de fondo"
												value={isButtonModalEditMode ? (getModalDesign().backgroundColor || "#ffffff") : (getHintModalDesign().backgroundColor || "#ffffff")}
												onChange={(color) => (isButtonModalEditMode ? updateModalDesign({ backgroundColor: color }) : updateHintModalDesign({ backgroundColor: color }))}
											/>
										</Box>
										<DraftIntTextField label="Redondeo (0=recto, 24=muy redondeado)" min={0} max={48} fullWidth
											value={isButtonModalEditMode ? (getModalDesign().borderRadius ?? 12) : (getHintModalDesign().borderRadius ?? 12)}
											onCommit={(n) => (isButtonModalEditMode ? updateModalDesign({ borderRadius: n }) : updateHintModalDesign({ borderRadius: n }))} />
									</Box>
								) : addPanelCategory === "editar" && !selectedElement && !isRegistrationPage ? (
									<>
										<ErEditAccordion title="Fondo de la página" icon={PaletteIcon} defaultOpen>
											<ErEditAccordion title="Imagen" nested defaultOpen>
												<Box
													onClick={() => setBackgroundPickerOpen(true)}
													display="flex"
													alignItems="center"
													style={{
														gap: 12, padding: 12, borderRadius: 12, background: "#fff",
														border: "1px solid #e2e8f0", cursor: "pointer", transition: "all 0.2s ease",
													}}
													onMouseEnter={(e) => { e.currentTarget.style.borderColor = "#7c3aed"; e.currentTarget.style.boxShadow = "0 0 0 1px rgba(124,58,237,0.2)"; }}
													onMouseLeave={(e) => { e.currentTarget.style.borderColor = "#e2e8f0"; e.currentTarget.style.boxShadow = "none"; }}
												>
													<Box style={{ width: 56, height: 42, borderRadius: 8, flexShrink: 0, background: currentPage?.backgroundImageUrl ? `url(${resolveEscapeRoomMediaUrl(currentPage.backgroundImageUrl)}) center/cover` : "linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%)", border: currentPage?.backgroundImageUrl ? "none" : "2px dashed #cbd5e1" }} />
													<Box flex={1} minWidth={0}>
														<Box fontSize={13} fontWeight={600} color="#1e293b">{currentPage?.backgroundImageUrl ? "Imagen asignada" : "Sin imagen"}</Box>
														<Box fontSize={11} color="#94a3b8">{currentPage?.backgroundImageUrl ? "Clic para cambiar" : "Clic para elegir o subir"}</Box>
													</Box>
													{currentPage?.backgroundImageUrl ? (
														<IconButton size="small" onClick={(e) => { e.stopPropagation(); updatePageDesign({ backgroundImageUrl: "" }); }} title="Quitar imagen">
															<DeleteIcon style={{ fontSize: 18, color: "#94a3b8" }} />
														</IconButton>
													) : (
														<ImageIcon style={{ fontSize: 22, color: "#cbd5e1" }} />
													)}
												</Box>
												{currentPage?.backgroundImageUrl && (
													<Box mt={2}>
														<Tooltip title="Opacidad de la imagen de fondo">
															<Box display="flex" alignItems="center" style={{ gap: 12, padding: "12px 14px", minHeight: 48, borderRadius: 10, background: "#fff", border: "1px solid #e2e8f0" }} mb={1}>
																<OpacityIcon style={{ fontSize: 22, color: "#64748b" }} />
																<Box fontSize={13} fontWeight={600} color="#475569">Opacidad</Box>
																<Box fontSize={13} color="#64748b" ml="auto">{currentPage?.backgroundImageOpacity != null ? Math.round(currentPage.backgroundImageOpacity) : 100}%</Box>
															</Box>
														</Tooltip>
														<Slider
															value={currentPage?.backgroundImageOpacity != null ? currentPage.backgroundImageOpacity : 100}
															onChange={(_, v) => updatePageDesign({ backgroundImageOpacity: v })}
															min={0} max={100} valueLabelDisplay="auto" valueLabelFormat={(v) => `${v}%`}
															style={{ color: "#7c3aed" }}
														/>
													</Box>
												)}
											</ErEditAccordion>
											<input ref={backgroundFileInputRef} type="file" accept="image/*" style={{ display: "none" }} onChange={handleUploadAndSelectBackground} />
											<ErEditAccordion title="Color de fondo" nested defaultOpen>
												<Box display="flex" alignItems="center" style={{ gap: 10 }}>
													<HexColorPickerPopover value={currentPage?.backgroundColor || "#ffffff"} onChange={(c) => updatePageDesign({ backgroundColor: c })} />
													<Box fontSize={12} color="#64748b" style={{ fontFamily: "monospace" }}>{currentPage?.backgroundColor || "#ffffff"}</Box>
												</Box>
											</ErEditAccordion>
											<ErEditAccordion title="Aplicar a todas las páginas" nested>
												<Button variant="contained" fullWidth onClick={applyBackgroundToAllPages}
													style={{ textTransform: "none", padding: "10px 16px", borderRadius: 10, background: "linear-gradient(135deg, #7c3aed 0%, #6d28d9 100%)", color: "#fff", boxShadow: "0 2px 8px rgba(124,58,237,0.3)" }}>
													Aplicar fondo a todas las páginas
												</Button>
											</ErEditAccordion>
										</ErEditAccordion>
										<ErEditAccordion title="Animación entre páginas" icon={SwapHorizIcon}>
											<ErEditAccordion title="Transición" nested defaultOpen>
												<PageTransitionPicker
													value={currentPage?.transitionToNext || "none"}
													onChange={(id) => updatePageDesign({ transitionToNext: id })}
													helperText="Pasa el cursor sobre una tarjeta para ver la animación."
												/>
											</ErEditAccordion>
											<ErEditAccordion title="Velocidad" nested defaultOpen>
												<FormControl variant="outlined" size="small" fullWidth>
													<InputLabel>Velocidad</InputLabel>
													<Select
														value={(() => {
															const d = currentPage?.transitionDuration ?? 350;
															return TRANSITION_SPEEDS.some((s) => s.ms === d) ? d : 350;
														})()}
														onChange={(e) => updatePageDesign({ transitionDuration: Number(e.target.value) })}
														label="Velocidad"
														style={{ fontSize: 14 }}
													>
														{TRANSITION_SPEEDS.map((s) => (
															<MenuItem key={s.ms} value={s.ms}>{s.label}</MenuItem>
														))}
													</Select>
												</FormControl>
											</ErEditAccordion>
											<ErEditAccordion title="Aplicar a todas las páginas" nested>
												<Button variant="outlined" fullWidth onClick={applyAnimationToAllPages}
													style={{ textTransform: "none", padding: "8px 16px", borderRadius: 10, borderColor: "#7c3aed", color: "#7c3aed" }}>
													Aplicar animación a todas las páginas
												</Button>
											</ErEditAccordion>
										</ErEditAccordion>
										<ErEditAccordion title="Puntos por aterrizar" icon={EmojiEventsIcon}>
											<ErEditAccordion title="Puntos al llegar" nested defaultOpen>
											<TextField
												type="number"
												size="small"
												fullWidth
												variant="outlined"
												label="Puntos al llegar a esta página"
												value={pointsOnLandDraft !== null ? pointsOnLandDraft : String(currentPage?.pointsOnLand ?? 0)}
												onFocus={() => setPointsOnLandDraft(String(currentPage?.pointsOnLand ?? 0))}
												onChange={(e) => setPointsOnLandDraft(e.target.value)}
												onBlur={() => {
													if (pointsOnLandDraft === null) return;
													const num = Number(pointsOnLandDraft);
													const final = Number.isNaN(num) ? 0 : Math.max(-9999, Math.min(9999, num));
													updatePageDesign({ pointsOnLand: final });
													setPointsOnLandDraft(null);
												}}
												inputProps={{
													min: -9999,
													max: 9999,
													onKeyDown: (e) => {
														if (e.key === "Enter") {
															e.preventDefault();
															e.target.blur();
														}
													},
												}}
												style={{ fontSize: 14 }}
											/>
											</ErEditAccordion>
										</ErEditAccordion>
										<ErEditAccordion title="Temporizador en esta página" icon={ScheduleIcon}>
											<ErEditAccordion title="Comportamiento del tiempo" nested defaultOpen>
											{(() => {
												const runs = currentPage?.timerRuns !== false;
												return (
													<Box display="flex" style={{ gap: 10 }}>
														<Box
															onClick={() => updatePageDesign({ timerRuns: true })}
															flex={1}
															style={{
																cursor: "pointer",
																padding: 12,
																borderRadius: 12,
																border: runs ? "2px solid #7c3aed" : "1px solid #e2e8f0",
																background: runs ? "#f5f3ff" : "#fff",
																boxShadow: runs ? "0 2px 8px rgba(124,58,237,0.14)" : "none",
																transition: "all 0.15s ease",
															}}
														>
															<Box display="flex" alignItems="center" style={{ gap: 8, marginBottom: 6 }}>
																<PlayArrowIcon style={{ fontSize: 20, color: runs ? "#7c3aed" : "#64748b" }} />
																<Box fontSize={13} fontWeight={700} color="#334155">Tiempo activo</Box>
															</Box>
														</Box>
														<Box
															onClick={() => updatePageDesign({ timerRuns: false })}
															flex={1}
															style={{
																cursor: "pointer",
																padding: 12,
																borderRadius: 12,
																border: !runs ? "2px solid #7c3aed" : "1px solid #e2e8f0",
																background: !runs ? "#f5f3ff" : "#fff",
																boxShadow: !runs ? "0 2px 8px rgba(124,58,237,0.14)" : "none",
																transition: "all 0.15s ease",
															}}
														>
															<Box display="flex" alignItems="center" style={{ gap: 8, marginBottom: 6 }}>
																<PauseIcon style={{ fontSize: 20, color: !runs ? "#7c3aed" : "#64748b" }} />
																<Box fontSize={13} fontWeight={700} color="#334155">Tiempo pausado</Box>
															</Box>
														</Box>
													</Box>
												);
											})()}
											</ErEditAccordion>
										</ErEditAccordion>
										<ErEditAccordion title="Barra de progreso" icon={ViewModuleIcon}>
											<ErEditAccordion title="Visibilidad" nested defaultOpen>
											<Box display="flex" flexDirection="column" style={{ gap: 6 }}>
												{(() => {
														const show = !!currentPage?.showFooter;
														return (
															<>
																<Box onClick={() => updatePageDesign({ showFooter: true })} style={{ display: "flex", alignItems: "center", gap: 10, padding: "10px 12px", borderRadius: 10, border: show ? "2px solid #7c3aed" : "1px solid #e2e8f0", background: show ? "#f5f3ff" : "#fff", cursor: "pointer" }}>
																	{show ? <CheckCircleIcon style={{ fontSize: 20, color: "#7c3aed" }} /> : <RadioButtonUncheckedIcon style={{ fontSize: 20, color: "#94a3b8" }} />}
																	<Box fontSize={14} fontWeight={500} color="#334155">Mostrar en esta página</Box>
																</Box>
																<Box onClick={() => updatePageDesign({ showFooter: false })} style={{ display: "flex", alignItems: "center", gap: 10, padding: "10px 12px", borderRadius: 10, border: !show ? "2px solid #7c3aed" : "1px solid #e2e8f0", background: !show ? "#f5f3ff" : "#fff", cursor: "pointer" }}>
																	{!show ? <CheckCircleIcon style={{ fontSize: 20, color: "#7c3aed" }} /> : <RadioButtonUncheckedIcon style={{ fontSize: 20, color: "#94a3b8" }} />}
																	<Box fontSize={14} fontWeight={500} color="#334155">Ocultar en esta página</Box>
																</Box>
															</>
														);
													})()}
												</Box>
											</ErEditAccordion>
										</ErEditAccordion>
									</>
								) : addPanelCategory === "configuracion" && isRegistrationPage ? (
									<Box p={2}>
										<Box fontSize={16} fontWeight={700} color="#1e293b" mb={3}>Configuración</Box>
										<Box mb={3} p={2} borderRadius={12} style={{ background: "#f8fafc", border: "1px solid #e2e8f0" }}>
											<Box fontSize={13} fontWeight={600} color="#334155" mb={0.5}>Registro (web)</Box>
											<Box fontSize={11} color="#64748b" mb={1.5} lineHeight={1.4}>
												Opcional. Si cambias algo, manda sobre la configuración del juego.
											</Box>
											{(() => {
												const rc = { ...(currentPage?.registrationDesign?.registerConfig || {}) };
												const modeStored = rc.mode === "simple" || rc.mode === "table" ? rc.mode : null;
												const setRegCfg = (next) => updateRegistrationDesign({ registerConfig: next });
												const pickMode = (m) => {
													setRegCfg({ ...rc, mode: m });
												};
												const photoStored = typeof rc.photoEnabled === "boolean" ? rc.photoEnabled : null;
												const pickPhoto = (v) => {
													setRegCfg({ ...rc, photoEnabled: v });
												};
												const maxPeopleVal = rc.maxPeoplePerTable != null && Number.isFinite(Number(rc.maxPeoplePerTable))
													? String(rc.maxPeoplePerTable)
													: "";
												const numTablesVal = rc.numTables != null && Number.isFinite(Number(rc.numTables)) && Number(rc.numTables) > 0
													? String(rc.numTables)
													: "";
												return (
													<>
														<FormControl variant="outlined" size="small" fullWidth style={{ marginBottom: 12 }}>
															<InputLabel id="bo-reg-mode-label">Modo de registro</InputLabel>
															<Select
																labelId="bo-reg-mode-label"
																value={modeStored == null ? "simple" : modeStored}
																label="Modo de registro"
																onChange={(e) => {
																	pickMode(e.target.value);
																}}
															>
																<MenuItem value="simple">Individual (nombre, tipo Kahoot)</MenuItem>
																<MenuItem value="table">Por mesas</MenuItem>
															</Select>
														</FormControl>
														<FormControl variant="outlined" size="small" fullWidth style={{ marginBottom: 12 }}>
															<InputLabel id="bo-reg-photo-label">Foto de equipo</InputLabel>
															<Select
																labelId="bo-reg-photo-label"
																value={photoStored === true ? "yes" : "no"}
																label="Foto de equipo"
																onChange={(e) => {
																	pickPhoto(e.target.value === "yes");
																}}
															>
																<MenuItem value="no">Sin foto</MenuItem>
																<MenuItem value="yes">Con foto</MenuItem>
															</Select>
														</FormControl>
														{modeStored === "table" ? (
															<Box display="flex" style={{ gap: 8, marginBottom: 8 }}>
																<TextField
																	size="small"
																	variant="outlined"
																	fullWidth
																	label="Máx./mesa"
																	placeholder="0=∞"
																	value={maxPeopleVal}
																	onChange={(e) => {
																		const raw = e.target.value.replace(/\D/g, "");
																		const n = { ...rc };
																		if (raw === "") delete n.maxPeoplePerTable;
																		else n.maxPeoplePerTable = Math.max(0, parseInt(raw, 10) || 0);
																		setRegCfg(n);
																	}}
																	InputLabelProps={{ shrink: true }}
																/>
																<TextField
																	size="small"
																	variant="outlined"
																	fullWidth
																	label="Mesas"
																	placeholder="Juego"
																	value={numTablesVal}
																	onChange={(e) => {
																		const raw = e.target.value.replace(/\D/g, "");
																		const n = { ...rc };
																		if (raw === "") delete n.numTables;
																		else n.numTables = Math.max(1, parseInt(raw, 10) || 1);
																		setRegCfg(n);
																	}}
																	InputLabelProps={{ shrink: true }}
																/>
															</Box>
														) : null}
														<Box fontSize={10} color="#94a3b8" mb={1} lineHeight={1.35}>
															Sin override en esta página se usan los valores del juego. Individual = solo nombre; por mesas = participantes y mesa.
														</Box>
													</>
												);
											})()}
										</Box>
										<Box mb={3} p={2.5} borderRadius={16} style={{ background: "linear-gradient(145deg, #f8fafc 0%, #f1f5f9 100%)", border: "1px solid #e2e8f0", boxShadow: "0 2px 8px rgba(0,0,0,0.04)" }}>
											<Box fontSize={15} fontWeight={600} color="#334155" mb={2} display="flex" alignItems="center" style={{ gap: 10 }}>
												<Box p={1} borderRadius={10} style={{ background: "#fff", border: "1px solid #e2e8f0" }}>
													<ImageIcon style={{ fontSize: 22, color: "#64748b" }} />
												</Box>
												Logo de la página de registro
											</Box>
											<Box onClick={() => setLogoPickerOpen(true)} display="flex" flexDirection="column" alignItems="center" justifyContent="center"
												style={{ minHeight: 160, borderRadius: 16, border: "2px dashed #cbd5e1", background: currentPage?.registrationDesign?.logoUrl ? "#fff" : "#f8fafc", cursor: "pointer", transition: "all 0.2s ease", padding: 20 }}
												onMouseEnter={(e) => { e.currentTarget.style.borderColor = "#7c3aed"; e.currentTarget.style.background = "#f5f3ff"; }}
												onMouseLeave={(e) => { e.currentTarget.style.borderColor = "#cbd5e1"; e.currentTarget.style.background = currentPage?.registrationDesign?.logoUrl ? "#fff" : "#f8fafc"; }}>
												{currentPage?.registrationDesign?.logoUrl ? (
													<>
														<Box style={{ width: 120, height: 120, borderRadius: 16, overflow: "hidden", border: "2px solid #e2e8f0", flexShrink: 0 }}>
															<img src={currentPage.registrationDesign.logoUrl.startsWith("http") || currentPage.registrationDesign.logoUrl.startsWith("/") || currentPage.registrationDesign.logoUrl.startsWith("data:") ? currentPage.registrationDesign.logoUrl : `${SERVER_URL}/${currentPage.registrationDesign.logoUrl}`} alt="Logo" style={{ width: "100%", height: "100%", objectFit: "contain" }} />
														</Box>
														<Box fontSize={14} fontWeight={500} color="#64748b" mt={1.5}>Clic para cambiar</Box>
													</>
												) : (
													<>
														<ImageIcon style={{ fontSize: 48, color: "#94a3b8" }} />
														<Box fontSize={15} fontWeight={600} color="#475569" mt={1.5}>Elegir logo</Box>
													</>
												)}
											</Box>
											{currentPage?.registrationDesign?.logoUrl && (
												<Button fullWidth size="medium" onClick={(e) => { e.stopPropagation(); updateRegistrationDesign({ logoUrl: "" }); }} style={{ marginTop: 16, textTransform: "none", color: "#64748b" }}>
													Quitar logo
												</Button>
											)}
										</Box>
									</Box>
								) : addPanelCategory === "diseño" && isRegistrationPage ? (
									<Box p={2}>
										<Box fontSize={16} fontWeight={700} color="#1e293b" mb={3}>Diseño de registro</Box>
										<Box mb={3} p={2.5} borderRadius={16} style={{ background: "#f8fafc", border: "1px solid #e2e8f0" }}>
											<Box fontSize={14} fontWeight={600} color="#334155" mb={2}>Fondo</Box>
											<input ref={registrationBackgroundFileInputRef} type="file" accept="image/*" style={{ display: "none" }} onChange={handleUploadAndSelectRegistrationBackground} />
											<Box
												onClick={() => setRegistrationBackgroundPickerOpen(true)}
												display="flex"
												flexDirection="column"
												alignItems="center"
												justifyContent="center"
												style={{ minHeight: 120, borderRadius: 12, border: "2px dashed #cbd5e1", background: currentPage?.registrationDesign?.backgroundImageUrl ? "#fff" : "#f8fafc", cursor: "pointer", padding: 16 }}
												onMouseEnter={(e) => { e.currentTarget.style.borderColor = "#7c3aed"; e.currentTarget.style.background = "#f5f3ff"; }}
												onMouseLeave={(e) => { e.currentTarget.style.borderColor = "#cbd5e1"; e.currentTarget.style.background = currentPage?.registrationDesign?.backgroundImageUrl ? "#fff" : "#f8fafc"; }}
											>
												{currentPage?.registrationDesign?.backgroundImageUrl ? (
													<>
														<Box style={{ width: 120, height: 68, borderRadius: 8, overflow: "hidden", border: "1px solid #e2e8f0", backgroundImage: `url(${resolveEscapeRoomMediaUrl(currentPage.registrationDesign.backgroundImageUrl)})`, backgroundSize: "cover", backgroundPosition: "center" }} />
														<Box fontSize={13} color="#64748b" mt={1}>Clic para cambiar imagen</Box>
													</>
												) : (
													<>
														<ImageIcon style={{ fontSize: 40, color: "#94a3b8" }} />
														<Box fontSize={14} fontWeight={600} color="#475569" mt={1}>Elegir imagen de fondo</Box>
														<Box fontSize={11} color="#94a3b8">Desde la biblioteca o subir</Box>
													</>
												)}
											</Box>
											{currentPage?.registrationDesign?.backgroundImageUrl && (
												<Button fullWidth size="small" onClick={(e) => { e.stopPropagation(); updateRegistrationDesign({ backgroundImageUrl: "" }); }} style={{ marginTop: 10, textTransform: "none", color: "#64748b" }}>
													Quitar imagen de fondo
												</Button>
											)}
											<Box mt={2}>
												<HexColorPickerPopover label="Color de fondo" value={currentPage?.registrationDesign?.backgroundColor || "#ffffff"} onChange={(c) => updateRegistrationDesign({ backgroundColor: c })} />
											</Box>
										</Box>
									</Box>
								) : (
									<>
								{addPanelCategory === "plantillas" && (
									<>
										<Box fontSize={12} fontWeight={600} color="#64748b" mb={1.5} letterSpacing="0.02em">PLANTILLAS</Box>
										<Box
											component="button"
											type="button"
											onClick={addScenario}
											width="100%"
											display="flex"
											alignItems="center"
											justifyContent="center"
											mb={1.5}
											style={{
												gap: 10,
												padding: "14px 16px",
												fontSize: 14,
												fontWeight: 600,
												color: "#334155",
												border: "1px solid #e2e8f0",
												borderRadius: 12,
												cursor: "pointer",
												fontFamily: "inherit",
												lineHeight: 1.3,
												background: "#fff",
												boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
												transition: "border-color 0.2s ease, background 0.2s ease, box-shadow 0.2s ease, color 0.2s ease",
											}}
											onMouseEnter={(e) => {
												e.currentTarget.style.borderColor = "#c4b5fd";
												e.currentTarget.style.background = "#faf5ff";
												e.currentTarget.style.boxShadow = "0 4px 14px rgba(124,58,237,0.12)";
												e.currentTarget.style.color = "#5b21b6";
											}}
											onMouseLeave={(e) => {
												e.currentTarget.style.borderColor = "#e2e8f0";
												e.currentTarget.style.background = "#fff";
												e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.06)";
												e.currentTarget.style.color = "#334155";
											}}
										>
											<ViewModuleIcon style={{ fontSize: 22, color: "#7c3aed" }} />
											Añadir escenario
										</Box>
										<Box fontSize={11} fontWeight={500} color="#94a3b8" mb={1}>Temas</Box>
										<Box display="flex" flexWrap="wrap" style={{ gap: 10 }} mb={2} alignItems="center">
											{PLANTILLA_TEMAS.map((t) => (
												<Tooltip key={t.id} title={t.label} placement="top">
													<Box
														onClick={() => setPlantillaTheme(t.id)}
														style={{
															width: 32,
															height: 32,
															borderRadius: "50%",
															cursor: "pointer",
															boxShadow: plantillaTheme === t.id ? "0 0 0 2px #fff, 0 0 0 4px " + (t.id === "azul" ? "#3b82f6" : t.id === "caso-medico" ? "#0f4c5c" : "#ef4444") : "0 1px 3px rgba(0,0,0,0.12)",
															background: t.id === "azul"
																? "linear-gradient(135deg, #3b82f6 0%, #0c1929 100%)"
																: t.id === "caso-medico"
																	? "#0f4c5c"
																	: "linear-gradient(90deg, #ffffff 50%, #ef4444 50%)",
														}}
													/>
												</Tooltip>
											))}
										</Box>
										{isRegistrationPage ? null : plantillaTheme === "azul" ? (
											azulPlantillasLoading ? (
												<Box p={3} textAlign="center" color="#94a3b8" fontSize={13}>Cargando plantillas azul...</Box>
											) : (
											<Box display="grid" gridTemplateColumns="1fr 1fr" style={{ gap: 10 }}>
												{azulPlantillas.map((plt) => {
													const d = plt.design || {};
													const bgUrl = d.backgroundImageUrl ? resolveEscapeRoomMediaUrl(d.backgroundImageUrl) : undefined;
													const scale = 1.6;
													return (
														<Box key={plt.name} onClick={() => applyTemplate(plt)}
															style={{ borderRadius: 12, overflow: "hidden", boxShadow: "0 2px 8px rgba(0,0,0,0.08)", border: "1px solid #e2e8f0", cursor: "pointer", transition: "all 0.2s ease", background: "#fff", display: "flex", flexDirection: "column" }}
															onMouseEnter={(e) => { e.currentTarget.style.boxShadow = "0 6px 20px rgba(59,130,246,0.25)"; e.currentTarget.style.borderColor = "#3b82f6"; e.currentTarget.style.transform = "translateY(-2px)"; }}
															onMouseLeave={(e) => { e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.08)"; e.currentTarget.style.borderColor = "#e2e8f0"; e.currentTarget.style.transform = "none"; }}>
															<Box style={{ display: "flex", justifyContent: "center", alignItems: "center", padding: 4, background: "#f8fafc", minHeight: 130, overflow: "hidden" }}>
																<Box style={{ transform: `scale(${scale})`, transformOrigin: "center center" }}>
																	<PagePreviewThumbnail
																		elements={d.elements || []}
																		isRegistration={false}
																		backgroundColor={d.backgroundColor || "#fff"}
																		backgroundImageUrl={bgUrl}
																		backgroundImageOpacity={d.backgroundImageOpacity}
																		quizzes={quizzes}
																	/>
																</Box>
															</Box>
															<Box px={0.75} py={0.5}>
																<Box fontSize={10} fontWeight={600} color="#1e293b" sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{plt.name}</Box>
																<Box fontSize={9} color="#3b82f6" fontWeight={500}>Aplicar</Box>
															</Box>
														</Box>
													);
												})}
											</Box>
											)
										) : plantillaTheme === "caso-medico" ? (
											casoMedicoPlantillasLoading ? (
												<Box p={3} textAlign="center" color="#94a3b8" fontSize={13}>Cargando plantillas Caso Médico...</Box>
											) : casoMedicoPlantillas.length === 0 ? (
												<Box p={3} textAlign="center" color="#94a3b8" fontSize={13}>No hay plantillas disponibles para Caso Médico.</Box>
											) : (
											<>
											<Box fontSize={11} color="#64748b" mb={1}>Páginas encontradas: {casoMedicoPlantillas.length}</Box>
											<Box display="grid" gridTemplateColumns="1fr 1fr" style={{ gap: 10 }}>
												{casoMedicoPlantillas.map((plt) => {
													const d = plt.design || {};
													const bgUrl = d.backgroundImageUrl ? resolveEscapeRoomMediaUrl(d.backgroundImageUrl) : undefined;
													const scale = 1.6;
													return (
														<Box key={plt.name} onClick={() => applyTemplate(plt)}
															style={{ borderRadius: 12, overflow: "hidden", boxShadow: "0 2px 8px rgba(0,0,0,0.08)", border: "1px solid #e2e8f0", cursor: "pointer", transition: "all 0.2s ease", background: "#fff", display: "flex", flexDirection: "column" }}
															onMouseEnter={(e) => { e.currentTarget.style.boxShadow = "0 6px 20px rgba(15,76,92,0.25)"; e.currentTarget.style.borderColor = "#0f4c5c"; e.currentTarget.style.transform = "translateY(-2px)"; }}
															onMouseLeave={(e) => { e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.08)"; e.currentTarget.style.borderColor = "#e2e8f0"; e.currentTarget.style.transform = "none"; }}>
															<Box style={{ display: "flex", justifyContent: "center", alignItems: "center", padding: 4, background: "#f8fafc", minHeight: 130, overflow: "hidden" }}>
																<Box style={{ transform: `scale(${scale})`, transformOrigin: "center center" }}>
																	<PagePreviewThumbnail
																		elements={d.elements || []}
																		isRegistration={false}
																		backgroundColor={d.backgroundColor || "#fff"}
																		backgroundImageUrl={bgUrl}
																		backgroundImageOpacity={d.backgroundImageOpacity}
																		quizzes={quizzes}
																	/>
																</Box>
															</Box>
															<Box px={0.75} py={0.5}>
																<Box fontSize={10} fontWeight={600} color="#1e293b" sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{plt.name}</Box>
																<Box fontSize={9} color="#0f4c5c" fontWeight={500}>Aplicar</Box>
															</Box>
														</Box>
													);
												})}
											</Box>
											</>
											)
										) : plantillasLoading ? (
											<Box p={3} textAlign="center" color="#94a3b8" fontSize={13}>Cargando plantillas...</Box>
										) : plantillas.length === 0 ? (
											<Box p={3} textAlign="center" color="#94a3b8" fontSize={13}>No hay plantillas disponibles.</Box>
										) : (
											<Box display="grid" gridTemplateColumns="1fr 1fr" style={{ gap: 10 }}>
												{plantillas.map((plt) => {
													const d = plt.design || {};
													const bgUrl = d.backgroundImageUrl ? resolveEscapeRoomMediaUrl(d.backgroundImageUrl) : undefined;
													const scale = 1.6;
													return (
													<Box key={plt._id || plt.name} onClick={() => applyTemplate(plt)}
														style={{ borderRadius: 12, overflow: "hidden", boxShadow: "0 2px 8px rgba(0,0,0,0.08)", border: "1px solid #e2e8f0", cursor: "pointer", transition: "all 0.2s ease", background: "#fff", display: "flex", flexDirection: "column" }}
														onMouseEnter={(e) => { e.currentTarget.style.boxShadow = "0 6px 20px rgba(124,58,237,0.2)"; e.currentTarget.style.borderColor = "#7c3aed"; e.currentTarget.style.transform = "translateY(-2px)"; }}
														onMouseLeave={(e) => { e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.08)"; e.currentTarget.style.borderColor = "#e2e8f0"; e.currentTarget.style.transform = "none"; }}>
														<Box style={{ display: "flex", justifyContent: "center", alignItems: "center", padding: 4, background: "#f8fafc", minHeight: 130, overflow: "hidden" }}>
															<Box style={{ transform: `scale(${scale})`, transformOrigin: "center center" }}>
																<PagePreviewThumbnail
																	elements={d.elements || []}
																	isRegistration={false}
																	backgroundColor={d.backgroundColor || "#fff"}
																	backgroundImageUrl={bgUrl}
																	backgroundImageOpacity={d.backgroundImageOpacity}
																	quizzes={quizzes}
																/>
															</Box>
														</Box>
														<Box px={0.75} py={0.5}>
															<Box fontSize={10} fontWeight={600} color="#1e293b" sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{plt.name}</Box>
															<Box fontSize={9} color="#7c3aed" fontWeight={500}>Aplicar</Box>
														</Box>
													</Box>
													);
												})}
											</Box>
										)}
									</>
								)}
								{addPanelCategory === "elementos" && (
									<>
										{elementosSubSection ? (
											<>
												<Box display="flex" alignItems="center" mb={2} style={{ gap: 8, cursor: "pointer" }} onClick={() => setElementosSubSection(null)}>
													<ArrowBackIcon style={{ fontSize: 20, color: "#64748b" }} />
													<Box fontSize={13} fontWeight={600} color="#64748b">Volver</Box>
												</Box>
												{elementosSubSection === "forma" && (
													<Box display="flex" flexWrap="wrap" style={{ gap: 10 }}>
														{[
															{ type: "shape-square", Icon: CropSquareIcon, label: "Cuadrado" },
															{ type: "shape-circle", Icon: PanoramaFishEyeIcon, label: "Círculo" },
															{ type: "shape-triangle", Icon: ChangeHistoryIcon, label: "Triángulo" },
															{ type: "shape-line", Icon: RemoveIcon, label: "Línea" },
														].map(({ type, Icon: ShapeIcon, label }) => (
															<Box key={type} onClick={() => effectiveAddElement(type)} display="flex" flexDirection="column" alignItems="center" justifyContent="center"
																style={{ width: 72, minHeight: 72, padding: "8px 4px", borderRadius: 12, background: "#f8fafc", border: "1px solid #e2e8f0", cursor: "pointer", transition: "all 0.2s ease" }}
																onMouseEnter={(e) => { e.currentTarget.style.background = "#f1f5f9"; e.currentTarget.style.borderColor = "#7c3aed"; e.currentTarget.style.boxShadow = "0 4px 12px rgba(124,58,237,0.15)"; e.currentTarget.style.transform = "translateY(-1px)"; }}
																onMouseLeave={(e) => { e.currentTarget.style.background = "#f8fafc"; e.currentTarget.style.borderColor = "#e2e8f0"; e.currentTarget.style.boxShadow = "none"; e.currentTarget.style.transform = "none"; }}>
																<ShapeIcon style={{ fontSize: 28, color: "#64748b", marginBottom: 4 }} />
																<Box fontSize={11} color="#64748b" textAlign="center" lineHeight={1.2}>{label}</Box>
															</Box>
														))}
													</Box>
												)}
												{elementosSubSection === "boton" && (
													<Box display="flex" flexDirection="column" style={{ gap: 10 }}>
														{BUTTON_TEMPLATES.map(({ label, desc, overrides }) => (
															<Box key={label} onClick={() => { effectiveAddElement("button", overrides); setElementosSubSection(null); }} display="flex" alignItems="center" p={1.5}
																style={{ borderRadius: 12, border: "1px solid #e2e8f0", background: "#fff", cursor: "pointer", transition: "all 0.2s ease" }}
																onMouseEnter={(e) => { e.currentTarget.style.borderColor = "#7c3aed"; e.currentTarget.style.background = "#faf5ff"; e.currentTarget.style.boxShadow = "0 4px 12px rgba(124,58,237,0.12)"; e.currentTarget.style.transform = "translateY(-1px)"; }}
																onMouseLeave={(e) => { e.currentTarget.style.borderColor = "#e2e8f0"; e.currentTarget.style.background = "#fff"; e.currentTarget.style.boxShadow = "none"; e.currentTarget.style.transform = "none"; }}>
																<Box display="flex" alignItems="center" justifyContent="center" style={{ width: 40, height: 40, borderRadius: 10, background: overrides.style?.backgroundColor || "#f1f5f9", marginRight: 12, color: overrides.style?.color || "#64748b" }}>
																	{BUTTON_ICON_MAP[overrides.content?.icon] ? React.createElement(BUTTON_ICON_MAP[overrides.content.icon], { style: { fontSize: 22 } }) : overrides.content?.icon ? <span style={{ fontSize: 22 }}>{overrides.content.icon}</span> : null}
																</Box>
																<Box flex={1} minWidth={0}>
																	<Box fontSize={14} fontWeight={600} color="#1e293b">{label}</Box>
																	<Box fontSize={11} color="#94a3b8">{desc}</Box>
																</Box>
															</Box>
														))}
													</Box>
												)}
											</>
										) : (
											<>
												<Box fontSize={12} fontWeight={600} color="#64748b" mb={1.5} letterSpacing="0.02em">ELEMENTOS</Box>
												<Box display="flex" flexDirection="column" style={{ gap: 10 }}>
													{[
														{ type: "button", Icon: ArrowForwardIcon, label: "Botón", desc: "Flecha adelante, Jugar...", subSection: "boton", addDirect: false },
														{ type: "forma", Icon: CategoryIcon, label: "Forma", desc: "Cuadrado, círculo, triángulo, línea", subSection: "forma", addDirect: false },
													].map(({ type, Icon: ElemIcon, label, desc, subSection, addDirect }) => (
														<Box
															key={type}
															onClick={() => addDirect ? effectiveAddElement(type) : setElementosSubSection(subSection)}
															display="flex"
															flexDirection="column"
															alignItems="stretch"
															p={1.5}
															style={{ borderRadius: 12, border: "1px solid #e2e8f0", background: "#fff", cursor: "pointer", transition: "all 0.2s ease" }}
															onMouseEnter={(e) => { e.currentTarget.style.borderColor = "#7c3aed"; e.currentTarget.style.background = "#faf5ff"; e.currentTarget.style.boxShadow = "0 4px 12px rgba(124,58,237,0.12)"; e.currentTarget.style.transform = "translateY(-1px)"; }}
															onMouseLeave={(e) => { e.currentTarget.style.borderColor = "#e2e8f0"; e.currentTarget.style.background = "#fff"; e.currentTarget.style.boxShadow = "none"; e.currentTarget.style.transform = "none"; }}
														>
															<Box display="flex" alignItems="center">
																<Box display="flex" alignItems="center" justifyContent="center" style={{ width: 40, height: 40, borderRadius: 10, background: "#f1f5f9", marginRight: 12 }}>
																	<ElemIcon style={{ fontSize: 22, color: "#64748b" }} />
																</Box>
																<Box flex={1} minWidth={0}>
																	<Box fontSize={14} fontWeight={600} color="#1e293b">{label}</Box>
																	<Box fontSize={11} color="#94a3b8" style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{desc}</Box>
																</Box>
																{!addDirect && <Box fontSize={18} color="#94a3b8">›</Box>}
															</Box>
															{type === "button" && (
																<Box display="flex" flexWrap="wrap" style={{ gap: 6, marginTop: 10 }}>
																	{BUTTON_TEMPLATES.slice(0, 4).map((tpl) => (
																		<Box key={tpl.label} style={{ padding: "4px 8px", borderRadius: 999, background: "#f8fafc", border: "1px solid #e2e8f0", fontSize: 10, color: "#64748b" }}>
																			{tpl.label}
																		</Box>
																	))}
																</Box>
															)}
														</Box>
													))}
												</Box>
											</>
										)}
									</>
								)}
								{addPanelCategory === "texto" && (
									<>
										<Box fontSize={12} fontWeight={600} color="#64748b" mb={1.5} letterSpacing="0.02em">TEXTO</Box>
										<Box onClick={() => effectiveAddElement("text")} display="flex" alignItems="center" p={1.5} mb={1.5}
											style={{ borderRadius: 12, background: "linear-gradient(135deg, #7c3aed 0%, #5b21b6 100%)", cursor: "pointer", boxShadow: "0 4px 14px rgba(124,58,237,0.35)", transition: "all 0.2s ease" }}
											onMouseEnter={(e) => { e.currentTarget.style.boxShadow = "0 6px 20px rgba(124,58,237,0.4)"; e.currentTarget.style.transform = "translateY(-1px)"; }}
											onMouseLeave={(e) => { e.currentTarget.style.boxShadow = "0 4px 14px rgba(124,58,237,0.35)"; e.currentTarget.style.transform = "none"; }}>
											<Box display="flex" alignItems="center" justifyContent="center" style={{ width: 36, height: 36, borderRadius: 10, background: "rgba(255,255,255,0.2)", marginRight: 12 }}>
												<TitleIcon style={{ fontSize: 22, color: "#fff" }} />
											</Box>
											<Box fontSize={14} fontWeight={600} color="#fff">Añadir caja de texto</Box>
										</Box>
										<Box fontSize={11} fontWeight={600} color="#94a3b8" mb={1} mt={2}>Estilos predeterminados</Box>
										<Box display="flex" flexDirection="column" style={{ gap: 8 }}>
											{[
												{ label: "Título", sub: "Añadir un título", size: 22, bold: true, overrides: { content: { html: "<p>Título</p>" }, style: { fontSize: 28, fontWeight: "bold" }, width: 300, height: 50 } },
												{ label: "Subtítulo", sub: "Añadir un subtítulo", size: 16, bold: false, overrides: { content: { html: "<p>Subtítulo</p>" }, style: { fontSize: 18 }, width: 280, height: 40 } },
												{ label: "Texto", sub: "Añade algo de texto", size: 14, bold: false, overrides: { content: { html: "<p>Texto</p>" }, style: { fontSize: 14 }, width: 250, height: 60 } },
												{ label: "Puntos", sub: "Muestra la puntuación del jugador", size: 28, bold: true, overrides: { content: { html: `<p>${SCORE_TEXT_TOKEN}</p>`, textRole: SCORE_TEXT_ROLE }, style: { fontSize: 32, fontWeight: "bold" }, width: 120, height: 52 } },
											].map(({ label, sub, size, bold, overrides }) => (
												<Box key={label} onClick={() => effectiveAddElement("text", overrides)} p={1.25}
													style={{ borderRadius: 10, border: "1px solid #e2e8f0", background: "#fff", cursor: "pointer", transition: "all 0.2s ease" }}
													onMouseEnter={(e) => { e.currentTarget.style.borderColor = "#7c3aed"; e.currentTarget.style.background = "#faf5ff"; e.currentTarget.style.boxShadow = "0 2px 8px rgba(124,58,237,0.1)"; }}
													onMouseLeave={(e) => { e.currentTarget.style.borderColor = "#e2e8f0"; e.currentTarget.style.background = "#fff"; e.currentTarget.style.boxShadow = "none"; }}>
													<Box fontSize={size} fontWeight={bold ? 700 : 400} color="#1e293b" style={{ lineHeight: 1.3 }}>{label}</Box>
													<Box fontSize={11} color="#94a3b8" mt={0.25}>{sub}</Box>
												</Box>
											))}
										</Box>
									</>
								)}
								{addPanelCategory === "quizzes" && (
									<>
										<Box fontSize={12} fontWeight={600} color="#64748b" mb={1.5} letterSpacing="0.02em">PREGUNTAS</Box>
										<Box onClick={async () => {
												try {
													const res = await createQuiz({ fullName: "Pregunta", questions: [{ type: "multipleChoice", text: "Pregunta", options: [{ text: "Opción 1", imageUrl: "", correct: true }], explanation: "" }], pointsCorrect: 10, pointsIncorrect: -5, allowMultipleAttempts: false, attemptMode: "single", maxAttempts: 3 });
													loadQuizzes();
													setAddPanelCategory("editar");
													effectiveAddElement("quiz", { content: { quizId: res.data._id } });
												} catch (e) { alertError({ error: e, customMessage: "No se pudo crear la pregunta." }); }
											}} display="flex" alignItems="center" p={2} mb={1.5}
											style={{ borderRadius: 12, border: "2px dashed #7c3aed", background: "#faf5ff", cursor: "pointer", transition: "all 0.2s ease" }}
											onMouseEnter={(e) => { e.currentTarget.style.background = "#f5f3ff"; e.currentTarget.style.borderColor = "#5b21b6"; }}
											onMouseLeave={(e) => { e.currentTarget.style.background = "#faf5ff"; e.currentTarget.style.borderColor = "#7c3aed"; }}>
											<Box display="flex" alignItems="center" justifyContent="center" style={{ width: 44, height: 44, borderRadius: 12, background: "linear-gradient(135deg, #7c3aed 0%, #5b21b6 100%)", marginRight: 12 }}>
												<AddIcon style={{ fontSize: 24, color: "#fff" }} />
											</Box>
											<Box>
												<Box fontSize={14} fontWeight={600} color="#1e293b">Añadir pregunta</Box>
												<Box fontSize={11} color="#64748b">Nueva pregunta en el canvas</Box>
											</Box>
										</Box>
										<Box fontSize={12} fontWeight={500} color="#64748b" mb={1}>O reutilizar la plantilla de pregunta:</Box>
										{quizzesLoading ? (
											<Box p={2} color="#94a3b8" fontSize={13}>Cargando...</Box>
										) : (() => {
											const reusableQuiz = quizzes.find((q) => q && String(q._id) === REUSABLE_QUIZ_ID);
											return !reusableQuiz ? (
												<Box p={2} color="#94a3b8" fontSize={13}>La plantilla de pregunta no está disponible.</Box>
											) : (
												<Box key={reusableQuiz._id} onClick={() => effectiveAddElement("quiz", { content: { quizId: reusableQuiz._id } })}
													style={{ borderRadius: 12, border: "1px solid #e2e8f0", background: "#fff", cursor: "pointer", transition: "all 0.2s ease", overflow: "hidden" }}
													onMouseEnter={(e) => { e.currentTarget.style.borderColor = "#7c3aed"; e.currentTarget.style.background = "#faf5ff"; e.currentTarget.style.boxShadow = "0 2px 8px rgba(124,58,237,0.12)"; }}
													onMouseLeave={(e) => { e.currentTarget.style.borderColor = "#e2e8f0"; e.currentTarget.style.background = "#fff"; e.currentTarget.style.boxShadow = "none"; }}>
													<QuizPreviewThumbnail quiz={reusableQuiz} />
													<Box px={1} pb={1} pt={0.5} display="flex" alignItems="center" justifyContent="space-between">
														<Box fontSize={11} fontWeight={600} color="#1e293b">{reusableQuiz.fullName}</Box>
														<Box fontSize={9} color="#7c3aed" fontWeight={500}>Reutilizar</Box>
													</Box>
												</Box>
											);
										})()}
										<Box fontSize={12} fontWeight={600} color="#64748b" mt={2} mb={1.5} letterSpacing="0.02em">PISTAS</Box>
										<Box display="flex" flexDirection="column" style={{ gap: 10 }}>
											{HINT_TEMPLATES.slice(0, 4).map(({ label, desc, overrides }) => (
												<Box key={label} onClick={() => { effectiveAddElement("hint", overrides); }} display="flex" alignItems="center" p={1.5}
													style={{ borderRadius: 12, border: "1px solid #e2e8f0", background: "#fff", cursor: "pointer", transition: "all 0.2s ease" }}
													onMouseEnter={(e) => { e.currentTarget.style.borderColor = "#7c3aed"; e.currentTarget.style.background = "#faf5ff"; e.currentTarget.style.boxShadow = "0 4px 12px rgba(124,58,237,0.12)"; e.currentTarget.style.transform = "translateY(-1px)"; }}
													onMouseLeave={(e) => { e.currentTarget.style.borderColor = "#e2e8f0"; e.currentTarget.style.background = "#fff"; e.currentTarget.style.boxShadow = "none"; e.currentTarget.style.transform = "none"; }}>
													<Box display="flex" alignItems="center" justifyContent="center" style={{ width: 40, height: 40, borderRadius: 10, background: overrides.style?.backgroundColor || "#f1f5f9", marginRight: 12, color: overrides.style?.color || "#64748b" }}>
														<LiveHelpIcon style={{ fontSize: 22 }} />
													</Box>
													<Box flex={1} minWidth={0}>
														<Box fontSize={14} fontWeight={600} color="#1e293b">{label}</Box>
														<Box fontSize={11} color="#94a3b8">{desc}</Box>
													</Box>
												</Box>
											))}
										</Box>
									</>
								)}
								{addPanelCategory === "multimedia" && (
									<>
										{elementosSubSection ? (
											<>
												<Box display="flex" alignItems="center" mb={2} style={{ gap: 8, cursor: "pointer" }} onClick={() => setElementosSubSection(null)}>
													<ArrowBackIcon style={{ fontSize: 20, color: "#64748b" }} />
													<Box fontSize={13} fontWeight={600} color="#64748b">Volver</Box>
												</Box>
												{elementosSubSection === "imagen" && (
													<>
														<input ref={fileInputRef} type="file" accept="image/*" style={{ display: "none" }} onChange={(e) => { handleUploadUserMedia(e); e.target.value = ""; }} />
														<Box onClick={() => fileInputRef.current?.click()} display="flex" alignItems="center" justifyContent="center" p={2} mb={2}
															style={{ borderRadius: 12, border: "2px dashed #cbd5e1", background: "#f8fafc", cursor: "pointer", transition: "all 0.2s ease" }}
															onMouseEnter={(e) => { e.currentTarget.style.borderColor = "#7c3aed"; e.currentTarget.style.background = "#faf5ff"; }}
															onMouseLeave={(e) => { e.currentTarget.style.borderColor = "#cbd5e1"; e.currentTarget.style.background = "#f8fafc"; }}>
															<CloudUploadIcon style={{ fontSize: 24, color: "#94a3b8", marginRight: 8 }} />
															<Box fontSize={13} fontWeight={600} color="#64748b">Subir imagen</Box>
														</Box>
														{userMediaLoading ? (
															<Box p={2} textAlign="center" color="#94a3b8" fontSize={12}>Cargando...</Box>
														) : userMedia.filter((m) => !m.isVideo).length === 0 ? (
															<Box p={2} textAlign="center" color="#94a3b8" fontSize={12}>No hay imágenes. Sube una arriba.</Box>
														) : (
															<Box display="flex" flexWrap="wrap" style={{ gap: 8 }}>
																{userMedia.filter((m) => !m.isVideo).map((item) => (
																	<Box
																		key={item.path}
																		draggable
																		onDragStart={(e) => { e.dataTransfer.setData("application/evenely-media", JSON.stringify({ type: "image", path: item.path })); e.dataTransfer.effectAllowed = "copy"; }}
																		onClick={() => { effectiveAddElement("image", { content: { url: item.path } }); setElementosSubSection(null); }}
																		style={{ width: 72, flexShrink: 0, cursor: "grab", borderRadius: 8, overflow: "hidden", border: "2px solid #e2e8f0" }}
																		onMouseEnter={(e) => { e.currentTarget.style.borderColor = "#7c3aed"; e.currentTarget.style.boxShadow = "0 2px 8px rgba(124,58,237,0.2)"; }}
																		onMouseLeave={(e) => { e.currentTarget.style.borderColor = "#e2e8f0"; e.currentTarget.style.boxShadow = "none"; }}
																	>
																		<img src={item.path.startsWith("http") || item.path.startsWith("/") ? item.path : `${SERVER_URL}/${item.path}`} alt="" style={{ width: "100%", height: 72, objectFit: "cover", display: "block", pointerEvents: "none" }} draggable={false} />
																	</Box>
																))}
															</Box>
														)}
													</>
												)}
												{elementosSubSection === "video" && (
													<>
														<input ref={fileInputRef} type="file" accept="video/*" style={{ display: "none" }} onChange={(e) => { handleUploadUserMedia(e); e.target.value = ""; }} />
														<Box onClick={() => fileInputRef.current?.click()} display="flex" alignItems="center" justifyContent="center" p={2} mb={2}
															style={{ borderRadius: 12, border: "2px dashed #cbd5e1", background: "#f8fafc", cursor: "pointer", transition: "all 0.2s ease" }}
															onMouseEnter={(e) => { e.currentTarget.style.borderColor = "#7c3aed"; e.currentTarget.style.background = "#faf5ff"; }}
															onMouseLeave={(e) => { e.currentTarget.style.borderColor = "#cbd5e1"; e.currentTarget.style.background = "#f8fafc"; }}>
															<CloudUploadIcon style={{ fontSize: 24, color: "#94a3b8", marginRight: 8 }} />
															<Box fontSize={13} fontWeight={600} color="#64748b">Subir video</Box>
														</Box>
														{userMediaLoading ? (
															<Box p={2} textAlign="center" color="#94a3b8" fontSize={12}>Cargando...</Box>
														) : userMedia.filter((m) => m.isVideo).length === 0 ? (
															<Box p={2} textAlign="center" color="#94a3b8" fontSize={12}>No hay videos. Sube uno arriba.</Box>
														) : (
															<Box display="flex" flexWrap="wrap" style={{ gap: 8 }}>
																{userMedia.filter((m) => m.isVideo).map((item) => (
																	<Box
																		key={item.path}
																		draggable
																		onDragStart={(e) => { e.dataTransfer.setData("application/evenely-media", JSON.stringify({ type: "video", path: item.path })); e.dataTransfer.effectAllowed = "copy"; }}
																		onClick={() => { effectiveAddElement("video", { content: { url: item.path } }); setElementosSubSection(null); }}
																		style={{ width: 72, flexShrink: 0, cursor: "grab", borderRadius: 8, overflow: "hidden", border: "2px solid #e2e8f0" }}
																		onMouseEnter={(e) => { e.currentTarget.style.borderColor = "#7c3aed"; e.currentTarget.style.boxShadow = "0 2px 8px rgba(124,58,237,0.2)"; }}
																		onMouseLeave={(e) => { e.currentTarget.style.borderColor = "#e2e8f0"; e.currentTarget.style.boxShadow = "none"; }}
																	>
																		<video src={item.path.startsWith("http") || item.path.startsWith("/") ? item.path : `${SERVER_URL}/${item.path}`} preload="metadata" muted playsInline style={{ width: "100%", height: 72, objectFit: "cover", display: "block", pointerEvents: "none" }} draggable={false} />
																	</Box>
																))}
															</Box>
														)}
													</>
												)}
											</>
										) : (
											<>
												<Box fontSize={12} fontWeight={600} color="#64748b" mb={1.5} letterSpacing="0.02em">MULTIMEDIA</Box>
												<Box display="flex" flexDirection="column" style={{ gap: 10 }}>
													{[
														{ type: "image", Icon: ImageIcon, label: "Imagen", desc: "Tus imágenes o subir nueva", subSection: "imagen" },
														{ type: "video", Icon: VideoLibraryIcon, label: "Vídeo", desc: "Tus videos o subir nuevo", subSection: "video" },
													].map(({ type, Icon: ElemIcon, label, desc, subSection }) => {
														const latestItems = userMedia
															.filter((m) => (type === "image" ? !m.isVideo : m.isVideo))
															.slice(0, 6);
														return (
														<Box
															key={type}
															onClick={() => setElementosSubSection(subSection)}
															display="flex"
															flexDirection="column"
															alignItems="stretch"
															p={1.5}
															style={{ borderRadius: 12, border: "1px solid #e2e8f0", background: "#fff", cursor: "pointer", transition: "all 0.2s ease" }}
															onMouseEnter={(e) => { e.currentTarget.style.borderColor = "#7c3aed"; e.currentTarget.style.background = "#faf5ff"; e.currentTarget.style.boxShadow = "0 4px 12px rgba(124,58,237,0.12)"; e.currentTarget.style.transform = "translateY(-1px)"; }}
															onMouseLeave={(e) => { e.currentTarget.style.borderColor = "#e2e8f0"; e.currentTarget.style.background = "#fff"; e.currentTarget.style.boxShadow = "none"; e.currentTarget.style.transform = "none"; }}
														>
															<Box display="flex" alignItems="center">
																<Box display="flex" alignItems="center" justifyContent="center" style={{ width: 40, height: 40, borderRadius: 10, background: "#f1f5f9", marginRight: 12 }}>
																	<ElemIcon style={{ fontSize: 22, color: "#64748b" }} />
																</Box>
																<Box flex={1} minWidth={0}>
																	<Box fontSize={14} fontWeight={600} color="#1e293b">{label}</Box>
																	<Box fontSize={11} color="#94a3b8" style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{desc}</Box>
																</Box>
																<Box fontSize={18} color="#94a3b8">›</Box>
															</Box>
															<Box display="flex" flexWrap="wrap" style={{ gap: 6, marginTop: 10 }}>
																{latestItems.length === 0 ? (
																	<Box fontSize={10} color="#94a3b8">Sin archivos recientes</Box>
																) : latestItems.map((item) => (
																	<Box key={item.path} style={{ width: 52, height: 40, borderRadius: 6, overflow: "hidden", border: "1px solid #e2e8f0", background: "#0f172a" }}>
																		{type === "image" ? (
																			<img src={item.path.startsWith("http") || item.path.startsWith("/") ? item.path : `${SERVER_URL}/${item.path}`} alt={item.name || ""} style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }} />
																		) : (
																			<video src={item.path.startsWith("http") || item.path.startsWith("/") ? item.path : `${SERVER_URL}/${item.path}`} muted playsInline preload="metadata" style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }} />
																		)}
																	</Box>
																))}
															</Box>
														</Box>
														);
													})}
												</Box>
											</>
										)}
									</>
								)}
								{addPanelCategory === "paginas" && (
									<>
										<Box fontSize={12} fontWeight={600} color="#64748b" mb={0.5} letterSpacing="0.02em">
											PÁGINA · ORDEN Z
										</Box>
										<Box fontSize={11} color="#94a3b8" mb={1.5} lineHeight={1.35}>
											De arriba a abajo: delante → detrás. Clic en un elemento para editarlo.
										</Box>
										{layerElementsForZPanel.length === 0 ? (
											<Box p={2} color="#94a3b8" fontSize={13} borderRadius={10} style={{ background: "#f8fafc", border: "1px solid #e2e8f0" }}>
												No hay elementos en {isModalEditMode ? "este modal" : "esta página"}.
											</Box>
										) : (
											<Box display="flex" flexDirection="column" style={{ gap: 6 }}>
												{[...layerElementsForZPanel].reverse().map((el, frontIdx) => {
													const zRank = layerElementsForZPanel.length - frontIdx;
													const typeLabel = ELEMENT_LAYER_TYPE_LABELS[el.type] || el.type || "Elemento";
													const sub = getElementLayerSubtitle(el, quizzes);
													const sel = selectedElement?.elementId === el.elementId;
													return (
														<Box
															key={el.elementId}
															onClick={() => setSelectedElement(el)}
															onContextMenu={(e) => {
																e.preventDefault();
																e.stopPropagation();
																skipOpenEditarOnSelectRef.current = true;
																setSelectedElement(el);
																setContextMenu({ mouseX: e.clientX, mouseY: e.clientY });
															}}
															p={1.25}
															display="flex"
															alignItems="flex-start"
															style={{
																gap: 10,
																borderRadius: 10,
																cursor: "pointer",
																border: (sel || hoverPanelElementId === el.elementId) ? "2px solid #7c3aed" : "1px solid #e2e8f0",
																background: (sel || hoverPanelElementId === el.elementId) ? "#faf5ff" : "#fff",
																boxShadow: (sel || hoverPanelElementId === el.elementId) ? "0 2px 10px rgba(124,58,237,0.12)" : "0 1px 3px rgba(0,0,0,0.06)",
																transition: "all 0.15s ease",
															}}
															onMouseEnter={(e) => {
																setHoverPanelElementId(el.elementId);
																if (!sel) {
																	e.currentTarget.style.borderColor = "#c4b5fd";
																	e.currentTarget.style.background = "#f5f3ff";
																}
															}}
															onMouseLeave={(e) => {
																setHoverPanelElementId((prev) => (prev === el.elementId ? null : prev));
																if (!sel) {
																	e.currentTarget.style.borderColor = "#e2e8f0";
																	e.currentTarget.style.background = "#fff";
																}
															}}
														>
															<Box
																minWidth={28}
																height={28}
																display="flex"
																alignItems="center"
																justifyContent="center"
																borderRadius={8}
																fontSize={11}
																fontWeight={700}
																style={{
																	background: frontIdx === 0 ? "linear-gradient(135deg, #7c3aed 0%, #5b21b6 100%)" : "#e2e8f0",
																	color: frontIdx === 0 ? "#fff" : "#64748b",
																}}
															>
																{zRank}
															</Box>
															<Box flex={1} minWidth={0}>
																<Box fontSize={13} fontWeight={600} color="#1e293b" display="flex" alignItems="center" style={{ gap: 6 }}>
																	{typeLabel}
																	{frontIdx === 0 && (
																		<Box component="span" fontSize={9} fontWeight={600} color="#7c3aed" style={{ textTransform: "uppercase", letterSpacing: "0.04em" }}>
																			delante
																		</Box>
																	)}
																</Box>
																{sub ? (
																	<Box fontSize={11} color="#64748b" mt={0.25} style={{ wordBreak: "break-word" }}>
																		{sub}
																	</Box>
																) : null}
															</Box>
														</Box>
													);
												})}
											</Box>
										)}
									</>
								)}
								{addPanelCategory === "ajustes" && (
									<>
										<Box fontSize={12} fontWeight={600} color="#64748b" mb={0.5} letterSpacing="0.02em">
											AJUSTES
										</Box>
										<Box fontSize={11} color="#94a3b8" mb={1.5} lineHeight={1.35}>
											Configuración general de la partida.
										</Box>
										<Box p={2.5} borderRadius={12} style={{ background: "#f8fafc", border: "1px solid #e2e8f0" }}>
											<Box fontSize={13} fontWeight={600} color="#334155" mb={1.5} display="flex" alignItems="center" style={{ gap: 8 }}>
												<Box p={0.75} borderRadius={8} style={{ background: "#fff", border: "1px solid #e2e8f0" }}>
													<ScheduleIcon style={{ fontSize: 18, color: "#64748b" }} />
												</Box>
												Temporizador
											</Box>
											<Box fontSize={20} fontWeight={700} color="#7c3aed" mb={1.25}>
												{`${Math.floor(gameTimeSeconds / 60)}:${String(gameTimeSeconds % 60).padStart(2, "0")}`}
											</Box>
											<Box display="flex" style={{ gap: 8 }}>
												<TextField
													type="number"
													size="small"
													variant="outlined"
													label="Min"
													value={String(Math.floor(gameTimeSeconds / 60))}
													onChange={(e) => {
														const mins = Math.max(0, Math.min(1440, Number(e?.target?.value ?? 0) || 0));
														const secs = gameTimeSeconds % 60;
														setGameTimeSecondsRaw(Math.max(1, Math.min(86400, mins * 60 + secs)));
													}}
													inputProps={{ min: 0, max: 1440 }}
													style={{ width: 90 }}
												/>
												<TextField
													type="number"
													size="small"
													variant="outlined"
													label="Seg"
													value={String(gameTimeSeconds % 60)}
													onChange={(e) => {
														const secs = Math.max(0, Math.min(59, Number(e?.target?.value ?? 0) || 0));
														const mins = Math.floor(gameTimeSeconds / 60);
														setGameTimeSecondsRaw(Math.max(1, Math.min(86400, mins * 60 + secs)));
													}}
													inputProps={{ min: 0, max: 59 }}
													style={{ width: 90 }}
												/>
											</Box>
										</Box>
										<Box mt={2} p={2.5} borderRadius={12} style={{ background: "#f8fafc", border: "1px solid #e2e8f0" }}>
											<Box fontSize={13} fontWeight={600} color="#334155" mb={1.5} display="flex" alignItems="center" style={{ gap: 8 }}>
												<Box p={0.75} borderRadius={8} style={{ background: "#fff", border: "1px solid #e2e8f0" }}>
													<PeopleOutlineIcon style={{ fontSize: 18, color: "#64748b" }} />
												</Box>
												Cupo de partida (en vivo)
											</Box>
											<Box fontSize={11} color="#64748b" mb={1.5} lineHeight={1.35}>
												Tope opcional de jugadores y de equipos/mesas a la vez. En el juego real, el límite del plan del cliente también aplica. 0 = sin tope extra en ese eje.
											</Box>
											<Box display="flex" flexDirection="column" style={{ gap: 10 }}>
												<TextField
													type="number"
													size="small"
													variant="outlined"
													label="Máx. jugadores simultáneos"
													value={String(sessionMaxConcurrentPlayersRaw)}
													onChange={(e) => {
														const raw = e.target.value.replace(/\D/g, "");
														const n = raw === "" ? 0 : Math.min(999999, Math.max(0, parseInt(raw, 10) || 0));
														setSessionMaxConcurrentPlayersRaw(n);
													}}
													inputProps={{ min: 0, max: 999999 }}
													fullWidth
												/>
												<TextField
													type="number"
													size="small"
													variant="outlined"
													label="Máx. equipos / mesas a la vez"
													value={String(sessionMaxTablesRaw)}
													onChange={(e) => {
														const raw = e.target.value.replace(/\D/g, "");
														const n = raw === "" ? 0 : Math.min(500, Math.max(0, parseInt(raw, 10) || 0));
														setSessionMaxTablesRaw(n);
													}}
													inputProps={{ min: 0, max: 500 }}
													fullWidth
												/>
											</Box>
										</Box>
										<Box mt={2} p={2.5} borderRadius={12} style={{ background: "#f8fafc", border: "1px solid #e2e8f0" }}>
											<Box fontSize={13} fontWeight={600} color="#334155" mb={1.5} display="flex" alignItems="center" style={{ gap: 8 }}>
												<Box p={0.75} borderRadius={8} style={{ background: "#fff", border: "1px solid #e2e8f0" }}>
													<PaletteIcon style={{ fontSize: 18, color: "#64748b" }} />
												</Box>
												Color del juego
											</Box>
											<Box fontSize={11} color="#64748b" mb={1.5} lineHeight={1.35}>
												Acento en la página de registro (web): pasos, bordes de campos y botón Siguiente.
											</Box>
											<HexColorPickerPopover
												label="Color principal"
												value={
													pages.find((pg) => (pg.pageId || pg._id) === REGISTRATION_PAGE_ID)?.registrationDesign?.primaryColor ||
													PRIMARY_RED
												}
												onChange={(c) => updateRegistrationPrimaryColor({ primaryColor: c })}
											/>
										</Box>
									</>
								)}
								</>
								)}
								</div>
							</Box>
				</>
		</Box>
		</Box>
		</Box>

		<Dialog open={mediaPickerOpen} onClose={() => { setMediaPickerOpen(false); setMediaPickerMode(null); }} maxWidth="sm" fullWidth>
			<DialogTitle>{mediaPickerMode === "image" ? "Elegir imagen" : "Elegir video"}</DialogTitle>
			<DialogContent>
				<Box display="flex" flexWrap="wrap" style={{ gap: 12, marginTop: 8 }}>
					<Box onClick={() => mediaElementFileInputRef.current?.click()} display="flex" flexDirection="column" alignItems="center" justifyContent="center"
						style={{ width: 88, height: 88, borderRadius: 12, border: "2px dashed #cbd5e1", background: "#f8fafc", cursor: "pointer" }}>
						<CloudUploadIcon style={{ fontSize: 32, color: "#94a3b8" }} />
						<Box fontSize={11} color="#64748b" mt={0.5}>Subir</Box>
					</Box>
					<input ref={mediaElementFileInputRef} type="file" accept={mediaPickerMode === "image" ? "image/*" : "video/*"} style={{ display: "none" }} onChange={handleUploadMediaForElement} />
					{userMediaLoading ? (
						<Box p={3} color="#94a3b8" fontSize={13}>Cargando...</Box>
					) : (
						userMedia.filter((m) => mediaPickerMode === "image" ? !m.isVideo : m.isVideo).map((item) => (
							<Box key={item.path} onClick={() => handleSelectMediaForElement(item.path)}
								style={{ width: 88, height: 88, borderRadius: 12, overflow: "hidden", border: "2px solid #e2e8f0", cursor: "pointer" }}>
								{item.isVideo ? (
									<video
										src={item.path.startsWith("http") || item.path.startsWith("/") ? item.path : `${SERVER_URL}/${item.path}`}
										preload="metadata"
										muted
										playsInline
										style={{ width: "100%", height: "100%", objectFit: "cover" }}
									/>
								) : (
									<img src={resolveEscapeRoomMediaUrl(item.path)} alt={item.name} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
								)}
							</Box>
						))
					)}
				</Box>
			</DialogContent>
			<DialogActions>
				<Button onClick={() => { setMediaPickerOpen(false); setMediaPickerMode(null); }}>Cancelar</Button>
			</DialogActions>
		</Dialog>

		<Dialog open={imageElementPickerOpen} onClose={() => { setImageElementPickerOpen(false); setButtonImagePickerTarget(null); }} maxWidth="sm" fullWidth>
			<DialogTitle>{buttonImagePickerTarget === "hover" ? "Imagen hover del botón" : buttonImagePickerTarget === "main" ? "Imagen del botón" : "Cambiar imagen"}</DialogTitle>
			<DialogContent>
				<Box display="flex" flexWrap="wrap" style={{ gap: 12, marginTop: 8 }}>
					<Box onClick={() => imageElementPickerFileInputRef.current?.click()} display="flex" flexDirection="column" alignItems="center" justifyContent="center"
						style={{ width: 88, height: 88, borderRadius: 12, border: "2px dashed #cbd5e1", background: "#f8fafc", cursor: "pointer" }}>
						<CloudUploadIcon style={{ fontSize: 32, color: "#94a3b8" }} />
						<Box fontSize={11} color="#64748b" mt={0.5}>Subir imagen</Box>
					</Box>
					<input ref={imageElementPickerFileInputRef} type="file" accept="image/*" style={{ display: "none" }} onChange={handleUploadImageForElement} />
					{userMediaLoading ? (
						<Box p={3} color="#94a3b8" fontSize={13}>Cargando...</Box>
					) : userMedia.filter((m) => !m.isVideo).length === 0 ? (
						<Box p={3} color="#94a3b8" fontSize={13}>No hay imágenes. Sube una arriba.</Box>
					) : (
						userMedia.filter((m) => !m.isVideo).map((item) => (
							<Box key={item.path} onClick={() => handleSelectImageForElement(item.path)}
								style={{ width: 88, height: 88, borderRadius: 12, overflow: "hidden", border: "2px solid #e2e8f0", cursor: "pointer" }}
								onMouseEnter={(e) => { e.currentTarget.style.borderColor = "#7c3aed"; e.currentTarget.style.boxShadow = "0 2px 8px rgba(124,58,237,0.2)"; }}
								onMouseLeave={(e) => { e.currentTarget.style.borderColor = "#e2e8f0"; e.currentTarget.style.boxShadow = "none"; }}>
								<img src={resolveEscapeRoomMediaUrl(item.path)} alt={item.name} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
							</Box>
						))
					)}
				</Box>
			</DialogContent>
			<DialogActions>
				<Button onClick={() => { setImageElementPickerOpen(false); setButtonImagePickerTarget(null); }}>Cancelar</Button>
			</DialogActions>
		</Dialog>

		<Dialog open={videoElementPickerOpen} onClose={() => setVideoElementPickerOpen(false)} maxWidth="sm" fullWidth>
			<DialogTitle>Cambiar video</DialogTitle>
			<DialogContent>
				<Box display="flex" flexWrap="wrap" style={{ gap: 12, marginTop: 8 }}>
					<Box onClick={() => videoElementPickerFileInputRef.current?.click()} display="flex" flexDirection="column" alignItems="center" justifyContent="center"
						style={{ width: 88, height: 88, borderRadius: 12, border: "2px dashed #cbd5e1", background: "#f8fafc", cursor: "pointer" }}>
						<CloudUploadIcon style={{ fontSize: 32, color: "#94a3b8" }} />
						<Box fontSize={11} color="#64748b" mt={0.5}>Subir video</Box>
					</Box>
					<input ref={videoElementPickerFileInputRef} type="file" accept="video/mp4,video/webm,video/ogg,video/quicktime,.mov" style={{ display: "none" }} onChange={handleUploadVideoForElement} />
					{userMediaLoading ? (
						<Box p={3} color="#94a3b8" fontSize={13}>Cargando...</Box>
					) : userMedia.filter((m) => m.isVideo).length === 0 ? (
						<Box p={3} color="#94a3b8" fontSize={13}>No hay videos. Sube uno arriba.</Box>
					) : (
						userMedia.filter((m) => m.isVideo).map((item) => (
							<Box key={item.path} onClick={() => handleSelectVideoForElement(item.path)}
								style={{ width: 88, height: 88, borderRadius: 12, overflow: "hidden", border: "2px solid #e2e8f0", cursor: "pointer", background: "#0f172a" }}
								onMouseEnter={(e) => { e.currentTarget.style.borderColor = "#7c3aed"; e.currentTarget.style.boxShadow = "0 2px 8px rgba(124,58,237,0.2)"; }}
								onMouseLeave={(e) => { e.currentTarget.style.borderColor = "#e2e8f0"; e.currentTarget.style.boxShadow = "none"; }}>
								<video src={item.path.startsWith("http") || item.path.startsWith("/") ? item.path : `${SERVER_URL}/${item.path}`} preload="metadata" muted playsInline style={{ width: "100%", height: "100%", objectFit: "cover", display: "block", pointerEvents: "none" }} />
							</Box>
						))
					)}
				</Box>
			</DialogContent>
			<DialogActions>
				<Button onClick={() => setVideoElementPickerOpen(false)}>Cancelar</Button>
			</DialogActions>
		</Dialog>

		<Dialog open={!!quizImagePickerFor} onClose={() => setQuizImagePickerFor(null)} maxWidth="sm" fullWidth>
			<DialogTitle>
				{quizImagePickerFor ? (typeof quizImagePickerFor.optionIndex === "string" ? "Imagen del elemento" : `Imagen · opción ${quizImagePickerFor.optionIndex + 1}`) : ""}
			</DialogTitle>
			<DialogContent>
				{quizImagePickerFor && (() => {
					const pickerEl = (currentPage?.elements || []).find((e) => e.elementId === quizImagePickerFor.elementId);
					const quizId = pickerEl?.content?.quizId;
					const quiz = quizzes.find((q) => q._id === quizId);
					const idx = quizImagePickerFor.optionIndex;
					const uploadId = `quiz-img-up-${quizImagePickerFor.elementId}-${String(idx)}`;
					const applyImage = async (url) => {
						if (!quizId || !handleUpdateQuiz) return;
						const qNow = quizzes.find((q) => q._id === quizId);
						const fq = qNow?.questions?.[0];
						if (!qNow || !fq) return;
						const payloadBase = {
							fullName: qNow.fullName,
							pointsCorrect: qNow.pointsCorrect,
							pointsIncorrect: qNow.pointsIncorrect,
							allowMultipleAttempts: qNow.allowMultipleAttempts,
							attemptMode: qNow.attemptMode,
							maxAttempts: qNow.maxAttempts,
						};
						try {
							if (typeof idx === "string" && idx.startsWith("matchLeft_")) {
								const i = parseInt(idx.replace("matchLeft_", ""), 10);
								const newLeft = (fq.matchLeft || []).map((it, j) => (j === i ? { ...it, imageUrl: url || "" } : it));
								await handleUpdateQuiz(quizId, { ...payloadBase, questions: [{ ...fq, matchLeft: newLeft }] });
							} else if (typeof idx === "string" && idx.startsWith("matchRight_")) {
								const i = parseInt(idx.replace("matchRight_", ""), 10);
								const newRight = (fq.matchRight || []).map((it, j) => (j === i ? { ...it, imageUrl: url || "" } : it));
								await handleUpdateQuiz(quizId, { ...payloadBase, questions: [{ ...fq, matchRight: newRight }] });
							} else {
								const optI = typeof idx === "number" ? idx : parseInt(String(idx), 10);
								const newOpts = (fq.options || []).map((o, j) => (j === optI ? { ...o, imageUrl: url || "" } : o));
								await handleUpdateQuiz(quizId, { ...payloadBase, questions: [{ ...fq, options: newOpts }] });
							}
							setQuizImagePickerFor(null);
							setQuizInlineSyncNonce((n) => n + 1);
						} catch (err) {
							alertError({ error: err, customMessage: "No se pudo guardar la imagen de la opción." });
						}
					};
					const onPickFile = async (e) => {
						const file = e.target.files?.[0];
						e.target.value = "";
						if (!file) return;
						if (!/\.(jpe?g|png|gif|webp|svg)$/i.test(file.name)) {
							alertError({ customMessage: "Solo imágenes: jpg, png, gif, webp, svg." });
							return;
						}
						try {
							const res = await uploadUserMedia(file, escapeRoom?._id);
							if (res?.data?.fileURL) {
								setUserMedia((prev) => [{ path: res.data.fileURL, name: file.name, isVideo: false }, ...prev]);
								await applyImage(res.data.fileURL);
							}
						} catch (err) {
							alertError({ error: err, customMessage: "Error al subir la imagen." });
						}
					};
					return (
						<Box display="flex" flexDirection="column" style={{ gap: 16, marginTop: 8 }}>
							<Box>
								<input id={uploadId} type="file" accept="image/*" style={{ display: "none" }} onChange={onPickFile} />
								<Box
									component="label"
									htmlFor={uploadId}
									display="flex"
									flexDirection="column"
									alignItems="center"
									justifyContent="center"
									style={{
										padding: "20px 16px",
										borderRadius: 12,
										border: "2px dashed #c4b5fd",
										background: "#faf5ff",
										cursor: "pointer",
									}}
								>
									<CloudUploadIcon style={{ fontSize: 36, color: "#7c3aed" }} />
									<Box fontSize={14} fontWeight={600} color="#5b21b6" mt={1}>
										Subir imagen desde el equipo
									</Box>
									<Box fontSize={12} color="#64748b" mt={0.5}>
										Se guardará en tu biblioteca multimedia
									</Box>
								</Box>
							</Box>
							<Box fontSize={13} fontWeight={600} color="#334155">
								Tu biblioteca (clic para usar)
							</Box>
							<Box display="flex" flexWrap="wrap" style={{ gap: 10, maxHeight: 280, overflowY: "auto", paddingBottom: 4 }}>
								{userMediaLoading ? (
									<Box p={2} color="#94a3b8" fontSize={13}>
										Cargando imágenes…
									</Box>
								) : userMedia.filter((m) => !m.isVideo).length === 0 ? (
									<Box p={2} color="#94a3b8" fontSize={13}>
										No hay imágenes aún. Sube una arriba.
									</Box>
								) : (
									userMedia
										.filter((m) => !m.isVideo)
										.map((item) => (
											<Box
												key={item.path}
												onClick={async () => { await applyImage(item.path); }}
												style={{
													width: 72,
													height: 72,
													borderRadius: 10,
													overflow: "hidden",
													border: "2px solid #e2e8f0",
													cursor: "pointer",
													flexShrink: 0,
												}}
												onMouseEnter={(ev) => {
													ev.currentTarget.style.borderColor = "#7c3aed";
													ev.currentTarget.style.boxShadow = "0 2px 10px rgba(124,58,237,0.25)";
												}}
												onMouseLeave={(ev) => {
													ev.currentTarget.style.borderColor = "#e2e8f0";
													ev.currentTarget.style.boxShadow = "none";
												}}
											>
												<img
													src={item.path.startsWith("http") || item.path.startsWith("/") ? item.path : `${SERVER_URL}/${item.path}`}
													alt={item.name}
													style={{ width: "100%", height: "100%", objectFit: "cover" }}
												/>
											</Box>
										))
								)}
							</Box>
						</Box>
					);
				})()}
			</DialogContent>
			<DialogActions>
				<Button onClick={() => setQuizImagePickerFor(null)}>Cerrar</Button>
			</DialogActions>
		</Dialog>

		<Dialog open={iconPickerOpen} onClose={() => setIconPickerOpen(false)} maxWidth="md" fullWidth>
			<DialogTitle>Elegir icono del botón</DialogTitle>
			<DialogContent>
				{selectedElement ? (
					<>
						<TextField size="small" fullWidth placeholder="Buscar por nombre (ej. flecha, play, candado)..." value={iconPickerSearch} onChange={(e) => setIconPickerSearch(e.target.value)}
							style={{ marginBottom: 16, marginTop: 8 }} inputProps={{ style: { fontSize: 14 } }} />
						<Box display="flex" flexWrap="wrap" style={{ gap: 8 }}>
							<Box onClick={() => { effectiveUpdateElement({ ...selectedElement, content: { ...selectedElement.content, icon: "" } }); setIconPickerOpen(false); }}
								style={{ width: 48, height: 48, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 12, borderRadius: 10, border: "1px solid #e2e8f0", background: "#f8fafc", cursor: "pointer", color: "#64748b" }}>
								Ninguno
							</Box>
							{BUTTON_ICON_LIBRARY.filter(({ id, label }) => {
								const q = iconPickerSearch.trim().toLowerCase();
								if (!q) return true;
								return label.toLowerCase().includes(q) || id.toLowerCase().includes(q);
							}).map(({ id, label, Icon }) => {
								const currentIcon = selectedElement?.content?.icon || "";
								const isSelected = currentIcon === id || (id === "arrowForward" && currentIcon === "arrowRight");
								return (
									<Tooltip key={id} title={label} placement="top">
										<Box onClick={() => { effectiveUpdateElement({ ...selectedElement, content: { ...selectedElement.content, icon: id } }); setIconPickerOpen(false); }}
											style={{ width: 48, height: 48, display: "flex", alignItems: "center", justifyContent: "center", borderRadius: 10, border: isSelected ? "2px solid #7c3aed" : "1px solid #e2e8f0", background: isSelected ? "#f5f3ff" : "#fff", cursor: "pointer", color: "#334155" }}>
											<Icon style={{ fontSize: 24 }} />
										</Box>
									</Tooltip>
								);
							})}
						</Box>
					</>
				) : (
					<Box py={2} color="#64748b">No hay ningún botón seleccionado.</Box>
				)}
			</DialogContent>
			<DialogActions>
				<Button onClick={() => setIconPickerOpen(false)}>Cerrar</Button>
			</DialogActions>
		</Dialog>

		<Dialog open={scenarioIconPickerIdx !== null} onClose={() => setScenarioIconPickerIdx(null)} maxWidth="md" fullWidth>
			<DialogTitle>Elegir icono de la etapa</DialogTitle>
			<DialogContent>
				<TextField size="small" fullWidth placeholder="Buscar (ej. bandera, ubicación, estrella)..." value={scenarioIconPickerSearch} onChange={(e) => setScenarioIconPickerSearch(e.target.value)}
					style={{ marginBottom: 16, marginTop: 8 }} inputProps={{ style: { fontSize: 14 } }} />
				<Box display="flex" flexWrap="wrap" style={{ gap: 8 }}>
					{BUTTON_ICON_LIBRARY.filter(({ id, label }) => {
						const q = scenarioIconPickerSearch.trim().toLowerCase();
						if (!q) return true;
						return label.toLowerCase().includes(q) || id.toLowerCase().includes(q);
					}).map(({ id, label, Icon }) => {
						const currentIcon = scenarioIconPickerIdx != null && (scenariosRaw || [])[scenarioIconPickerIdx]?.icon || "";
						const isSelected = currentIcon === id || (id === "arrowForward" && currentIcon === "arrowRight");
						return (
							<Tooltip key={id} title={label} placement="top">
								<Box
									onClick={() => {
										if (scenarioIconPickerIdx == null) return;
										setScenariosRaw((prev) => prev.map((s, i) => i === scenarioIconPickerIdx ? { ...s, icon: id } : s));
										setScenarioIconPickerIdx(null);
									}}
									style={{ width: 48, height: 48, display: "flex", alignItems: "center", justifyContent: "center", borderRadius: 10, border: isSelected ? "2px solid #7c3aed" : "1px solid #e2e8f0", background: isSelected ? "#f5f3ff" : "#fff", cursor: "pointer", color: "#334155" }}
								>
									<Icon style={{ fontSize: 24 }} />
								</Box>
							</Tooltip>
						);
					})}
				</Box>
			</DialogContent>
			<DialogActions>
				<Button onClick={() => setScenarioIconPickerIdx(null)}>Cerrar</Button>
			</DialogActions>
		</Dialog>

		<Dialog open={backgroundPickerOpen || registrationBackgroundPickerOpen} onClose={() => { setBackgroundPickerOpen(false); setRegistrationBackgroundPickerOpen(false); }} maxWidth="sm" fullWidth>
			<DialogTitle>{registrationBackgroundPickerOpen ? "Imagen de fondo (registro)" : "Elegir imagen de fondo"}</DialogTitle>
			<DialogContent>
				<Box display="flex" flexWrap="wrap" style={{ gap: 12, marginTop: 8 }}>
					<Box onClick={() => (registrationBackgroundPickerOpen ? registrationBackgroundFileInputRef.current : backgroundFileInputRef.current)?.click()} display="flex" flexDirection="column" alignItems="center" justifyContent="center"
						style={{ width: 88, height: 88, borderRadius: 12, border: "2px dashed #cbd5e1", background: "#f8fafc", cursor: "pointer" }}>
						<CloudUploadIcon style={{ fontSize: 32, color: "#94a3b8" }} />
						<Box fontSize={11} color="#64748b" mt={0.5}>Subir</Box>
					</Box>
					{userMediaLoading ? (
						<Box p={3} color="#94a3b8" fontSize={13}>Cargando...</Box>
					) : (
						userMedia.filter((m) => !m.isVideo).map((item) => {
							const isReg = !!registrationBackgroundPickerOpen;
							const selected = isReg ? (currentPage?.registrationDesign?.backgroundImageUrl === item.path) : (currentPage?.backgroundImageUrl === item.path);
							const onSelect = isReg ? () => handleSelectRegistrationBackground(item.path) : () => handleSelectBackgroundImage(item.path);
							return (
								<Box key={item.path} onClick={onSelect}
									style={{ width: 88, height: 88, borderRadius: 12, overflow: "hidden", border: "2px solid #e2e8f0", cursor: "pointer", background: selected ? "#7c3aed" : "#f1f5f9" }}>
									<img src={resolveEscapeRoomMediaUrl(item.path)} alt={item.name} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
								</Box>
							);
						})
					)}
				</Box>
			</DialogContent>
			<DialogActions>
				<Button onClick={() => { setBackgroundPickerOpen(false); setRegistrationBackgroundPickerOpen(false); }}>Cancelar</Button>
			</DialogActions>
		</Dialog>

		<Dialog open={logoPickerOpen} onClose={() => setLogoPickerOpen(false)} maxWidth="sm" fullWidth>
			<DialogTitle>Elegir logo</DialogTitle>
			<DialogContent>
				<input ref={logoFileInputRef} type="file" accept="image/*" style={{ display: "none" }} onChange={handleUploadAndSelectLogo} />
				<Box display="flex" flexWrap="wrap" style={{ gap: 12 }}>
					<Box onClick={() => logoFileInputRef.current?.click()} display="flex" flexDirection="column" alignItems="center" justifyContent="center"
						style={{ width: 88, height: 88, borderRadius: 12, border: "2px dashed #cbd5e1", background: "#f8fafc", cursor: "pointer" }}>
						<CloudUploadIcon style={{ fontSize: 32, color: "#94a3b8" }} />
						<Box fontSize={11} color="#64748b" mt={0.5}>Subir</Box>
					</Box>
					{userMediaLoading ? (
						<Box p={3} color="#94a3b8" fontSize={13}>Cargando...</Box>
					) : (
						userMedia.filter((m) => !m.isVideo).map((item) => (
							<Box key={item.path} onClick={() => handleSelectLogo(item.path)}
								style={{ width: 88, height: 88, borderRadius: 12, overflow: "hidden", border: "2px solid #e2e8f0", cursor: "pointer", background: currentPage?.registrationDesign?.logoUrl === item.path ? "#7c3aed" : "#f1f5f9" }}>
								<img src={resolveEscapeRoomMediaUrl(item.path)} alt={item.name} style={{ width: "100%", height: "100%", objectFit: "contain" }} />
							</Box>
						))
					)}
				</Box>
			</DialogContent>
			<DialogActions>
				<Button onClick={() => setLogoPickerOpen(false)}>Cancelar</Button>
			</DialogActions>
		</Dialog>

		<Dialog open={addPageTemplateDialogOpen} onClose={() => setAddPageTemplateDialogOpen(false)} maxWidth="sm" fullWidth>
			<DialogTitle>Elegir plantilla para la nueva página</DialogTitle>
			<DialogContent>
				<Box
					component="button"
					type="button"
					onClick={addScenario}
					width="100%"
					display="flex"
					alignItems="center"
					justifyContent="center"
					mb={2}
					style={{
						gap: 10,
						padding: "14px 16px",
						fontSize: 14,
						fontWeight: 600,
						color: "#334155",
						border: "1px solid #e2e8f0",
						borderRadius: 12,
						cursor: "pointer",
						fontFamily: "inherit",
						lineHeight: 1.3,
						background: "#fff",
						boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
						transition: "border-color 0.2s ease, background 0.2s ease, box-shadow 0.2s ease, color 0.2s ease",
					}}
					onMouseEnter={(e) => {
						e.currentTarget.style.borderColor = "#c4b5fd";
						e.currentTarget.style.background = "#faf5ff";
						e.currentTarget.style.boxShadow = "0 4px 14px rgba(124,58,237,0.12)";
						e.currentTarget.style.color = "#5b21b6";
					}}
					onMouseLeave={(e) => {
						e.currentTarget.style.borderColor = "#e2e8f0";
						e.currentTarget.style.background = "#fff";
						e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.06)";
						e.currentTarget.style.color = "#334155";
					}}
				>
					<ViewModuleIcon style={{ fontSize: 22, color: "#7c3aed" }} />
					Añadir escenario
				</Box>
				<Box fontSize={11} fontWeight={500} color="#94a3b8" mb={1} mt={1}>Temas</Box>
				<Box display="flex" flexWrap="wrap" style={{ gap: 10 }} mb={2} alignItems="center">
					{ADD_PAGE_DIALOG_TEMAS.map((t) => (
						<Tooltip key={t.id} title={t.label} placement="top">
							<Box
								onClick={() => setAddPageDialogTheme(t.id)}
								style={{
									width: 32,
									height: 32,
									borderRadius: "50%",
									cursor: "pointer",
									boxSizing: "border-box",
									boxShadow: addPageDialogTheme === t.id ? `0 0 0 2px #fff, 0 0 0 4px ${getPlantillaThemeRingColor(t.id)}` : "0 1px 3px rgba(0,0,0,0.12)",
									...getPlantillaThemeSwatchStyle(t.id),
								}}
							/>
						</Tooltip>
					))}
				</Box>
				{addPageDialogTheme === ADD_PAGE_BLANCO_THEME_ID ? (
					<Box display="grid" gridTemplateColumns="1fr 1fr" style={{ gap: 12 }}>
						{[
							{ key: "blank", plt: BLANK_PAGE_ADD_TEMPLATE, subtitle: "Crear página", accent: "#64748b", onClick: () => addPageFromTemplate(BLANK_PAGE_ADD_TEMPLATE) },
							{ key: "with-bg", plt: pageWithBackgroundAddTemplate, subtitle: "Crear página", accent: "#64748b", onClick: () => addPageFromTemplate(pageWithBackgroundAddTemplate) },
							...addPageDialogErPages.map((item) => ({
								key: item.key,
								plt: {
									name: item.name,
									design: {
										backgroundColor: item.page.backgroundColor ?? "#fff",
										backgroundImageUrl: item.page.backgroundImageUrl ?? "",
										backgroundImageOpacity: item.page.backgroundImageOpacity ?? 100,
										elements: item.page.elements || [],
										timerRuns: item.page.timerRuns !== false,
									},
								},
								subtitle: "Copiar esta página",
								accent: "#7c3aed",
								onClick: () => addPageFromSourcePage(item.page),
							})),
						].map(({ key, plt, subtitle, accent, onClick }) => {
							const d = plt.design || {};
							const bgUrl = d.backgroundImageUrl ? resolveEscapeRoomMediaUrl(d.backgroundImageUrl) : undefined;
							const scale = 2;
							return (
								<Box
									key={key}
									onClick={() => { onClick(); }}
									style={{ borderRadius: 12, overflow: "hidden", boxShadow: "0 2px 8px rgba(0,0,0,0.08)", border: "1px solid #e2e8f0", cursor: "pointer", transition: "all 0.2s ease", background: "#fff", display: "flex", flexDirection: "column" }}
									onMouseEnter={(e) => { e.currentTarget.style.boxShadow = `0 6px 20px ${accent}33`; e.currentTarget.style.borderColor = accent; e.currentTarget.style.transform = "translateY(-2px)"; }}
									onMouseLeave={(e) => { e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.08)"; e.currentTarget.style.borderColor = "#e2e8f0"; e.currentTarget.style.transform = "none"; }}
								>
									<Box style={{ display: "flex", justifyContent: "center", alignItems: "center", padding: 6, background: "#f8fafc", minHeight: 180, overflow: "hidden" }}>
										<Box style={{ transform: `scale(${scale})`, transformOrigin: "center center" }}>
											<PagePreviewThumbnail
												elements={d.elements || []}
												isRegistration={false}
												backgroundColor={d.backgroundColor || "#fff"}
												backgroundImageUrl={bgUrl}
												backgroundImageOpacity={d.backgroundImageOpacity}
												quizzes={quizzes}
											/>
										</Box>
									</Box>
									<Box px={0.75} py={0.5}>
										<Box fontSize={10} fontWeight={600} color="#1e293b" sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{plt.name}</Box>
										<Box fontSize={9} style={{ color: accent }} fontWeight={500}>{subtitle}</Box>
									</Box>
								</Box>
							);
						})}
					</Box>
				) : addPageDialogTheme === "azul" ? (
					azulPlantillasLoading ? (
						<Box p={3} textAlign="center" color="#94a3b8" fontSize={13}>Cargando plantillas azul...</Box>
					) : (
					<Box display="grid" gridTemplateColumns="1fr 1fr" style={{ gap: 12 }}>
						{azulPlantillas.map((plt) => {
							const d = plt.design || {};
							const bgUrl = d.backgroundImageUrl ? resolveEscapeRoomMediaUrl(d.backgroundImageUrl) : undefined;
							const scale = 2;
							return (
								<Box key={plt.name} onClick={() => { addPageFromTemplate(plt); setAddPageTemplateDialogOpen(false); }}
									style={{ borderRadius: 12, overflow: "hidden", boxShadow: "0 2px 8px rgba(0,0,0,0.08)", border: "1px solid #e2e8f0", cursor: "pointer", transition: "all 0.2s ease", background: "#fff", display: "flex", flexDirection: "column" }}
									onMouseEnter={(e) => { e.currentTarget.style.boxShadow = "0 6px 20px rgba(59,130,246,0.25)"; e.currentTarget.style.borderColor = "#3b82f6"; e.currentTarget.style.transform = "translateY(-2px)"; }}
									onMouseLeave={(e) => { e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.08)"; e.currentTarget.style.borderColor = "#e2e8f0"; e.currentTarget.style.transform = "none"; }}>
									<Box style={{ display: "flex", justifyContent: "center", alignItems: "center", padding: 6, background: "#f8fafc", minHeight: 180, overflow: "hidden" }}>
										<Box style={{ transform: `scale(${scale})`, transformOrigin: "center center" }}>
											<PagePreviewThumbnail
												elements={d.elements || []}
												isRegistration={false}
												backgroundColor={d.backgroundColor || "#fff"}
												backgroundImageUrl={bgUrl}
												backgroundImageOpacity={d.backgroundImageOpacity}
												quizzes={quizzes}
											/>
										</Box>
									</Box>
									<Box px={0.75} py={0.5}>
										<Box fontSize={10} fontWeight={600} color="#1e293b" sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{plt.name}</Box>
										<Box fontSize={9} color="#3b82f6" fontWeight={500}>Crear página</Box>
									</Box>
								</Box>
							);
						})}
					</Box>
					)
				) : addPageDialogTheme === "caso-medico" ? (
					casoMedicoPlantillasLoading ? (
						<Box p={3} textAlign="center" color="#94a3b8" fontSize={13}>Cargando plantillas Caso Médico...</Box>
					) : casoMedicoPlantillas.length === 0 ? (
						<Box p={3} textAlign="center" color="#94a3b8" fontSize={13}>No hay plantillas disponibles para Caso Médico.</Box>
					) : (
					<>
					<Box fontSize={11} color="#64748b" mb={1}>Páginas encontradas: {casoMedicoPlantillas.length}</Box>
					<Box display="grid" gridTemplateColumns="1fr 1fr" style={{ gap: 12 }}>
						{casoMedicoPlantillas.map((plt) => {
							const d = plt.design || {};
							const bgUrl = d.backgroundImageUrl ? resolveEscapeRoomMediaUrl(d.backgroundImageUrl) : undefined;
							const scale = 2;
							return (
								<Box key={plt.name} onClick={() => { addPageFromTemplate(plt); setAddPageTemplateDialogOpen(false); }}
									style={{ borderRadius: 12, overflow: "hidden", boxShadow: "0 2px 8px rgba(0,0,0,0.08)", border: "1px solid #e2e8f0", cursor: "pointer", transition: "all 0.2s ease", background: "#fff", display: "flex", flexDirection: "column" }}
									onMouseEnter={(e) => { e.currentTarget.style.boxShadow = "0 6px 20px rgba(15,76,92,0.25)"; e.currentTarget.style.borderColor = "#0f4c5c"; e.currentTarget.style.transform = "translateY(-2px)"; }}
									onMouseLeave={(e) => { e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.08)"; e.currentTarget.style.borderColor = "#e2e8f0"; e.currentTarget.style.transform = "none"; }}>
									<Box style={{ display: "flex", justifyContent: "center", alignItems: "center", padding: 6, background: "#f8fafc", minHeight: 180, overflow: "hidden" }}>
										<Box style={{ transform: `scale(${scale})`, transformOrigin: "center center" }}>
											<PagePreviewThumbnail
												elements={d.elements || []}
												isRegistration={false}
												backgroundColor={d.backgroundColor || "#fff"}
												backgroundImageUrl={bgUrl}
												backgroundImageOpacity={d.backgroundImageOpacity}
												quizzes={quizzes}
											/>
										</Box>
									</Box>
									<Box px={0.75} py={0.5}>
										<Box fontSize={10} fontWeight={600} color="#1e293b" sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{plt.name}</Box>
										<Box fontSize={9} color="#0f4c5c" fontWeight={500}>Crear página</Box>
									</Box>
								</Box>
							);
						})}
					</Box>
					</>
					)
				) : plantillasLoading ? (
					<Box p={3} textAlign="center" color="#94a3b8" fontSize={13}>Cargando plantillas...</Box>
				) : plantillas.length === 0 ? (
					<Box p={3} textAlign="center" color="#94a3b8" fontSize={13}>No hay plantillas disponibles.</Box>
				) : (
					<Box display="grid" gridTemplateColumns="1fr 1fr" style={{ gap: 12 }}>
						{plantillas.map((plt) => {
							const d = plt.design || {};
							const bgUrl = d.backgroundImageUrl ? resolveEscapeRoomMediaUrl(d.backgroundImageUrl) : undefined;
							const scale = 2;
							return (
								<Box key={plt._id || plt.name} onClick={() => { addPageFromTemplate(plt); setAddPageTemplateDialogOpen(false); }}
									style={{ borderRadius: 12, overflow: "hidden", boxShadow: "0 2px 8px rgba(0,0,0,0.08)", border: "1px solid #e2e8f0", cursor: "pointer", transition: "all 0.2s ease", background: "#fff", display: "flex", flexDirection: "column" }}
									onMouseEnter={(e) => { e.currentTarget.style.boxShadow = "0 6px 20px rgba(124,58,237,0.2)"; e.currentTarget.style.borderColor = "#7c3aed"; e.currentTarget.style.transform = "translateY(-2px)"; }}
									onMouseLeave={(e) => { e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.08)"; e.currentTarget.style.borderColor = "#e2e8f0"; e.currentTarget.style.transform = "none"; }}>
									<Box style={{ display: "flex", justifyContent: "center", alignItems: "center", padding: 6, background: "#f8fafc", minHeight: 180, overflow: "hidden" }}>
										<Box style={{ transform: `scale(${scale})`, transformOrigin: "center center" }}>
											<PagePreviewThumbnail
												elements={d.elements || []}
												isRegistration={false}
												backgroundColor={d.backgroundColor || "#fff"}
												backgroundImageUrl={bgUrl}
												backgroundImageOpacity={d.backgroundImageOpacity}
												quizzes={quizzes}
											/>
										</Box>
									</Box>
									<Box px={0.75} py={0.5}>
										<Box fontSize={10} fontWeight={600} color="#1e293b" sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{plt.name}</Box>
										<Box fontSize={9} color="#7c3aed" fontWeight={500}>Crear página</Box>
									</Box>
								</Box>
							);
						})}
					</Box>
				)}
			</DialogContent>
			<DialogActions>
				<Button onClick={() => setAddPageTemplateDialogOpen(false)}>Cancelar</Button>
			</DialogActions>
		</Dialog>
		<Dialog open={fontManagerOpen} onClose={() => setFontManagerOpen(false)} maxWidth="sm" fullWidth>
			<DialogTitle>Fuentes</DialogTitle>
			<DialogContent dividers style={{ background: "#f8fafc" }}>
				<Box mb={1.25} fontSize={12} color="#64748b">
					Selecciona una fuente para aplicarla al elemento actual.
				</Box>
				<Box display="grid" gridTemplateColumns="1fr 1fr" style={{ gap: 10, marginBottom: 14 }}>
					{allFontOptions.map((f) => (
						<Box
							key={f}
							onClick={() => {
								applyFontToTarget(f);
								setFontManagerOpen(false);
							}}
							style={{
								cursor: "pointer",
								padding: "10px 12px",
								borderRadius: 10,
								border: "1px solid #e2e8f0",
								background: "#fff",
								fontFamily: f,
								fontSize: 14,
								color: "#334155",
							}}
						>
							{fontLabel(f)}
						</Box>
					))}
				</Box>
				<GoogleFontsSearchPicker
					onUseFont={handleUseGoogleFontFromSearch}
					isFontAlreadyAdded={isGoogleFontAlreadyAdded}
				/>
				{importedFontOptions.length > 0 && (
					<Box mt={1.5} p={1.5} borderRadius={10} style={{ border: "1px solid #e2e8f0", background: "#fff" }}>
						<Box fontSize={11} fontWeight={600} color="#64748b" mb={0.75}>Tus fuentes añadidas</Box>
						<Box display="flex" flexWrap="wrap" style={{ gap: 6 }}>
							{importedFontOptions.map((f) => (
								<Box
									key={f}
									display="flex"
									alignItems="center"
									style={{
										gap: 4,
										padding: "4px 8px",
										borderRadius: 8,
										border: "1px solid #e2e8f0",
										background: "#f8fafc",
										fontFamily: f,
										fontSize: 12,
									}}
								>
									<span>{fontLabel(f)}</span>
									<IconButton
										size="small"
										style={{ padding: 2 }}
										onClick={() => {
											setCustomFontsRaw((prev) =>
												prev.filter((entry) => {
													const s = String(entry || "").trim();
													if (s === f) return false;
													if (isFontStylesheetUrl(s) && parseGoogleFontsFamilies(s).includes(f)) return false;
													return true;
												})
											);
										}}
									>
										<DeleteIcon style={{ fontSize: 16, color: "#94a3b8" }} />
									</IconButton>
								</Box>
							))}
						</Box>
					</Box>
				)}
				<Box mt={1.25}>
					<Button
						size="small"
						onClick={() => setFontLinkImportOpen((v) => !v)}
						startIcon={fontLinkImportOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
						style={{ textTransform: "none", color: "#64748b", fontSize: 12 }}
					>
						{fontLinkImportOpen ? "Ocultar pegar enlace" : "Pegar enlace de Google Fonts (avanzado)"}
					</Button>
					{fontLinkImportOpen && (
						<Box mt={1} p={1.5} borderRadius={10} style={{ border: "1px solid #e2e8f0", background: "#fff" }}>
							<Box display="flex" style={{ gap: 8, alignItems: "flex-start" }}>
								<TextField
									size="small"
									variant="outlined"
									fullWidth
									label="Enlace de Google Fonts"
									placeholder="https://fonts.googleapis.com/css2?family=Roboto&display=swap"
									value={fontImportInputRaw}
									onChange={(e) => {
										setFontImportInputRaw(e.target.value);
										if (fontImportError) setFontImportError("");
									}}
									onKeyDown={(e) => {
										if (e.key === "Enter") {
											e.preventDefault();
											handleImportGoogleFont();
										}
									}}
									error={!!fontImportError}
									helperText={fontImportError || "Opcional: pega la URL del CSS si ya la tienes."}
								/>
								<Button
									variant="outlined"
									color="primary"
									onClick={handleImportGoogleFont}
									style={{ textTransform: "none", whiteSpace: "nowrap", marginTop: 2 }}
								>
									Añadir
								</Button>
							</Box>
						</Box>
					)}
				</Box>
			</DialogContent>
			<DialogActions>
				<Button onClick={() => setFontManagerOpen(false)}>Cerrar</Button>
			</DialogActions>
		</Dialog>

		</>
		)}
	</>
	);
}